import { ELanguages } from "src/app/core/enums/Languages.enum";

export const locale = {
  lang: ELanguages.RU,
  data: {
    LANG_TAB: {
      UZ: "Oʻzbekcha",
      UZ_CYRL: "Ўзбекча",
      RU: "Русский",
    },
    PAGE: "Страница",
    TEST_MODE: "Система работает в тестовом режиме!",
    ALL: "Все",
    NEW_VERSION_AVAILABLE: "Доступна новая версия системы",
    REFRESH: "Обновить",
    LAYOUT: {
      SHOW_SIDEBAR: "Большое боковое меню",
      SMALL_SIDEBAR: "Маленькое боковое меню",
      DROPDOWN_NAVBAR: "Меню по умолчанию",
      MEGA_NAVBAR: "Большое меню",
    },
    AUDIT_LOG: {
      IS_BUDGET_ORG: "Бюджетная организация",
      END_AT: "Завершено",
      COURT_WARNING_ENTITY: {
        PREFIX: "Состояние судебного",
      },
      ORGANIZATION_ENTITY: {
        PREFIX: "Предприятия",
      },
      MAHALLA_ENTITY: {
        PREFIX: "Окрестности",
        PUBLIC_OFFER_FILE_ID: "Файл публичной оферты",
        ADDED_INSPECTOR: "Новый инспектор прикреплен к району",
      },
      USER_ENTITY: {
        PREFIX: "Пользователь с",
        CHANGE_IMAGE: "Изображение пользователя изменено",
        CHANGE_PASSWORD: "Пароль пользователя изменен",
        CHANGE_PASSPORT: "Изменена серия паспортов пользователя",
        CHANGE_DISTRICT: "Изменен район / город пользователя",
        CHANGE_REGION: "Изменен регион пользователя",
        CHANGE_PHONE: "Изменен номер телефона пользователя",
        CHANGE_EMAIL: "Изменен адрес электронной почты пользователя",
        ADDRESS: "Адрес",
        TABLE_NUMBER: "Номер таблицы",
        ATTACHED_HOME: "Новый дом прикреплен к пользователю",
      },
      NORM_ENTITY: {
        PREFIX: "Юридический",
      },
      ACT_PACK_ENTITY: {
        PREFIX: "Пачка актов",
      },
      AUTOMOBILE_ENTITY: {
        PREFIX: "Transport vositasini",
      },
      TARIFF_ENTITY: {
        PREFIX: "Tarifni",
      },
      COMPANY_ENTITY: {
        PREFIX: "Korxonani",
      },
      EMPLOYEE_ENTITY: {
        PREFIX: "Xodimni",
      },

      OLD_AUDITS_INFO: {
        CHANGE_INFO: "Изменение данных",
        FIELD: "Поле",
        OLD_VALUE: "Старое значение",
        NEW_VALUE: "Новое значение",
      },
    },
    RESIDENT_AUDIT_LOG: {
      STATUS: "Состояние",
      ACTIVE: "Активный",
      IN_ACTIVE: "Неактивный",
      FROM: "От",
      TO: "до",
      CHANGED: "изменено",

      INDIVIDUAL_RESIDENT: {
        PREFIX: "Физический абонент",
        ELECTRICITY_COATO: "Электричество COATO",
        CITIZEN: "Изменены паспортные данные абонент",
        MAHALLA: "Район абанент преобразован",
        STREET: "Улица абанента переименована",
        IDENTIFIED: "Идентифицированный",
        IDENTIFIED_DATE: "Идентифицированная дата",
        ELECTRICITY_ACCOUNT_NUMBER: "Счет за электроэнергию",
        LAST_PAYMENT_DATE: "Дата последнего платежа",
        LAST_PAYMENT_AMOUNT: "Сумма последнего платежа",
        LAST_PAYMENT_TYPE: "Тип последнего платежа",
        CONTRACT_DATE: "Дата договора",
        DESCRIPTION: "Описание",
        BALANCE: "Баланс",
      },
      ACT: {
        PREFIX: "Акт подписчика",
        OLD_INHABITANT_COUNT: "Количество предыдущих жителей",
        NEW: "Новый",
        CONFIRMED: "Подтвержденный",
        CANCELED_AT: "Дата отмены",
        CANCELED_BY: "Пользователь, который отменил",
        CANCELLATION_CONCLUSION: "Заключение об отмене",
      },
    },
    MAIN_COMPANY: {
      TITLE: "Данные компании",
      ENABLE_OR_DISABLE_INTEGRATION: "Включить или отключить интеграцию",
      COMPANY_NOT_ENOUGH_DATA_TITLE:
        "Сведения о махаллях в желтой строке неполные!",
      EDIT_INTEGRATION: "Редактировать интеграцию",
      ATTACH_AUTO_TO_COMPANY: "Добавить автотехнику",
      CONTRACT_END_DATE_WARNING: "До конца контракта осталось 1 месяц",
      CONTRACT_END_DATE_WARNING_LESS_MORE_THAN_MONTH:
        "До окончания контракта осталось менее месяца",
      CONTRACT_END_DATE_WARNING_ROW:
        "До окончания контракта компании в желтой строке остался 1 месяц",
      TABS: {
        STATISTICS: "Статистика",
        VILLAGES: "Махалли",
        EMPLOYEES: "Сотрудники",
        SETTINGS: "Настройки",
        COMPANY_CONTRACTS: "Контракты",
        COMPANY_SHARED_AUTO: "Совместно используемая техника",
        COVERAGE: "Зона обслуживания",
        PUBLIC_CONTRACTS: "Публичные договоры",
        COMPANY_AUTO: "Техники",
        VISIT_GRAPH_FILE: "Файлы графиков",
        COMPANY_AUTO_WORK_GRAPHIC: "График работы техник",
      },
      COMPANY_COVERAGE: {
        CONFIRMATION_MODAL: {
          TITLE: "Отправка SMS",
          MESSAGE:
            "Вы действительно хотите отправить предупреждающее SMS абонентам махалли, у которых изменилась организация?",
        },
        PUBLIC_CONTRACT_UPLOAD: "Загрузка файла публичного договора",
        PUBLIC_CONTRACT_DELETE: "Удаление файла публичного договора",
        PUBLIC_CONTRACT_DELETE_MESSAGE:
          "Вы действительно хотите удалить файл публичного договора?",
        VIEW_PUBLIC_CONTRACTS: "Просмотр публичных договоров",
        DATE_ATTACH_CONTRACT: "Дата последнего прикрепленного договора",
        NEW_MAHALLA_CONTRACT_START_DATE: "Дата начала нового договора",
      },
      APPX_CHART1: {
        ECO_PAY_INVENTORY: "EcoPay инвентаризация",
        INVENTORY: "Инвентаризация",
        FROZEN: "Замороженный",
        SIMPLE: "Простой",
        SERVICE_NOT_PROVIDED: "Не обслуживается",
        SPECIAL: "Специальный",
        OTHERS: "Другие",
        NO_ACT_DATA: "Актов по данному периоду нет",
        NO_INCOME_DATA: "Нет поступлений за этот период",
        NO_ALL_APPEALS_DATA: "Нет всех ссылок на этот период",
        NO_COURT_ACTION_DATA: "Никаких судебных исков за этот период",
      },
      APPX_CHART2: {
        QUEUE: "В очереди",
        LEARNING: "Обучение",
        DONE: "Выполнено",

        CANCELED: "Отменено",
        CREATED: "Создано",
        ACCEPTED: "Принято",
        COMPLETED: "Завершено",
        CANCELLED: "Отменено",
        SYSTEM_CANCELLED: "Система отменила",
      },
      APPX_CHART3: {
        NEW: "Новый",
        ALERTED: "Предупрежден",
        DOCUMENT_FORMALIZED: "Оформлено",
        MIB_EXECUTION: "Исполнение МИБ",
        SENT: "Отправлено",
        THE_DECISION_CAME_OUT: "Решение вышло",
        DEBT_COVERED: "Долг погашен",
        CANCELLED: "Отменено",
        WARNED: "Предупрежден",
        DOCUMENT_PREPARATION: "Подготовка документов",
        DOCUMENTS_SENT: "Документы отправлены",
        COURT_DECISION: "Решение суда",
        DEBT_PAID: "Долг оплачен",
      },
      COMPANY_SETTING_TYPES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          SHORT_NAME: "Короткое наименование",
          ACTION: "Действие",
        },
        ADD_EDIT_MODAL: {
          SHORT_NAME: "Короткое наименование:",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить тип настройки",
          EDIT_MODAL_TITLE: "Изменить тип настройки",
          DELETE_MODAL_TITLE: "Отключить тип настройки",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить этот тип настроек из системы?",
        },
      },
      COMPANY_AUTO_WORK_GRAPHIC: {
        COMPANY_AUTO_NUMBER: "Номер автомобиля",
        COMPANY_AUTO_REST_DAY: "Выходной день",
        COMPANY_AUTO_PIN_MAHALLA: "Прикрепить махалли",
        COMPANY_AUTO_PIN_AUTO: "Прикрепить автомобиля",
        COMPANY_AUTO_EDIT_MAHALLA: "Редактировать",
        COMPANY_AUTO_MAHALLA_NAME: "Наименования махалли",
        NO_DATA: "График работы техник отсутствует!",
        COMPANY_AUTO_MAHALLA_SECTION: "В разрезе махалли",
        COMPANY_AUTO_AUTOS_SECTION: "В разрезе техники",
        SELECT_COMPANY: "Выберите компанию",
        SELECT_COMPANY_NOT_FOUND: "Компания не найдена",
        SEE_ALL: "Посмотреть все",
        VISIT_GRAPH_FILE: "Файл графиков",
        VISIT_GRAPH_CANCEL: "Отменить график визита",
        VISIT_GRAPH_APPROVE: "Подтвердить график визита",
        CHANGE_GRAPHIC_WARNING:
          " Подтверждённый график изменить невозможно, для внесения изменений свяжитесь с сотрудниками центра. !",
        WARNING: "Предупреждение",
      },
      COMPANY_AUTO: {
        TABLE_HEADERS: {
          ID: "ID",
          AUTOMOBILE_NUMBER: "Номер автотехники",
          AUTOMOBILE_TYPE: "Типы автотехники",
          COMPANY_NAME: "Название компании",
          GPS_SYSTEM_NAME: "Название GPS",
          MODEL: "Модель",
        },
      },
      COMPANY_SHARED_AUTO: {
        TABS: {
          SHARED_AUTO_TAB: "Предоставлено компанией",
          SHARED_BY_TAB: "Принято компанией",
        },
        TABLE: {
          COMPANY_AUTO_NUMBER: "Номер автомобиля",
          SHARED_BY_COMPANY: "Название совместной компании",
          COMPANY_NAME: "Название компании",
        },
        TABLE_HEADERS: {
          COMPANY_AUTO_NUMBER: "Номер автомобиля",
          SHARED_BY_COMPANY: "Название компании, поделившейся",
          COMPANY_NAME: "Название принимающей компании",
        },

        MODAL: {
          DELETE_MODAL: "Удаление подключённой техники",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить данную технику?",
        },
        FORM: {
          COMPANY_AUTO_SHARED_TO_TITLE:
            "Выберите компанию для подключения техники",
          REGION: "Регион",
          DISTRICT: "Район / Город",
          COMPANY: "Компания",
          COMPANY_SHARED_AUTO: "Выберите технику, которую хотите подключить",
        },
      },
      COMPANY_CONTRACTS: {
        ADD_CONTRACT: "Добавить контракт",
        CONTRACT_NUMBER: "Номер контракта",
        CONTRACT_NO: "Номер контракта",
        CONTRACT_START_DATE: "Дата начала контракта",
        CONTRACT_END_DATE: "Дата окончания контракта",
        CONTRACT_FILE: "Файл контракта",
        MODAL: {
          DELETE_MODAL: "Удалить контракт",
          DELETE_MODAL_SUBTITLE: "Вы действительно хотите удалить эту сделку?",
        },
      },
      COMPANY_FILES: {
        TABLE_HEADERS: {
          ID: "ID",
          CREATED_AT: "Дата создания",
          DOCUMENT_DATE: "Дата документа",
          FILE: "Файл",
          DESCRIPTION: "Описание",
        },
        MODAL: {
          DELETE_MODAL: "Удалить файл",
          DELETE_MODAL_SUBTITLE: "Вы действительно хотите удалить этот файл?",
          EDIT_MODAL: "Изменить файл",
          ADD_MODAL: "Добавить файл",
          ADDED_FILE: "Добавленный файл",
        },
      },
      VISIT_GRAPH_FILE: {
        ADD_TITLE: "Прикрепить файл",
        EDIT_TITLE: "Редактировать график",
        FILTER: {
          MAHALLA_NAME: "Махалля",
          ACTIVE: "Активный",
          IN_ACTIVE: "Не активно",
          STATUS: "Статус",
        },
        TABLE_HEADERS: {
          MAHALLA_NAME: "Махалля",
          START_DATE: "Начало",
          END_DATE: "Конец",
          FILE: "Файл",
          ACTIONS: "Действия",
        },
        FORM: {
          ATTACH_GRAPH_FILE: "Файл графика",
          MAHALLA_NAME: "Махалля",
        },
        MODAL: {
          TITLE_DELETE: "Удаление файл графика",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить этот файл графика?",
        },
      },
    },
    MAPS: {
      LENGTH: "Длина",
      SEGMENT: "Сегмент",
      COOR: "Координаты",
      SIMPLE_OPEN: "Простой открытый",
      HYBRID: "Гибрид",
      SIMPLE: "Простой",
      NIGHT: "Ночь",
    },
    STATISTICS: {
      UNITS: {
        TA: "",
        SUM: "сум",
        PROTSENT: "%",
        ACCOUNTS: "абонентов",
      },
      BALANCE: "Баланс",
      INITIAL_BALANCE: "Начальный баланс",

      COMPANY: {
        TITLE: "Долги/Кредиторы по разделу махалля",
      },
      TOTAL_AMOUNT: "Общая сумма",
      TOTAL_QUANTITY: "Общая количество",
      BILLION: "Миллиард",
      MILLION: "Миллион",

      TITLE: "Statistika",
      MAP_TITLE: "Республика Узбекистан",
      TITLE2: "Входы инспекторов",
      TITLE3: "Виды входящих платежей (тыс. сум)",
      TITLE4: "Абоненты в разрезе областей",
      TITLE_5: "Данные",
      PIE_CHART_DATA: {
        TITLE: "Абоненты в разрезе районов",
      },
      STATISTICS_DATA: {
        RESIDENTS: "Количество абонентов",
        DEBTORS: "Количество абонентов-должников",
        TOTAL_DEBT: "Общая задолженность",
        ENTITLEMENT: "Количество абонентов-кредиторов",
        REVENUE: "Сборы",
        APPEALS: "Обращения",
        COURT_PROCEEDINGS: "Судебные процессы",
        ACTS: "Акты",
      },
      INCOME_BY_REGION: "Поступления в разрезе территорий",
      INCOME_BY_CHANNEL: "Поступления в поперечном сечении каналов",
      DEBIT_BY_REGION: "Долг / кредитор в разрезе территорий",
      DEBIT_DYNAMICS: "Динамика задолженность",
      CASH_DYNAMICS: "Динамика доходов",
      DAY: "День",
      WEEK: "Неделя",
      MONTH: "Месяц",
      YEAR: "Год",
      DEBIT: "Долги",
      INCOMEE: "Доход",
      RESIDENT_COUNT: "Количество абонентов",
      MAHALLAS_COUNT: "Количество махаллей",
      FROZEN_MAHALLAS_COUNT: "Количество замороженных махаллей",
      FROZEN_START_DATE: "Дата начала заморозки",
      EMPLOYEES_COUNT: "Количество сотрудников",
      CREDIT: "Кредитор",
      SUM: "сум",
      MUNIS: "Мунис",
      ELECTRONIC_PAYMENTS: "Электронные платежи",
      MOBILE: "Мобильный",
      WEB: "Веб",
      PAYMENTS_1031: "Платежи БПИ и 1031",
      INCOME: "Доходы",

      // Regions
      ANDIJON: "Андижан",
      BUKHARA: "Бухара",
      FERGANA: "Фергана",
      JIZZAKH: "Джиззак",
      KHOREZM: "Хорезм",
      NAMANGAN: "Наманган",
      NAVOI: "Навои",
      KASHKADARYA: "Кашкадарья",
      SAMARKAND: "Самарканд",
      SURKHANDARYA: "Сурхандарья",
      TASHKENT: "Ташкент",
      TASHKENT_CITY: "Ташкент город",

      // Months
      JANUARY: "Январь",
      FEBRUARY: "Февраль",
      MARCH: "Март",
      APRIL: "Апрель",
      MAY: "Май",
      JUNE: "Июнь",
      JULY: "Июль",
      AUGUST: "Август",
      SEPTEMBER: "Сентябрь",
      OCTOBER: "Октябрь",
      NOVEMBER: "Ноябрь",
      DECEMBER: "Декабрь",
    },
    CALCULATOR: {
      CALCULATOR: "Калькулятор",
      CURRENT_TARIFF: "Текущий тариф",
      INHABITANT_CNT: "Количество жителей",
      AS_OF_THE_CURRENT_PERIOD: "Задолженность по состоянию на текущий период",
      AS_OF_THE_CURRENT_PERIOD1: "Переплата по состоянию на текущий период",
      IT_WAS_UNTIL_THE_SELECT_PERIOD: "Задолженность до выбранного периода",
      IT_WAS_UNTIL_THE_SELECT_PERIOD1: "Переплата до выбранного периода",
    },
    PINNED: {
      BUTTON: "Переход на карту",
      BUTTON1: "Перерасчет",
      BUTTON2: "Разрешения",
      BUTTON3: "Переход на пачку",
      BUTTON4: "Переход к разделам",
      BUTTON5: "Переход к сотрудникам",
      BUTTON6: "Переход на сборы",
      BLOCK: "Блокировка",
      WRITE_ANSWER: "Написать ответ",
      OLD: "Старый",
      CORRECTED: "Исправленный",
      TRUE: "Активный",
      FALSE: "Неактивный",
      YES: "Да",
      NO: "Нет",
      BACK: "Назад",
      SUM: "сум",
      SPEED: "Скорость (км/ч)",
      NEW: "Новый",
      DIFFERENCE: "Разница",
      CONFIRMED: "Подтвержденный",
      PAYED: "Оплаченный",
      CANCELED: "Отмененный",
      CONFIRMED_CANCELED: "Подтвержденный и отмененный",
      OLD_ACTS: "Старый акт",
      WARNED: "Предупрежденный",
      WARN: "Предупредит",
      DEFECT_CORRECTED: "Дефект исправлен",
      WARN_CORRECTED: "Предупреждение исправлено",
      CREDIT: "Kpeдитoвый",
      DEBIT: "Дебетовый",
      CREDITOR: "Кредитор",
      DEBTOR: "Дебитор",
      APPROVED: "Получение",
      WARNED_CANCELLED: "Предупрежден и отменен",
      SELECT_ALL: "Выбрать все",
      UN_SELECT_ALL: "Отменить все",
      OPERATIONS: "История платежей",
      CREATE: "Создано",
      UPDATE: "Обновлено",
      DELETE: "Удалено",
      WEB: "Веб",
      MOBILE: "Мобильный",
      MORE_DETAILS: "Подробнее",
      HOUR: "час",
      MINUTES: "минут",
      SECOND: "секунд",
      TIME: "время",
      SPEED_BY_X1: "Скорость 1x",
      SPEED_BY_X2: "Скорость 2x",
      SPEED_BY_X3: "Скорость 3x",
    },
    PRINT: {
      CARD: "Печать карту",
      NOTIFICATION: "Уведомление",
      CONTRACT: "Контракт",
      EV_DOC: "Инв акт",
      REFERENCE_DOC: "Справка",
    },
    WARNING_CARD: {
      WARNING_TITLE:
        "Пожалуйста, выберите вариант ниже, чтобы загрузить, как выглядит файловая структура!",
      TITLE:
        "Если вы не знаете, как выглядит файловая структура {{selectTitle}}, вы можете скачать образец файла.",
      BUTTON: "Скачать",
      NO_USER_FOUND_FOR_SUCH_PASSPORT_AND_PNFL:
        "По такому паспорту и ПИНФЛ пользователя не найдено!",
    },
    IMPORT_CARD: {
      TITLE: "Скачайте образец формы для загрузки измененных данных в систему",
      BUTTON: "Скачать",
    },
    BUTTON: {
      SAVE: "Сохранить",
      UPDATE: "Обновить",
      DELETE: "Удалить",
      DELETE_SELECTED: "Удалить выбранное",
      WARNING_CELECTED: "Предупреждение выбрано",
      SEARCH: "Поиск",
      CANCEL: "Отмена",
      CLEAN: "Очистка",
      PRINT: "Печать",
      CLOSE: "Закрыть",
      CONFIRM: "Подтвердить",
      EDIT: "Редактировать",
      LINK: "Ссылка",
      OTHER: "Другие",
      SELECT: "Выбирать",
      READ_MORE: "Читать далее",
      GPS_SETTING: "Настройки GPS",
    },
    GARBAGE_TYPE: {
      SOLID_WASTE: "Твердые бытовые отходы (сум)",
      LIQUID_WASTE: "Жидкие бытовые отходы (сум)",
      CONSTRUCTION_WASTE: "Строительные и другие отходы (сум)",
    },
    BUTTON_TITLES: {
      CLEARABLE_BUTTON_TITLE: "Очистка фильтра",
    },
    HOUSE_TYPE: {
      HOUSE: "Участка",
      APARTMENT: "Многоэтажный дом",
      NOT_INCLUDET: "Не включено",
    },
    ACTION_DROPDOWN: {
      ACTION: "Действия",
      ADD: "Добавить",
      EDIT: "Редактировать",
      DELETE: "Удалить",
      STOP: "Останавливаться",
      FINISH: "Завершить",
      MARGE_FILE: "Прикрепить файл",
      UPLOAD_FILE: "Загрузить файл",
      GET_PAYMENTS: "Платежи",
      VIEW_DETAILS: "Подробности",
      CHECK: "Подтверждать",
      ACTIVATION: "Активация",
      CONFORMATION: "Подтверждать",
      BLOCK: "Блокировать",
      UN_BLOCK: "Открытие блока",
      WARNING: "Предупреждение",
      WARNING_ACT: "Отмена предупрежденных актов",
      APPROVED: "получение",
      CANCEL: "Отменить",
      ACTION_CANCEL: "Отмена действия",
      EDIT_HOME: "Изменить участок",
      EDIT_STREET: "Изменить улица",
      EDIT_PERSON_COUNT: "Изменить количество людей",
      CANCEL_CONTRACT: "Отменить договор",
      PRIMARY_INV: "Предв.инвентаризация",
      FIND_FROM_CADASTR: "Поиск по базе кадастра",
      SEARCH_FROM_CADASTR: "Онлайн-поиск по базе данных кадастра",
      CHEKING_PERSONS_OF_HOME: "Проверить проживающих по прописке",
      SEARCH_PERSON_BY_PASSPORT:
        "Поиск абонента по ПИНФЛ и серийному номеру паспорта",
      ADD_COMPANY: "Перерасчет компании",
      TOTAL: "Итого",
      INSTALL_LIMIT: "Установить лимит",
      NEW_VERSION: "Доступна новая версия, хотите обновить?",
      CONFIRMED_CANCELLED: "Отмена утвержденного акта",
      FORMA_1_PDF: "Скачать Форма-1",
    },
    SPECIAL_ACTION_DROPDOWN: {
      ACTION: "Специальные действия",
      TITLE: "Ввод и изменение номера энергосчета абонента",
      TITLE_2: "Укажите подписчиков, которых хотите удалить",
      IMPORT: "Импорт абонентов",
      IMPORT_EDIT: "Редактировать через импорт",
      NARYAD: "Наряд",
      PAYMENT: "Абонентская плата",
      IMPORT_FIRST_INV: "Импорт первичной инвентаризации",
      IMPORT_PERIOD_SALDO: "Импорт сальдо на период",
      WARNING_RESIDENTS: "Оповещение абонентов",
      WARNING_BY_HET: "Предупреждение через РЭС",
      NO_DATA_IN_HET: "Нет данных в РЭС",
      ERROR_IN_HET: "Ошибка в РЭС",
      ADD_SUB_ACCOUNT: "Добавить субсчет",
      DELETE_SUB_ACCOUNT_TITLE: "Отделение субсчёта",
      DELETE_SUB_ACCOUNT_CONFIRM:
        "Вы действительно хотите отделить выбранного абонента от основного лицевого счёта? После выполнения операции данный абонент больше не будет считаться субсчётом.",
      ATTACHMENT_SUB_ACCOUNT: "Прикрепить субсчет",
      SEARCH_AND_SELECT_FROM_HET: "Поиск и выбор из РЭС",
      GET_DATA_FROM_HET: "Получить данные из РЭС",
      MAIN_ACCOUNT: "Основной счет",
      SUB_ACCOUNT: "Субсчет",
      ATTACH_ACCOUNT_CADASTRAL_WARNING:
        "Здесь удаляется кадастровый номер субсчета, и кадастровый номер основного счета записывается автоматически!",
      ATTACH_ACCOUNT_MAHALLA_WARNING:
        "Здесь удаляется махалля субсчета, и махалля основного счета записывается автоматически!",
      ATTACH_ACCOUNT_STREET_WARNING:
        "Здесь удаляется улица субсчета, и улица основного счета записывается автоматически!",
      MOVE_RESIDENT_FROM_TO_MAHALLA:
        "Переместить абонентов из одной махалли в другую",
      HET_BLOCK_CHECK: "Проверка блокировки HET",
    },

    ACTION_DROPDOWN_FILE: {
      FILE: "Файл",
      PRINT: "Печать",
      EXCEL: "Эксель",
    },
    TRANSLATOR: {
      SELECT: "Выберите язык",
      WAITING: "Пожалуйста, подождите...",
    },
    SELECT: {
      SELECT_COMPANY: "Выберите компанию",
      NOT_FOUND: "Не найдено",
      SELECT_DISTRICT: "Выберите район",
      MAHALLA: "Махаля",
      SUB_MAHALLA: "Суб-махалла",
      ERROR_CALCULATION_BY_MAHALLA_PAGE:
        "Этот абонент не прикреплён к территории махалли!",
    },
    DATAPICKER: {
      TITLE: "Дата",
      FROM: "От:",
      TO: "До:",
      ONE_MONTH: "Вы можете выбрать максимальный интервал в 30 дней.",
      IN_PERIOD: "Можно выбрать только в диапазоне одного периода.",
    },
    NAVBAR: {
      CURRENT_PERIOD: "Текущий период:",
    },
    FILTER: "Фильтр",
    SELECTED_RESIDENTS: "Выбранные абоненты",
    SELECTED_ACTS: "Выбранные акты",
    SELECTION_DELETE: "Выборочное удаление",
    TABLE_NO_DATA: "Нет данных",
    TYPE_TO_SEARCH: "Введите для поиска",
    VIEW: "Посмотреть {{items}} до {{items2}} из {{items3}} записей",
    STATUS: "Статус",
    LOADING: "Загрузка...",
    ACCESS_DENIED: "Доступ ограничен",
    CONFIRMATION: {
      DELETE: "Вы действительно хотите удалить этот файл?",
      CONFIRM: "Подтвердить",
      CANCEL: "Отмена",
    },
    GEO_DASHBOARD: {
      ON_DEBT: "По задолженности",
      ON_FROZEN: "По замороженности",
      NOT_FOUND_POLYGON: "{{count}} поля(е) информация не найдена.",
    },
    USER_PROFILE: {
      TITLE: "Профиль пользователя",
    },
    MENU: {
      DASHBOARD: "Статистика",
      GEO_DASHBOARD: "Гео анализ",
      LEASING: "Лизинг",
      DXSH: {
        TITLE: "ДХШ",
        INVESTITION_INFO: "Предприятия",
        CONTRACTS: "Договоры",
        DXSH_INVESTMENT: "Факт исполнения договора",
        INVESTITION_CATEGORIES: "Категории",
        DXSH_REPORT: "Отчетность",
        STATISTICS: "Статистика",
        FACT_OF_NEW_WORK_POSOTIONS: "Факт создания нового рабочего места",
        REPORTS_BY_CONTRACT: "Отчеты по договорам",
      },
      TOOLS: {
        TITLE: "Физические потребители",
        RESIDENTS: "Абонент",
        CHANGE_PHONE_NUMBER_RESIDENT_REQUEST_TITLE:
          "Запросы на изменение номера",
        IIB_SINXRONIZATSIYA: "Синхронизация МВД",
        BLOCKED_RESIDENTS: "Заблокированные абоненты",
        DELETED_RESIDENTS: "Удаленные абоненты",
        WARNING_RESIDENTS: "Предупреждение абонентов",
        LEGAL_RESIDENTS: "Юридические абоненты",
        HET_SEARCH_DATA: "Поиск данных из базы данных РЭС",
        PAYMENTS: "Электронные платежи",
        MUNIS: "Мунис",
        APPEAL: "Онлайн обращения",
        NARYAD: "Наряд",
        ALLPAYMENTS: "Платежи",
        OPERATIONS: "Операции периода",
        PLANS: "Тарифы",
        ACCRUAL: "Начисление",
        COURT: "Суд",
        COURT_WARNING: "Предупреждения суда",
        CREATE_COURT_WARNING: "Создание предупреждений суда",
        COURT_ACTION: "Судебные процессы",
        LIMITS: "Уведомление об ограничениях",
        MVD_INFO: "Информация МВД",
        KADASTR_INFO: "Кадастровые данные",
        ACTS: "Акты",
        ACT_PACK: "Пачка актов",
        ACT_FORMS: "Формы актов",
        INVENT_ACTS: "Акты инвентаризации",
        CHANGING_ACTS: "Акты об изменении количества жителей",
        FROZEN_DEBT_ACTS: "Акт замороженный долг",
        FIRST_INVENTORY_ACTS: "Акты первичной инвентаризации",
        NOTIFICATION_RESTRICTIONS: "Уведомление об ограничениях",
        CASH_PAYMENTS: "Наличные расчеты",
        ORG_EMPLOYEES: "Сотрудники компании",
        ACTIONS: "Действия",
        EMPLOYEE_ACTIONS: "Действия сотрудников",
        RESIDENT_ACTIONS: "Действия абонентов",
        USERS_SPECIAL_ACTIONS: "Специальный действия пользователей",
        RECEIPT_FORMS_COUNT: "Учет бланков квитанций",
        FREEZING: "Замораживание",
        FREEZING_MAHALLA: "Махалли",
        FROZEN_RESIDENTS: "Абоненты",
        FROZEN_STREETS: "Улицы",
        EDIT_RESIDENT_INFORMATION: "Абоненты с неверными данными",
        NON_EXISTENT_RESIDENTS_IN_SYSTEM: "Абоненты, полученные из налоговой",
        MY_GOV: "Заявления от MyGov",
        MY_GOV_APPEAL: "Заявления с существующим абонентом в системе",
        MY_GOV_APPEAL_RESIDENT_NULL: "Заявления с неизвестным абонентом",
        CADASTR_PUSH: "Изменения кадастра",
      },
      GENERAL: {
        TITLE: "Общий",
        RECEIPT_ISSUERS: "Владельцы квитанций",
      },

      SETTINGS: {
        TITLE: "Настройки",
        USER_ROLES: "Роли пользователей",
        EMPLOYEES: "Сотрудники",
        OPERATIONS: "Операции периодов орг.",
        REPORT_CURRENT_PERIOD: "Отчет по текущему периоду",
      },
      WORK1031: {
        TITLE: "Работа по положению БПИ и 1031",
        PAYMENT_LIST: "Список платежей",
        ORGANIZATION_LIST: "Список организаций",
        EMPLOYEE_LIST: "Работа со списком сотрудников организации",
        ORGANIZATION_DEPARTMENT_LIST: "Работа со списком отделов организации",
        ORGANIZATION_EMPLOYEES_TITLE: "Персонал организации",
      },
      GEOGRAPHY: {
        TITLE: "География",
        VILLAGES: "Махалли",
        MAHALLA_AREA: "Территории махалли",
        MAHALLA_AREA_BIND_RESIDENTS: "Привязать абонента к территории",
        STREETS: "Улицы",
        REGIONS: "Регионы",
        DISTRICTS: "Районы",
        POLIGON: "Полигон",
        WASTE_COLLECTION_AREA: "Зона сбора отходов",
        AREA_BRICKING_OF_LEGAL_RESIDENTS: "Юридические потребители",
        VILLAGE_CLASSIFIER: "Синхронизировать махалля",
      },
      MANAGEMENT: {
        USERS: "Пользователи",
        USERS_LIST: "Список",
        TITLE: "Общий",
        COMPANIES: "Предприятии",
        ROLES: "Роли",
        COMPANY_OPERATIONS: "Операции периодов организаций",
        REPORTING_PERIOD: "Отчетный период",
        EMPLOYEES: "Сотрудники",
        BLOCKED_USERS: "Заблокированные пользователи",
        INVESTITION_CATEGORIES: "Категории инвестиций",
        INTEGRATIONS: "Интеграции",
        SYSTEM_CONFIGURATIONS: "Системные настройки",
        PARAMETER_NAME: "Наименования параметров",
        PARAMETER_VALUE: "Значения параметров",
        BANK_OPERATIONS: "Банковские операции",
        BANK_BILLING_COMPARISON:
          "Сравнительный отчет о поступлениях по данным банка и биллинга",
        ACT_PERMISSION_BY_COMPANIES: "Управление формированием Акт",
        WORK_1031_PERMISSION_BY_ORGANIZATION:
          "Управление формированием БПИ и 1031",
        PAYMENTS_PERMISSION_BY_ORGANIZATION:
          "Управление формированием платежей",
        MUNIS_SVERKA: "Munis сверка",
        COM_GR_ADMIN: "Директор группы компаний",
        COMPANY_LOGIN: "SMS логины на предприятие",
        MY_GOV_APPEAL_REPORT: "Отчет о заявках от MyGov",
        GNK_RESIDENTS_REPORT: "Отчетность абонентов по налогам",
        HET_WARNING_MAHALLAS: "Предупреждение через HET",
      },
      COVERAGE_REPORT: {
        TITLE: "Отчет по территориям, охваченным предприятиями",
        REGION_NAME: "Название региона",
        STATISTIKA_BOYICHA_YIL_HOLATIGA: "По статистике на 01.01.2025 года",
        BILLING_TIZIMIGA_KIRITILGAN: "Введено в биллинговую систему",
        MAHALLA_COUNT: "Количество махалля",
        RESIDENT_COUNT: "Количество абонентов",
        TOTAL_INHABITANTS: "Количество населения",
        TOZA_HUDUD_DUK_QAMRAB_OLGAN: "Тоза худуд-Максустранс-ДУК охвачено",
        KLASTERLAR_QAMRAB_OLGAN: "Кластеры охвачено",
        HUSUSIY_KORXONALAR_QAMRAB_OLGAN: "Частные предприятия охвачено",
        DXSH_KORXONALAR_QAMRAB_OLGAN: "ДХШ предприятия охвачено",
        HAQIQATDA_XIZMAT_KILUVCHI_MAHALLA_PERCENT:
          "Фактически обслуживающие махалля %",
        HAQIQATDA_XIZMAT_KILUVCHI_AHOLI_PERCENT:
          "Фактически обслуживающие население %",
      },
      GNK_RESIDENTS_REPORT: {
        TITLE: "Отчетность абонентов по налогам",
        REGIONS: "Регионы",
        TOTAL_RESIDENTS: "Общее количество подписчиков",
        ALL_ATTACHED_RESIDENTS: "Общее количество подключенных абонентов",
        UNATTACHED_RESIDENTS: "Количество неподключенных абонентов",
        ATTACHED_RESIDENTS_COUNT_BY_DATE:
          "Количество прикрепленных за выбранное время",
        ATTACHED_GNK_RESIDENTS: "Абонент Ф.I.О",
        GNK_RESIDENT: "Получено из налога Ф.I.O",
        ACCOUNT_NUMBER: "Номер счета",
        DISTRICT: "Район",
        MAHALLA: "Соседство",
        HOUSE_TYPE: "Тип дома",
        PLOSHAD: "Площадь",
        ADDRESS: "Адрес",
        CADASTRAL_NUMBER: "Кадастровый номер",
        PNFL: "ПИНФЛ",
        INN: "ИНН",
      },
      COMPANY_LOGIN: {
        ADD_TITLE: "Добавление SMS - Логинов на предприятие",
        EDIT_TITLE: "Редактирование SMS-Логинов для предприятия",
        FORM_TITLE:
          "Включение или отключение sms-сообщений с этим логином для предприятия",
      },
      MY_GOV_APPEAL_REPORT: {
        TITLE: "Отчет по заявлениям, поступившим через MyGov",
        TABLE_HEADERS: {
          CREATED_COUNT: "Количество созданных",
          ACCEPTED_COUNT: "Количество принятых",
          COMPLETED_COUNT: "Количество сделанных",
          CANCELLED_COUNT: "Количество отмененных",
          TOTAL_COUNT: "Общее количество заявок",
        },
      },
      SMS_GATEWAY: {
        TITLE: "История СМС",
        PURPOSE: "Цель",
        PAYMENT: "Для оплаты",
        DEBIT: "Для задолженность",
        CONFIRM_CODE: "Код подтверждения",
      },
      REPORTS: {
        GPS_REPORT: "GPS Отчеты",
        TITLE: "Отчеты",
        GENERAL: "Все отчеты",
        REPORT1: "ОТЧЕТ ОСВ-1",
        REPORT2: " Ф-2 ОТЧЕТ ОСВ",
        REPORT3: "Список квитанций ОСВ-2",
        REPORT4: "Отчет по дебитором в разрезе махаллей",
        REPORT5: "Отчет о платежах Муниса",
        REPORT6: "Отчет по кредиторам в разрезе махаллей",
        REPORT7: "Отчет об электронный платежах",
        REPORT8: "Отчет по должникам",
        REPORT9: "Отчет об ограничениях уведомлений",
        REPORT10: "Анализ документов Хатлова",
        REPORT11: "Отчет о переписке документов",
        REPORT12:
          "Периодический отчет о деятельности по судебным разбирательствам",
        REPORT13: "Отчет о численности населения",
        REPORT14: "Отчет об онлайн-заявке",
        REPORT15: "Отчет о сеансе пользователя",
        REPORT16: "Отчет о поступлениях от государственно-частного партнерства",
        REPORT17: "Отчет о сеансе пользователя",
        REPORT18: "Абоненты с большой задолженностью",
        REPORT19: "Комплексный отчет по абонентам с высокой задолженностью",
        REPORT20: "Доходы - в разделе сотрудники",
        REPORT21: "Заполненности базы ПИНФЛ и номером кадастра",
        REPORT22: "Анализ дел судебного разбирательства",
        REPORT23: "МФА-1 Отчет ДХЖ ",
        REPORT24: "МUNIS",
        REPORT26: "МФА-2 Отчет по текущем периодам",
        REPORT27: "МФА-4 Отчет по актам",
        REPORT33: "Аналитический SMS-отчет",
        REPORT28: "МФА-16 Общий анализ доходов",
        REPORT29: "МФА-8 Отчет по SMS-уведомлениям",
        REPORT40: "Сбор по СМС",
        REPORT31: "Мониторинг зарегистрированных абонентов",
        REPORT42: "Отчет об изменении абонентов",
        REPORT38: "Ежедневные входящие абоненты в разрезе кварталов",
        REPORT39: "Отчет об идентифицированных подписчиках",
        REPORT41: "Отчет о статусе акта",
        REPORT43: "Отчет Ф-3 ДҲЖ",
        REPORT45: "Отчет о состоянии судебного процесса",
        REPORT46: "МФА-6 Отчет о временно отключенных абонентах",
        REPORT47: "Доходы - по сотрудникам",
        REPORT48: "Начисленная сумма за визит МСП для абонентов",
        REPORT49: "Аналитический отчет о погашении дебиторской задолженности",
        REPORT50: "Отчёт по типам актов",
        DUPLICATE_CADASTRAL: "Дублирующиеся кадастровые номера",
        REPORT_GPS_VISIT_CONTROL:
          "Зона сбора отходов GPS и количество абонентов, прикрепленных к махалля",
        ELECTRICITY: "Отчет о сравнении электроэнергии",
        REPORT_CREDITORS: "Отчет по кредиторам в разрезе махаллей",
        REPORT_RESIDENTS_DEBT: "Абоненты с большой задолженностью",
        RESIDENTS_WITH_HIGH_INDEBTEDNESS_REPORT:
          "Сводный отчет по абонентам с высокой задолженностью",
        REPORT_ANALYTICAL_SMS: "Аналитический смс-отчет",
        REPORT_GPS_WORKING_TIME:
          "Запуск специальной техники для утилизации отходов",
        INPUT_OUTPUT: "Время въезда-выезда техники в регионы",
        HET_BLOCK_USERS: "Заблокированные пользователи из РЭС",
        HET_WARNING_USERS: "Предупрежденные пользователи из РЭС",
        HET_WARNING_POSSIBLE_USERS:
          "Предупрежденные возможные пользователи из РЭС",
        RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT_TITLE:
          "Отчёт об абонентах с аннулированной идентификацией",
        RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT_CANCELED_RESIDENTS_TITLE:
          "Абоненты с аннулированной идентификацией",
        GPS_ACCRUALS_REPORT:
          "Отчёт по расчёту платежей, введённых через систему GPS, по территориям",
        FEED_BACK_REPORT_TITLE:
          "Отчет по оценкам, данным абонентами через личный кабинет",
      },
      NOTIFICATIONS: {
        TITLE: "Нотификации",
        MODULE: "Нотификаци модуль",
        REQUIREMENTS: "Требования",
      },
      GPS_TRACKING: {
        TITLE: "GPS наблюдение",
        GPS: "GPS",
        MONITORING: "Мониторинг",
        COMPANY_AUTOS_WORK_GRAPHICS_TITLE: "Графики работ техник",
        ACTION_REPORT: "Отчет о действиях",
        AUTOMOBILE_TYPES: "Типы автомобилей",
        AUTOMOBILES: "Автомобили",
        TRACKER_MODELS: "Модели устройств GPS",
        ATTACH_AUTO_TO_COMPANY: "Присоединить автотехнику",
        SECONDS: "Минута",
        MAHALLA_VISIT_ANALYZE: "Анализ посещений махалли",
        VISITS_TO_POLYGON: "Количество посещений полигонов техники",
        VISITS_TO_LEGAL: "Количество посещений юридических абонентов техники",
        VISITS_GRAPHS_CONTROL: "Управление графиком посещений",
        GPS_VISITS_GRAPH_ANALYZE_TITLE:
          "Контроль соблюдения графика автомобилями",
      },
      LEGAL_ENTITIES: {
        STATISTICS: "Статистика",
        TITLE: "Юридические потребители",
        ABONENTS: "Абоненты",
        ADDITIONAL_TYPES: "Виды дополнительных услуг",
        INDUSTRY_TYPES: "Типы  отраслей",
        TARIFFS: "Тарифы",
        CONTRACTS: "Договоры в разрезе регионов",
        NORMATIVES: "Нормативы",
        ORGANIZATIONS: "Организации",
        MONEY_TRANSFERS: "Денежные переводы",
        ONLINE_PAYMENTS: "Онлайн платежи",
        MUNIS: "Муниципальные сборы",
        ACTS: "Акты",
        CASH_PAYMENTS: "Наличные расчеты",
        SCHET_FAKTURA: "Счет-фактура",
      },
      SPRAVOCHNIK: {
        TITLE: "Справочник",
        PAYMENT_PARTNERS: "Платежные партнеры",
        STATUS_TYPES: "Статусы и типы",
        NOTIFICATION_TYPES: "Типы уведомлений",
        TEMPLATES_TITLE: "Типы шаблонов",
        CONTRACT_TEMPLATES_TITLE: "Контракт",
        EVIDENCE_TEMPLATES_TITLE: "Акт",
        NOTIFICATION_TEMPLATES_TITLE: "Уведомления",
        COMPANY_SETTINGS_TYPES_TITLE: "Типы настроек компании",
        ACTS_TITLE: "Акты",
        SMS_TEMPLATES_TITLE: "SMS",
      },
      POLYGON: {
        TITLE: "Полигон",
        POLYGONS: "Лицензированные организации",
        COMPANY: "Предприятии",
        POLYGONS_INFO: "Полигоны",
        CARS_LICENSED: "Лицензия на автомобиль",
        TARIFF: "Тарифы",
        STATISTICS: "Статистика",
        REPORTS: "Отчеты",
        EMPLOYEES: "Сотрудники",
      },
    },
    TOAST: {
      TITLE: {
        SUCCESS: "Успешно",
        WARNING: "Предупреждение",
        CANCELLED: "Отменено",
        ERROR: "Ошибка",
        INFO: "Информация",
        DOWNLOAD: "Загрузка",
        EXPORT_EXCEL: "Файл Excel успешно загружен!",
        IMPORT_EXCEL: "Файл Excel успешно импортирован!",
        RESIDENT_ID: "Данное строка таблицы не эммет абонент ID",
        SEND_SMS_WARNING_SUCCESS: "Уведомление успешно отправлено",
        SEND_SMS_WARNING_ERROR: " Произошла ошибка при отправке уведомления",
      },
      TOAST_DELETE: "Выбранная строка таблицы удалена успешно!",
      TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",
      TOAST_SUCCESS: "Информация успешно добавлена!",
      TOAST_ATTACH: "Данные успешно прикреплены!",
      TOAST_UPDATE: "Информация успешно отредактирована!",
      TOAST_UPDATE_ERROR: "Таҳрирлашда хатолик содир бўлди!",
      TOAST_MULTIPLE_SELECT_ROW: "Пожалуйста, выберите строкы!",
      TOAST_WARNING:
        "Если вы не знаете, как выглядит файловая структура, вы можете скачать образец файла.",
      TOAST_WARNING_RESIDENT:
        "Этот абонент не является сотрудником предприятия!",
      TOAST_ERROR_NOT_EMPLOYEE: "Этот абонент не является сотрудником!",
      TOAST_WARNING_RESIDENT_SEARCH: "Абонент не найден",
      TOAST_WARNING_RESIDENT_NOT_FOUND: "Абонентов на этой улице не нашлось",
      UPLOAD_FILE: "Файл успешно загружен",
    },
    THEME_MODE: {
      LIGHT: "Светлый",
      DARK: "Темный",
      SYSTEM: "Система",
    },
    HEADER_INPUT: {
      REGION: "Регионы",
      DISTRICTS: "Районы",
      COMPANY: "Компания",
    },
    USER_INNER: {
      PROFILE: "Профиль",
      EXIT: "Выход",
    },
    CHANGE_PHONE_NUMBER_RESIDENT_REQUEST: {
      TABS: {
        SENT_REQUESTS: "Отправлено",
        INCOME_REQUESTS: "Получено",
      },
      TABLE_HEADERS: {
        RESIDENT_ID: "ID абонента",
        PHONE: "Телефон",
        ADDRESS: "Адрес",
        CREATED_BY_NAME: "Создано кем",
        CREATED_DESCRIPTION: "Описание создания",
        CANCELLED_DESCRIPTION: "Описание отмены",
        CREATED_AT: "Дата создания",
        ACCOUNT_NUMBER: "Номер счета",
        COMPLETE: "Подтвердить",
        CANCEL: "Отменить",
        STATUS: "Статус",
        CREATED: "Создано",
        COMPLETED: "Подтверждён",
        CANCELLED: "Отменено",
      },
      STATUS: {
        CREATED: "Создано",
        COMPLETED: "Подтверждён",
        CANCELLED: "Отменено",
      },
      FORM: {
        TITLE: "Отправить запрос",
        ACCOUNT_NUMBER: "Номер счета",
        PHONE_NUMBER: "Номер телефона",
        DESCRIPTION: "Описание",
        SEND: "Отправить",
        CANCEL: "Отменить",
        CANCELLED_DESCRIPTION: "Описание отмены",
      },
      MODAL: {
        CONFIRMATION_COMPLETE_MODAL_COMPLETE: "Подтвердить",
        CONFIRMATION_COMPLETE_MODAL_TITLE: "Подтверждение запроса",
        CONFIRMATION_COMPLETE_MODAL_TEXT:
          "Вы действительно хотите подтвердить запросы на изменение номера?",
        CONFIRMATION_CANCEL_MODAL_CANCEL: "Отменить",
        CONFIRMATION_CANCEL_MODAL_TITLE: "Отмена запроса",
        CONFIRMATION_CANCEL_MODAL_TEXT:
          "Вы действительно хотите отменить запрос?",
      },
    },
    AUTH: {
      LOGIN: {
        TITLE: "Вход в систему",
        SUB_TITLE: "Биллинговая система Toza Makon",
        BUTTON: "Войти",
        FORGOT_BUTTON: "Забыли пароль?",
        LABEL_LOGIN: "Логин",
        LABEL_PASSWORD: "Пароль",
        CONFIRM_PASSWORD: "Подтвердите пароль",
        PLACEHOLDER_LOGIN: "Введите ваш логин",
        PLACEHOLDER_PASSWORD: "Введите ваш пароль",
        ERROR: "Введены неверные данные!",
        CHANGE_PASSWORD: "Сменить пароль",
        CURRENT_PASSWORD: "Текущий пароль",
        OLD_PASSWORD: "Старый пароль",
        NEW_PASSWORD: "Новый пароль",
        CONFIRM_NEW_PASSWORD: "Подтвердите новый пароль",
      },
      FORGOT: {
        TITLE: "Забыли пароль?",
        DESC: "Введите ваш электронный адрес, чтобы сбросить пароль",
        SUCCESS: "Ваша учетная запись была успешно сброшена.",
      },
      VALIDATION: {
        REQUIRED_LOGIN: "Требуется вход!",
        REQUIRED_PASSWORD: "Пароль необходимо ввести!",
        INVALID_LOGIN: "Введен неверный логин!",
        MIN_LOGIN: "Логин должен быть не менее 3-х символов!",
        MIN_PASSWORD: "Пароль должен содержать минимум 3 символа!",
        MAX_LOGIN: "Логин должен быть максимум 24 символа!",
        MAX_PASSWORD: "Пароль должен состоять максимум из 24 символов!",
        INVALID_PASSWORD: "Пароль должен содержать буквы и цифры!",
        PASSWORD_MISMATCH: "Введенные пароли несовместимы!",
      },
    },
    LEGAL_ENTITIES: {
      INTEGRATION: {
        RESIDENTS: {
          ORG_ID: "ИНН санитарной организации",
          ORG_NAME: "Название санитарной организации",
          FACTURA_SUM: "Сумма счетов-фактур",
          FACTURA_COUNT: "Количество счетов-фактур",
          REVENUE: "Сумма, поступившая на транзитный счёт",
          DEBIT_SUM: "Долг потребителей перед санитарной организацией",
          CREDIT_SUM: "Переплата потребителя санитарной организации",
          EQUIPMENT_COUNT: "Количество техники",
          AREA_ZONE: "Обслуживаемые территории",
        },
        TARIFF: {
          OBL_NAME: "Название области",
          CITY_FEE: "Тарифная сумма для города",
          AREA_FEE: "Тарифная сумма для района",
          UNIT_ID: "Единица измерения",
          ORG_NAME: "Название санитарной организации",
          AREA_NAME: "Название района",
          ORDER_DATE: "Дата решения о тарифе",
        },
        INFO: {
          TOTAL_CONTRACT_COUNT: "Количество договоров",
          TOTAL_CONTRACT_SUM: "Сумма договоров",
          TOTAL_CANDIDATES: "Количество кандидатов",
          COVERAGE: "Охват",
          DISPOSAL_COUNT: "Количество площадок для сбора отходов",
        },
      },
      RESIDENT_CARD: {
        DATA_EDIT: "Редактировать",
        RESIDENT_INFO: "Информация об абоненте",
        LEARN_MORE: "Более подробная информация",
        LEFT_CARD: {
          LEGAL_RESIDENT: "Юридический абонент",
          INDUSTRY_TYPES: "Тип отрасли",
          BANK: "Банк",
          BANK_OKED: "ОКЭД",
          BANK_MFO: "Банк МФО",
          ACCOUNT_NUMBER: "Номер счета",
          CADASTRAL_NUMBER: "Кадастровый номер",
          EMPLOYEE_COUNT: "Количество сотрудников",
          BUTTONS: {
            PAYMENT: "Платежи",
            ACCOUNT_INVOICE: "Счет-фактура",
            COURT_LAWSUIT: "Иск в суд",
          },
        },
        TABLE_HEADERS: {
          TARIFFS: "Тарифы",
          CONTRACTS: "Контракты",
          PAYMENTS: "Платежи",
          ACCOUNT_INVOICE: "Счет-фактура",
          SERVICES: "Услуги",
          VISITS: "Посещения",
        },
      },
      RESIDENTS: {
        TABLE_HEADERS: {
          NAME: "Наименование юридического лица",
          ACCOUNT_NUMBER: "Номер счета",
          DIRECTOR_FIO: "Ф.И.О директора",
          BANK: "Банк",
          BANK_ACCOUNT: "Банковский счет",
          BANK_MFO: "Банк МФО",
          BANK_OKED: "Банк ОКЭД",
          CONTRACT_DATE: "Дата заключения контракта",
          CONTRACT_NUMBER: "Номер контракта",
          CONTRACT_CLOSED_AT: "Дата окончания контракта",
          CREATED_AT: "Дата создания",
          CREATED_BY: "Создатель",
          DELETED_AT: "Дата удаления",
          DELETED_BY: "стирающий человек",
          DESCRIPTION: "Описание",
          ELECTRICITY_ACCOUNT_NUMBER: "Номер счета за электроэнергию",
          ELECTRICITY_COATO: "Электричество COATO",
          FAX: "Факс",
          HOME_PHONE: "Домашний телефон",
          IS_BUDGET: "Бюджетный?",
          CADASTRAL_NUMBER: "Кадастровый номер",
          RESIDENT_TYPE: "Тип абонента",
          SUP_ORGANIZATION: "Высшая организация",
          TIN: "ИНН",
          TYPE: "Тип",
          PERCENT: "Процент",
          UPDATED_AT: "Дата обновления",
          UPDATED_BY: "Обновленный человек",
        },
        FORM: {
          MAP_POSITION: "Расположение на карте",
          COMPANY: "Компания",
          TYPE: "Тип организации",
          RESIDENT_TYPE: "Тип абонента",
          INDUSTRY_TYPES: "Типы отраслей",
          TIN: "ИНН",
          NAME: "Наименование",
          OWNERSHIP_TYPES: "Тип владения",
          DIRECTOR_FIO: "ФИО директора",
          STATUS: "Статус",
          HOME_PHONE: "Номер телефона",
          FAX: "Факс",
          ELECTRICITY_COATO: "Электроэнергия COATO",
          ELECTRICITY_ACCOUNT_NUMBER: "Счет за электричество",
          CADASTRAL_NUMBER: "Кадастр номер",
          BANK: "Банк",
          BANK_ACCOUNT: "Банковский счет",
          BANK_MFO: "Банк МФО",
          BANK_OKED: "ОКЭД",
          MAHALLA_NAME: "Название махалли",
          STREET_NAME: "Название улицы",
          BUILDING_NUMBER: "Номер дома",
          ZIPCODE: "Почтовый индекс",
          EMPLOYEE_COUNT: "Количество сотрудников",
          IS_BUDGET: "Бюджетная организация",
          SUP_ORGANIZATION: "Название организации",
          DESCRIPTION: "Описание",
          FIRM_OR_ORGANIZATION: "Фирма/Организация",
          SOLE_ENTREPRENEUR: "ИП",
          WASTE_VOLUME: "Объем отходов",
          GEOZONA: "Геозона (введите название)",
          RESIDENTAL: "Физический",
          NON_RESIDENTAL: "Юридический",
          PROPERTY_TYPE: "Тип собственности",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить абонента",
          EDIT_MODAL_TITLE: "Редактировать абонента",
          DELETE_MODAL_TITLE: "Удалить абонента",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранного абонента из системы?",
        },
        TABS: {
          MAIN: "Основная информация",
          ADDITIONAL: "Дополнительная информация",
          LOCATION: "Местоположение",
        },
      },
      ADDITIONAL_TYPES: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_ID: "Название компании",
          NAME: "Название",
          SHORT_NAME: "Короткое наименование",
          RATE: "Цена",
        },
        ADD_EDIT_MODAL: {
          COMPANY: "Компания",
          RATE: "Цена",
          SHORT_NAME: "Короткое наименование",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить тип услуги",
          EDIT_MODAL_TITLE: "Редактировать тип услуги",
          DELETE_MODAL_TITLE: "Удалить тип услуги",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранный тип услуги из системы?",
        },
      },
      INDUSTRY_TYPES: {
        TABLE_HEADERS: {
          NAME: "Название",
          DESCRIPTION: "Описание",
          UNIT_NAME: "Название единство",
          UNIT_NAME_UZ: "Название единство (UZ)",
          UNIT_NAME_RU: "Название единство (РУ)",
          UNIT_NAME_CRL: "Название единство (УЗ)",
          DESCRIPTION_UZ: "Описание (UZ)",
          DESCRIPTION_RU: "Описание (РУ)",
          DESCRIPTION_CRL: "Описание (УЗ)",
          BEGINNING: "Начало",
          END: "Конец",
          OKONX: "ОКОНХ",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить тип отрасли",
          EDIT_MODAL_TITLE: "Редактировать тип отрасли",
          DELETE_MODAL: "Удалить тип отрасли",
          DELETE_MODAL_TITLE:
            "Вы действительно хотите удалить выбранную отрасль из системы?",
        },
      },
      TARIFFS: {
        TABLE_HEADERS: {
          ID: "ID",
          INDUSTRY_TYPES: "Виды отраслей",
          NAME: "Название",
          COMPANY_ID: "ID компании",
          RATE: "Цены",
          START_DATE: "Дата начала",
          END_DATE: "Дата окончания",
          DESCRIPTION: "Описание",
          SOLID_WASTE_RATE: "Твердые бытовые отходы",
          LIQUID_WASTE_RATE: "Жидкие бытовые отходы",
          CONSTRUCTION_WASTE_RATE: "Строительные и другие отходы",
        },
        FORMS: {
          COMPANY: "Компания",
          RATE: "Цена",
          START_DATE: "Дата начала",
          DESCRIPTION: "Описание",
          WASTE_CATEGORY: "Категория отходов",
          SOLID_WASTE: "Твердые бытовые отходы",
          LIQUID_WASTE: "Жидкие бытовые отходы",
          CONSTRUCTION_WASTE: "Строительные и другие отходы",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить тариф",
          EDIT_MODAL_TITLE: "Изменить тариф",
          DELETE_MODAL_TITLE: "Удалить тариф",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранный тариф из системы?",
        },
      },
      CONTRACTS: {
        TITLE: "Контракты",
        TABLE_HEADERS: {
          CONTRACTED_DATE: "Дата контракта",
          CONTRACT_START_DATE: "Дата начала контракта",
          CONTRACT_END_DATE: "Дата окончания контракта",
          OVERALL_AMOUNT: "Общая сумма",
          LEGAL_CONTRACT_TYPE: "Тип контракта",
          LEGAL_RESIDENT: "Юридические лица",
          TARIFFS: "Тариф",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить контракт",
          EDIT_MODAL_TITLE: "Изменить контракт",
          DELETE_MODAL_TITLE: "Удалить контракт",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранный контракт из системы?",
        },
        CONTRACT_TYPE: {
          YEARLY: "Годовой",
          DISPOSABLE: "Разовый",
        },
      },
      NORMATIVES: {
        TABLE_HEADERS: {
          NAME: "Название единство",
          MIN_AMOUNT: "Стоимость единицы",
          NORMATIVE: "Норматив (г)",
          WEIGHT_BY_VOLUME: "Вес по объему (кг/м³) ",
          INDUSTRY_TYPE_NAME: "Тип юридического лица",
          OKONX: "ОКОНХ",
          TARIFF: "Тариф",
          RATE: "Цена",
          WASTE_SUMM: "Плата за 1 кг отходов (сум)",
          WASTE_MONTH_SUMM: "Сумма ежемесячного платежа (сум)",
        },

        MODALS: {
          ADD_MODAL_TITLE: "Добавить норматив",
          EDIT_MODAL_TITLE: "Изменить норматив",
          DELETE_MODAL_TITLE: "Удалить норматив",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранный норматив из системы?",
        },
      },
      VISITS: {
        TABLE_HEADERS: {
          COMPANY_NAME: "Название компании",
          AUTOMOBILE_NUMBER_AND_MODEL: "Номер и модель автомобиля",
          VISIT_DATE: "Дата посещения",
          TIME_IN: "Время входа",
          TIME_OUT: "Время выхода",
          PARKING_DURATION_IN_SECONDS: "Продолжительность парковки (мин)",
          MIN_MOVING_DURATION: "Время движения (мин)",
          MIN_DURATION_IN: "Продолжительность доступа (мин)",
          MILEAGE: "Пройденное расстояние (км)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
          AVG_SPEED: "Средняя скорость (км/ч)",
        },
      },
      STATISTICS: {
        FIELD_TYPES: {
          TITLE: "По типам полей",
        },
      },
    },
    GPS_TRACKING: {
      ATTACH_STREET_TO_MAHALLA: {
        TITLE: "Прикрепить улицы к махалле",
        STREET_BINDING_TITLE: "Улицы",
        MAHALLA_VISIT_ANALYZE: "Анализ посещений махалли",
        STREET_BINDING: "Прикрепление улицы",
        SELECTED_STREETS_COUNT: "Количество выбранных улиц",
        DELETE_BINDING_STREET: "Удалить прикрепленную улицу",
        DELETE_MESSAGE:
          "Вы действительно хотите удалить выбранную улицу из этого района?",
      },
      ATTACH_AUTO_TO_COMPANY_NO_WIALON_ID: "Wialon ID автомобиля не найден",
      AUTOMOBILE_TYPES: {
        TABLE_HEADERS: {
          ID: "ID",
          MODEL: "Модель",
          DESCRIPTION: "Описание",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить тип автомобиля",
          EDIT_MODAL_TITLE: "Редактировать тип автомобиля",
          DELETE_MODAL_TITLE: "Удалить тип автомобиля",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранный тип автомобиля из системы?",
        },
      },
      AUTOMOBILES: {
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Номер автомобиля",
          TRACKER_SERIAL_NUMBER: "Серийный номер трекера",
          TRACKER_SIMCARD_NUMBER: "Номер SIM-карты трекера",
          DESCRIPTION: "Описание",
          STATUS: "Статус",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить автотехнику",
          EDIT_MODAL_TITLE: "Редактировать автомобиль",
          DELETE_MODAL_TITLE: "Удалить автомобиль",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранный автомобиль из системы?",
        },
        FORM: {
          AUTOMOBILE_NUMBER: "Номер автотехники",
          TRACKER_SERIAL_NUMBER: "Серийный номер трекера",
          TRACKER_SIMCARD_NUMBER: "Номер SIM-карты трекера",
          DESCRIPTION: "Описание",
          STATUS: "Статус",
          AUTOMOBILE_TYPE: "Типы автотехники",
          TRACKER_MODEL: "Модель GPS-устройства",
          AUTOMOBILE_NUMBER_AND_MODEL: "Номер и модель",
          M_KUB: "Объем отходов (м³)",
        },
      },
      TRACKER_MODELS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          DESCRIPTION: "Описание",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Добавить модель GPS трекера",
          EDIT_MODAL_TITLE: "Редактировать модель GPS трекера",
          DELETE_MODAL_TITLE: "Удалить модель GPS трекера",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранную модель GPS трекера из системы?",
        },
      },
      ATTACH_AUTO_TO_COMPANY: {
        EDIT_TITLE: "Редактирование автотехники компании",
        COMPANY_NAME: "Название компании",
        COMPANY_TECH: "Автотехники компании",
        AUTOMOBILE_NUMBER: "Автомобиль",
        SELECT_COMPANY: "Выберите компанию",
        AUTOMOBILE_WIALON: "Автотехника Wialon",
        DRIVER: "Водители",
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Номер автомобиля",
          DRIVERS: "Водители",
          WIALON_ID: "Wialon ID",
        },

        DELETE_MODAL_TITLE: "Удалить прикрепленный автотехнику",
        DELETE_MESSAGE:
          "Вы действительно хотите удалить прикрепленный автотехнику из системы?",
      },
      GPS_WATCH: {
        AUTO_REFRESH: "Автоматическое обновление карты",
        SECOND: "секунд",
        KM_H: "км/ч",
        KM: "км",
        H: "ч.",
        IMPORTANCE_OF_INDICATORS: "Важность показателей",
        ON: "Вкл",
        OFF: "Выкл",
        CUSTOM_FIELDS: "Настраиваемые поля",
        NO_COORDINATES_WARNING: "Координаты недоступны!",
      },
      STATISTICS: {
        INFO_CARD: {
          TITLE: "Географические единицы",
          REGION_COUNT: "Количество регионов",
          DISTRICT_COUNT: "Количество районов",
          MAHALLA_COUNT: "Количество махалли",
          STREET_COUNT: "Количество улиц",
          POLYGON_COUNT: "Количество свалок",
          WASTE_COLLECTION_AREA_COUNT: "Количество мест сбора отходов",
          AUTOMOBILE_COUNT: "Количество автомобилей в системе",
          ASSIGNED_AUTOMOBILE_COUNT: "Количество прикрепленных к Wialon",
          ASSIGNED_AUTOMOBILE_ALL_COUNT:
            "Общее количество автомобилей в Wialon",
          WASTE_COLLECTION_AREA_MAHALLA_NAME: "Район сбора отходов",
          WASTE_COLLECTION_AREA_NAME: "Название зоны сбора отходов",
          WASTE_COLLECTION_AREA_STREET_NAME: "Площадь сбора мусора улица",
        },
        CARS_STATISTICS: {
          TITLE: "Статистика транспортных средств",
          TITLE1: "Типы автомобилей",
          TITLE2: "Типы устройств GPS",
        },
        NEIGHBORHOODS: {
          TITLE1: "Наименее посещаемые районы в течение недели",
          TITLE2: "Самые посещаемые районы в течение недели",
          COUNT: "Количество посещений",
        },
      },
      MAHALLA_VISIT_ANALYZE: {
        FILTER: {
          VILLAGE: "Махалля",
        },
        TABLE_HEADERS: {
          MAHALLA_NAME: "Название махалли",
          DATE: "Дата",
          INDEX: "Индекс обслуживания",
          ACTION: "Действие",
        },
        MAHALLA_VISIT_ANALYSIS_ITEMS_TABLE_HEADERS: {
          MARKED_AS_SERVICED: "Помечено как обслуженное",
          MARKED_AS_GRAPHED: "Соответствует графику посещений",
          INDEX: "Индекс обслуживания",
          AVG_SPEED: "Средняя скорость (км/ч)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
          AUTOMOBILE_NUMBER: "Номер автомобиля",
          TIME_IN: "Время входа",
          TIME_OUT: "Время выхода",
          DURATION_IN_TIME: "Продолжительность пребывания на территории",
          MOVING_DURATION_IN_TIME: "Продолжительность времени в движении",
          PARKING_DURATION_IN_TIME: "Продолжительность времени отсутствия",
          MILEAGE: "Пройденное расстояние (км)",
          STOPS_COUNT: "Количество остановок",
          ON_MAP: "На карте",
          VISIT_DATE: "Дата посещения",
          ACTION: "Действие",
        },
        MODALS: {
          TITLE_UPDATE: "Редактировать",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT: "Пометить как обслуженное",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT_CANCEL:
            "Отменить оказание услуги",
        },
      },
      VISITS_GRAPHS_CONTROL: {
        TABLE_HEADERS: {
          MAHALLA_NAME: "Название махалли",
          DISTRICT_NAME: "Название район",
          DESCRIPTION: "Описание",
          REGION_NAME: "Название провинции",
          COMPANY_NAME: "Название компании",
          CREATED_AT: "Дата создания",
          END_DATE: "Дата окончания до истечения срока",
          FROM_DATE: "Дата начала",
          TO_DATE: "Дата окончания",
          FILE_PATH: "Прикрепленный файл",
          STATUS: "Статус",
          ACTION: "Действие",
          NEW: "Новый",
          ACTIVE: "Активный",
          INACTIVE: "Не активно",
        },
        MODALS: {
          MAHALLA_NAME: "Название махалли",
          FROM_TO_DATE: "Дата начала и окончания",
          DESCRIPTION: "Описание",
          FILE_PATH: "Прикрепить файл",
          COMPANY_NAME: "Название компании",
          ADD_MODAL_TITLE: "Добавить управление посещениями",
          EDIT_MODAL_TITLE: "Редактировать статус управления посещениями",
          DELETE_MODAL_TITLE: "Удалить управление посещениями",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранное управление посещениями из системы?",
        },
      },
      GPS_ACCRUALS_REPORT: {
        TABLE_HEADERS: {
          NAME: "Название",
          TOTAL_MAHALLAS_COUNT: "Общее количество махаллей",
          GPS_BASED_MAHALLAS_COUNT:
            "Количество махаллей, где включены начисления на основе GPS",
          GPS_BASED_ACTIVE_MAHALLAS_COUNT:
            "Количество махаллей с активными GPS-начислениями в текущем периоде",
          SUB_MAHALLAS_COUNT: "Общее количество суб-махаллей",

          ACTUAL_BALANCE_CALCULATED_MAHALLAS_COUNT:
            "Количество махаллей, в которых внедрена сумма, рассчитанная через GPS",
          GPS_BASED_SUB_MAHALLAS_COUNT: "Суб-махалли с начислением по GPS",
          TOTAL_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "Общее количество ежемесячных поездок по махаллям",
          TOTAL_SUB_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "Общее количество ежемесячных поездок по суб-махаллям",
          TOTAL_GPS_BASED_SUB_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "Ежемесячные поездки по GPS-суб-махаллям",
          MAHALLA_TOTAL_RESIDENTS_COUNT:
            "Общее количество абонентов в махаллях",
          MAHALLA_TOTAL_GPS_BASED_RESIDENTS_COUNT:
            "Абоненты с GPS-начислением в махаллях",
          SUB_MAHALLA_TOTAL_RESIDENTS_COUNT:
            "Общее количество абонентов в суб-махаллях",
          SUB_MAHALLA_UNASSIGNED_RESIDENTS_COUNT:
            "Общее количество неназначенный абонентов",
          SUB_MAHALLA_TOTAL_GPS_BASED_RESIDENTS_COUNT:
            "Абоненты с GPS-начислением в суб-махаллях",
          TOTAL_VISITS_COUNT: "Общее количество посещений",
          TOTAL_MAKED_AS_SERVICED_VISITS_COUNT:
            "Посещения, отмеченные как обслуженные",
          TOTAL_DEFAULT_ACCRUAL_AMOUNT: "Общая сумма обычных начислений",
          TOTAL_AMOUNT: "Общая сумма",
          TOTAL_GPS_BASED_ACCRUAL_AMOUNT: "Общая сумма начислений по GPS",
          TOTAL_SUB_MAHALLAS_ACCRUAL_AMOUNT:
            "Общая сумма начислений по территориям махалли",
          TOTAL_CHYM_ACCRUAL_AMOUNT: "Общая сумма начислений МСП",
          ACCRUAL_TYPE: "Тип начисления",
          DEFAULT_ACCRUAL_AMOUNT: "Сумма обычного начисления",
          GPS_ACCRUAL_AMOUNT: "Сумма GPS начисления",
          CHYM_BASED: "На основе визитов МСП",
          MAHALLA_BASED: "На основе визитов махалли",
        },
        MODAL: {
          TITLE: "Абоненты",
        },
      },
      GPS_VISITS_GRAPH_ANALYZE: {
        TABLE: {
          PLANNED: "По графику",
          ACTUAL: "Фактически",
          MAHALLA_NAME: "Название махалли",
          TIME_IN: "Время входа",
          TIME_OUT: "Время выхода",
          DURATION_IN_TIME: "Продолжительность пребывания на территории",
          MILAGE_KM: "Пройденное расстояние (км)",
          STOPS_COUNT: "Количество остановок",
        },
        CHOOSE_COMPANY_TITLE:
          "Чтобы посмотреть анализ графика посещений, выберите предприятие и дату",
      },
    },
    MANAGEMENT: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        ID: "ID",
        NAME: "Название",
        COMPANY: "Предприятии",
        DATE1: "03.2023",
        DATE2: "04.2023",
        DATE3: "05.2023",
        DATE4: "06.2023",
        DATE5: "07.2023",
        DATE6: "08.2023",
        DATE7: "09.2023",
        ACTION: "Действие",
      },
      USER_ROLE: {
        TABLE_HEADERS: {
          ID: "ID",
          PREFIX: "Префикс роли",
          NAME: "Название роли",
          LEVEL: "Уровень",
          USERS_COUNT: "Количество пользователей",
          TYPE: "Тип",
          COMMENT: "Комментарий",
          COMMENT_UZ: "Комментарий (UZ)",
          COMMENT_CRL: "Комментарий (УЗ)",
          COMMENT_RU: "Комментарий (РУ)",
        },
        FILTER: {
          FILTER_BUTTON: "Доступные действия",
          TITLE: "Разрешенные действия",
        },
        INSERT_MODAL: "Добавление новой роли",
        UPDATE_MODAL: "Редактирование ролей",
        DELETE_MODAL: {
          TITLE: "Удаление роли",
          TEXT: "Вы действительно хотите удалить выбранную роль из системы?",
        },
        TOAST_EXISTS_ROLENAME:
          "Это «Имя роли» существует в системе.\nПожалуйста, введите другое имя!",
      },
      USERS: {
        ROLE: "Роль",
        ADD_MODAL_TITLE: "Добавление пользователя",
        EDIT_MODAL_TITLE: "Редактирование информации о пользователе",
        EDIT_USER: "Редактировать данные",
        UPDATE_STATUS_MODAL_TITLE: "Статус пользователя",
        UPDATE_PASS_MODAL_TITLE: "Изменить пароль пользователя",
        UPDATE_STATUS: "Изменить статус",
        UPDATE_PASS: "Изменить пароль",
        ACTIVE: "Активный",
        IN_ACTIVE: "Не активно",
        TOAST_EXISTS_LOGIN:
          "Данное имя «Логин» уже существует в системе.\nПожалуйста, введите другое имя!",
        RESPUBLIC: "Республика",
      },
      COMPANY_GROUP_ADMIN: {
        DELETE_ADMIN_TEXT:
          'Вы действительно хотите удалить выбранная "Директора группы предприятия" из системы?',
        DETACH_COMPANY_TEXT:
          'Вы действительно хотите удалить выбранное предприятие из "Директора группы предприятия"?',
        GPS_ADMIN: "Создать как администратор GPS",
      },
      COMPANY_OPERATIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          T_PERIOD: "Тек. период",
          ADDRESS: "Адрес",
          PHONE: "Телефон",
          TASK: "Задания",
          START_DATE: "Начало",
          END_DATE: "Окончание",
          STATUS: "Статус",
          RESULT: "Результат",
          KOD: "Код",
          ACTION: "Действие",
        },
        SELECT: {
          REGION: "Выберите регион",
          DISTRICT: "Выберите район",
          YEAR: "Год",
          MONTH: "Месяц",
        },
        MODAL: {
          TITLE: "Перерасчет текущего месяца",
          TEXT: "Вы действительно хотите одновременно перерасчитать, а затем перевести данную компанию на новый период?",
          SAVE: "Да выполнить",
        },
      },
      COMPANY_SETTINGS: {
        TITLES: {
          HYBRID_SETTINGS: "Настройки гибридной почты",
          PERMISSION_SETTINGS: "Настройки разрешений",
          MENU_RESTRICTIONS: "Ограничения меню",
        },
      },
      ACT_PERMISSION_BY_COMPANIES: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION_NAME: "Название провинции",
          COMPANY_NAME: "Название компании",
          CREATED_AT: "Дата создания",
          ENDED_AT: "Дата окончания до истечения срока",
          FROM_DATE: "Дата начала",
          TO_DATE: "Дата окончания",
          FILE_PATH: "Прикрепленный файл",
          CREATED_BY: "Пользователь, который создал",
        },
        MODALS: {
          ADD_TITLE: "Активация управления действиями для предприятия",
          FROM_DATE: "Дата начала:",
          TO_DATE: "Дата окончания:",
          FILE_PATH: "Прикрепленный файл:",
          WANT_BLOCK: "Хотите заблокировать это предприятие?",
          WANT_UNBLOCK: "Хотите активировать это предприятие?",
        },
      },
      WORK_1031_PERMISSION_BY_ORGANIZATION: {
        MODALS: {
          ADD_TITLE: "Активация управления БПИ и 1031 для предприятий",
        },
      },
      PAYMENTS_PERMISSION_BY_ORGANIZATION: {
        MODALS: {
          ADD_TITLE: "Активация управления платежами для предприятий",
        },
      },

      BLOCKED_USERS: {
        TABLE_HEADERS: {
          ID: "ID",
          USER_NAME: "Имя пользователя",
          ROLE_NAME: "Название роли",
          IPADDRESS: "IP адрес",
          UN_SUCCESS_FULATTEMPTS_COUNT: "Количество неудачных попыток",
          BLOCKED_AT: "Дата блокировки",
          BLOCKED_UNTIL: "Дата окончания блокировки",
          CURRENTLY_BLOCKED: "Состояние блока",
          UNBLOCK: "Разблокировать",
          BLOCKED: "Заблокирован",
          UNBLOCKED: "Разблокирован",
        },
      },
      SYSTEM_CONFIGURATIONS: {
        COURT_WARNING: "Системные настройки",
        COURT_WARNING_PUT: "Обновление настроек судебного уведомления",
        COURT_WARNING_TO_COURT_PROCESS_DAY_INTERVAL:
          "Промежуток между днями судебного разбирательства (месяцы)",
        COURT_WARNING_VALIDATION_MONTH_INTERVAL:
          "Минимальный промежуток (месяцы), в течение которого можно создать повторное судебное уведомление",
        COURT_WARNING_DEBT_PARTIAL_COVERAGE_PERCENTAGE:
          "Процент частичного погашения задолженности",
        QQS_PERCENTAGE: "Процент НДС",
        QSS_STARTS_AT: "Дата начала расчета НДС",
        MINIMUM_CHYM_TIME_IN_MINUTES:
          "Минимальное количество минут нахождения в зоне, чтобы считать посещение площадки для сбора отходов.",
        MINIMUM_MAHALLA_SERVICE_ABILITY_INDEX:
          "Минимальный индекс обслуживания для учета посещения махаллы",
        STATE_DUTY_AMOUNT: "Государственная пошлина за судебное предупреждение",
        POST_FREE_AMOUNT: "Почтовые расходы за судебное предупреждение",
        PUBLIC_FILE_DOWNLOAD_URL_PREFIX:
          "URL-адрес загрузки файла через QR-код",
        MAX_COURT_WARNING_CREATE_LIMIT:
          "Максимальное количество предупреждений суда достигнуто",
        WASTE_COLLECTION_AREA_RADIUS: "Радиус зоны сбора отходов",
        AFFECT_CHYM_VISIT_TO_BALANCE:
          "Расчет начислений на основе визитов в МСП",
        AFFECT_MAHALLA_VISIT_TO_BALANCE:
          "Расчет начислений на основе визитов в махаллу",
        GPS_WEIGHT_DURATION: "Важность продолжительности пребывания в движении",
        GPS_WEIGHT_MILEAGE: "Важность пройденного расстояния",
        GPS_WEIGHT_STOPS: "Важность количества остановок",
        GPS_WEIGHT_SPEED: "Важность средней скорости",
        CHANGE_VALUE:
          "Индивидуальное определение важности параметров посещения окрестностей, не вычитая их из общих настроек",
        LAST_MIA_SYNC_MONTH: "Месяц последней успешной синхронизации с УВД",
        RESIDENT_CRON_OPEN_HOUR: "Время открытия крона для абонентов (час)",
        RESIDENT_CRON_CLOSE_HOUR: "Время закрытия крона для абонентов (час)",
      },
    },
    SMS_GATEWAY: {
      TABLE_HEADERS: {
        PHONE_NUMBER: "Номер телефона",
        SENDING_DATE: "Дата отправки",
        SENDING_TIME: "Время отправки",
        PROVIDER_TYPE: "Тип провайдера",
        MESSAGE_TEXT: "Текст сообщения",
        SEND_SMS: "Отправлено CMC",
        ACTION: "Действия",
        TIME: "Время",
      },
      SEND: "Отправлено",
      DELIVERED: "Доставлено",
      TRANSFERRED: "Передано",
      NOT_DELIVERED: "Не доставлено",
      REJECTED: "Отклонено",
      UNSUCCESSFUL: "Неудачно",
      EXPIRED: "Истекший",
      COMPANY_NAME: "Название компании",
      MODAL_TITLE: "Текст сообщения",
      NOT_TEMPLATE: "Не соответствует шаблону",
      NO_CONTRACT: "Контракт не существует",
      AUTHFAILED: "Ошибка авторизации",
      WARNED: "Предупрежденный",
    },
    DXSH: {
      DXSH_COMAPANIES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          INN: "INN",
          ADDRESS: "Manzil",
          PHONE: "Telefon",
          EMAIL: "Elektron pochta",
          DIRECTOR_FIO: "Direktor F.I.Sh",
          LEGAL_ACCOUNT_NUMBER: "Yuridik shaxs hisob raqami",
        },
      },
      INVESTITION_CATEGORIES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          DESCRIPTION: "Описание",
        },
        NAMES: {
          SPECIAL_EQUIPMENT: "Специальная техника",
          CONTAINER: "Контейнер",
          SORTING_EQUIPMENT: "Сортировочное оборудование",
          PROCESSING_EQUIPMENT: "Технологическое оборудование",
          REBOOT_STATION: "Перевалочная станция",
          WASTE_COLLECTION_TANK: "Цех по сбору мусора",
          CONSTRUCTION_OF_BUILDINGS: "Строительство зданий и сооружений",
          JOB_VACANCY: "Вакансии",
          OTHER: "Другие",
        },
        MODALS: {
          NAME_UZ: "Название (UZ)",
          NAME_RU: "Название (RU)",
          NAME_CRL: "Название (УЗ)",
          ADD_MODAL_TITLE: "Добавить инвестиционную категорию",
          EDIT_MODAL_TITLE: "Редактировать инвестиционную категорию",
          DELETE_MODAL_TITLE: "Удалить инвестиционную категорию",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранную инвестиционную категорию из системы?",
        },
      },
      DXSH_INVESTMENT: {
        TABLE_HEADERS: {
          ID: "ID",
          INVOICE_NUMBER: "Номер счета-фактуры",
          INVOICE_PURPOSE: "Цель счета-фактуры",
          INVOICE_DATE: "Дата",
          INVESTMENT_CATEGORY_NAME: "Инвестиционная категория",
          QUANTITY: "Количество",
          AMOUNT: "Сумма",
          FILE: "Бухгалтерский отчет",
        },
        MODALS: {
          INVOICE_NUMBER: "Номер счета-фактуры:",
          INVOICE_PURPOSE: "Цель счета-фактуры:",
          INVOICE_DATE: "Дата:",
          INVESTMENT_CATEGORY: "Категория инвестиции:",
          NAME: "Название:",
          QUANTITY: "Количество:",
          AMOUNT: "Сумма:",
          FILE: "Файл-основатель:",
          VEHICLE_NUMBER: "Транспортный номер",
          TEX_PASSPORT_SERIES: "Технический паспорт серия",
          TEX_PASSPORT_NUMBER: "Технический паспорт номер",
          PURCHASE_AMOUNT: "Покупная сумма",
          GET_CAR_INFO: "Получение информации о транспорте",
          DELETE_CAR_INFO: "Удалить транспортные данные",
          ADD_NEW_TRANSPORT: "Добавить новый транспорт",
          ADD_MODAL_TITLE: "Добавление факта выполнения контракта",
          EDIT_MODAL_TITLE: "Редактирование факта исполнения договора",
          DELETE_MODAL_TITLE: "Удаление факта исполнения договора",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить из системы факт выполнения выбранного контракта?",
          CAR_NUMBER: "Номер автобуса:",
          CAR_DOCUMENT: "Документ на автомобиль:",
          CAR_DOCUMENT_FILE: "Файл документа об автомобиле:",
          CAR_INFO_CONFIRMATION_TITLE: "Подтверждение информации об автомобиле",
        },
        CONFIRM_CAR_INFO: {
          TITLE: "Подтверждение информации об автомобиле",
          CONFIRM: "Подтверждение",
          CANCEL: "Отмена",
          CAR_YEAR: "Автомобильный год",
          CAR_MODEL: "Модель автомобиля",
          CAR_NUMBER: "Номер автомобиля",
          CAR_COLOR: "Цвет автомобиля",
          CAR_REGISTRATION_DATE: "Дата регистрации автомобиля",
          CAR_DOCUMENT_SERIES_NUMBER: "Серия и номер документа на автомобиль",
        },
        ERRORS: {
          INVESTMENT_CATEGORY_NOT_FOUND:
            "В этом контракте не было найдено информации по выбранной категории",
        },
      },
      INVESTITION_INFO: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Название компании",
          COMPANY_INN: "ИНН компании",
          CONTRACTS: "Контракты",
          CONTRACT_INFO: "Информация о контракте",
          CONTRACT_NUMBER: "Номер контракта",
          NUMBER: "Номер",
          CONTRACT_DATE: "Дата контракта",
          DATE: "Дата",
          CONTRACT_AMOUNT: "Сумма контракта",
          CATEGORIES: "Инвестиционные категории",
          CATEGORY_NAME: "Название категории",
          QUANTITY: "Количество",
          AMOUNT: "Сумма",
          EMPLOYEES_COUNT: "Количество сотрудников",
          POSITIONS_COUNT: "Количество рабочих мест руководителя",
          POPULATION_USERS_COUNT: "Численность обслуживаемого населения:",
        },
        MODALS: {
          COMPANY_NAME: "Название компании:",
          CONTRACT_NUMBER: "Номер контракта:",
          CONTRACT_DATE: "Дата контракта:",
          CONTRACT_AMOUNT: "Сумма контракта:",
          INVESTITION_AMOUNT: "Инвестиционная сумма:",
          CATEGORY_NAME: "Название категории:",
          QUANTITY: "Количество:",
          AMOUNT: "Сумма:",
          COMPANY_NOT_FOUNT: "Не найдено предприятие на базе ГЧП",
          ADD_MODAL_TITLE: "Добавление нового контракта",
          EDIT_MODAL_TITLE: "Редактирование контракта",
          DELETE_MODAL_TITLE: "Удаление контракта",
          DELETE_MESSAGE:
            "Вы действительно хотите удалить выбранный контракт из системы?",
        },
      },
      DXSH_REPORT: {
        DATE: "Дата",
        TABLE_HEADERS: {
          ID: "№",
          REGIONS: "Районы",
          ATTACHED_DISTRICS: "Присоединенный район (города)",
          PRIVATE_PARTNER: "Частный партнер",
          DXSH_AGREEMENT: "Соглашение  ДХШ",
          CONTRACT_AMOUNT: "Общая сумма включенных инвестиций",
          TOTAL_AMOUNT: "сумма инвестиций в состояние",
          TOTAL_INVESMENT_AMOUNT: "Общий объем инвестиционных мигрантов",
          COMPLECTED_IN_PERCENT: "Исполнение (в процентах)",
          CATEGORY_COUNT: "План (количество)",
          CATEGORY_SUMMA: "Сумма",
          CATEGORY_PRACTIC_COUNT: "На практике (количество)",
          CONTRACT_DATE: "Дата контракта",
          CONTRACT_NUMBER: "Номер контракта",
          TOTAL: "Итого:",
        },
        MODAL: {
          EXCEL_TITLE: "Инвестиционный отчет {{date}}",
        },
      },
      STATISTICS: {
        INCOME_BY_REGION: {
          TITLE: "Суммы инвестиций по регионам",
        },
        INFO_CARD: {
          TITLE: "Данные",
          TOTAL_AMOUNT: "Сумма в плане",
          CURRENT_AMOUNT: "Текущая сумма",
          CONTRACT_NUMBER: "Номер контракта",
          PROTSENT: "Процент",
          COMPANIES_COUNT: "Количество компаний",
          CONTRACTS_COUNT: "Количество контрактов",
          CATEGORIES_COUNT: "Количество категорий",
        },
        COMPANIES_CHART: {
          TITLE: "Суммы контрактных инвестиций, заключенных предприятиями",
        },
        CONTRACTS_CHART: {
          TITLE: "Контракты плановые и текущие суммы инвестиций",
        },
        CATEGORIES_CHART: {
          TITLE: "Категории планируемые и текущие суммы инвестиций",
        },
      },
      FACT_OF_NEW_WORK_POSOTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Yangi ish o'rin yaratilganlik fakti qo‘shish",
        },
      },
    },
    BANK_OPERATIONS: {
      COMPANY_INN: "ИНН компании",
      COMPANY_BANK_MFO: "МФО банка компании",
      COMPANY_TRANZIT_ACCOUNT: "Транзитный счет компании",
      CORRESPONDENT_ACCOUNT: "Номер счета корреспондента",
      CORRESPONDENT_NAME: "Название корреспондента",
      CORRESPONDENT_BANK_MFO: "МФО банка корреспондента",
      PAYMENT_PURPOSE: "Цель платежа",
      DEBIT: "Доход",
      CREDIT: "Расход",
      OPENING_BALANCE: "Остаток на начало периода",
      CLOSING_BALANCE: "Остаток на конец периода",
      LAST_UPDATE: "Время последнего обновления",
    },
    BANK_BILLING_COMPARISON: {
      LAST_PERIOD_DIFFERENCE: "Остаток на начало периода",
      BILLING_AMOUNT: "Поступление в биллинговой системе",
      PARTNER_STAFF: "Доля платежного партнёра (%)",
      BILLING_AMOUNT_PARTNER_STAFF:
        "Сумма, которую должны перечислить платёжные партнёры",
      BANK_AMOUNT:
        "Сумма, поступившая от платёжных партнёров за текущий период (по данным банка)",
      DIFFERENCE: "Остаток на конец периода",
    },
    COMPANY: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        TRANSIT_ACC_MFO: "Транзитный счет МФО",
        ID: "ID",
        NAME: "Название",
        TYPE: "Тип",
        REGION: "Район",
        REGIONS: "Регионы",
        TURNOVER: "Банк МФО",
        COMPANY_ACCOUNT: "Номер счета компании",
        TRANSIT_NUMBER: "Транзитный счет номер",
        TREASURY_ACC_NUMBER: "Номер казначейского счета",
        LEGAL_ACCOUNT: "Номер счета для юридических лиц",
        TRANZIT_ACCOUNT: "Номер счета для транзитов",
        INN: "ИНН",
        CONTRACT_NUMBER: "Номер договора",
        CONTRACT_START_DATE: "Дата начала",
        CONTRACT_END_DATE: "Дата окончания",
        CONTRACT_LEFT_DATE: "Срок действия договора (дней)",
        CONTRACT_FILE: "Файл контракта",
        COMMENT: "Комментарий",
        STATUS: "Статус",
        TYPE_COMPANY: "Тип компании",
        EMAIL: "Электронная почта",
        ADDRESS: "Адрес",
        DIRECTOR_FIO: "Ф.И.О директора",
        BANK_NAME: "Название банка",
        PHONE_NUMBER: "Номер телефона",
        CONTRACT_CREATED_AT: "Дата создания",
        CONTRACT_CREATED_BY_NAME: "Пользователь, создавший договор",
      },
      MODAL: {
        SEND_SMS: "Отправить SMS",
        ADD_TITLE: "Добавление компании",
        EDIT_TITLE: "Редактирование компании",
        DELETE_TITLE: "Удалить выбранную компанию",
        EDIT_CONTRACT_TITLE: "Редактирование договора",
        DELETE_TEXT: "Вы действительно хотите удалить компанию из системы?",
        INPUT_MODAL_TEXT: "Название компании: ",
        SEND_SMS_DEBIT_RESIDENT_CONFIRMATION_TEXT:
          "Вы действительно хотите подтвердить отправку СМС этому абоненту?",
        SEND_SMS_DEBIT_RESIDENTS_CONFIRMATION_TEXT:
          "Вы действительно хотите подтвердить, что отправляете SMS своим подписчикам-должникам!",

        BLOCK_CONFIRMED_MAHALLA_TITLE: "Блокировка предупреждённых",
        BLOCK_CONFIRMED_MAHALLA_SUB_TITLE:
          "Вы действительно хотите заблокировать предупреждённых абонентов?",
        AUTO_LIST_CONFIRMED_MAHALLA_TITLE: "Формирование списка",
        AUTO_LIST_CONFIRMED_MAHALLA_SUB_TITLE:
          "Вы действительно хотите формирование списка для выбранных махаллей?",
        REMOVE_FROM_AUTO_LIST_TITLE: "Удалить из списка",
        REMOVE_FROM_AUTO_LIST_SUB_TITLE:
          "Вы действительно хотите удалить выбранные махалли из списка?",
      },
      NUMBER_OF_RESIDENTS_SELECTED: "Количество выбранных жителей",
      LIMITED: "Количество СМС, которое можно отправить:",
      RESIDENTS_WITH_BALANCE_FROM_BALANCE_TO:
        "Абоненты с задолженностью от {{ from }} до {{ to }} ",
      LIMITED_SMS: "Лимит SMS",
      NAME_FOR_SMS: "Название для SMS",
      DXSH_PERCENTAGE: "Процент ДХШ",
    },
    EMPLOYEES: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        ID: "ID",
        FIRST_NAME: "Имя",
        LAST_NAME: "Фамилия",
        PATRONYMIC: "Отчество",
        EMAIL: "Электронная почта",
        PHONE_NUMBER: "Номер телефона",
        ADDRESS: "Адрес",
        COMMENT: "Комментарий",
        LOGIN: "Логин",
        STATUS: "Статус",
        TABEL_NUMBER: "Табельный номер",
        ATTACHED_FILE: "Прикрепленный файл",
        LAST_OPERATION_DATE: "Дата последней операции",
      },
      MODAL: {
        ADD_TITLE: "Добавление нового сотрудника",
        EDIT_TITLE: "Редактирование сотрудника",
        DELETE_TITLE: "Удаление выбранного сотрудника",
        DELETE_TEXT:
          "Вы действительно хотите удалить выбранного сотрудника из системы?",
        INPUT_MODAL_TEXT: "Название сотрудника: ",

        TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",

        EMPLOYEE_INFO: "Информация о сотруднике",
        FIRST_NAME: "Фамилия",
        LAST_NAME: "Имя",
        PATRONYMIC: "Отчество",
        POSITION: "Позиция",
        EMAIL: "Электронная почта",
        PHONE_NUMBER: "Номер телефона ",
        ADDRESS: "Адрес ",
        COMMENT: "Комментарий",
        ROLES: "Роли",
        POSITIONS: "Должность",
        PHOTO: "Загрузка фотографии сотрудника",
        CHANGE_PASSWORD: "Изменить пароль",
        PASSWORD: "Пароль",
      },
    },
    TOOLS: {
      RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          FISH: "Ф.И.О",
          FOREIGN_CITIZEN: "Иностранный гражданин",
          CITIZENSHIP: "Гражданство",
          CITIZEN_OF_UZBEKISTAN: "Гражданин Узбекистана",
          LITSEVOY: "Номер счета",
          ETK_NUMBER: "Номер счета ЭТК",
          ETK_SOATO: "ЭТК СОАТО",
          COMPANY_NAME: "Название компании",
          REGION: "Территория",
          VILLAGES: "Махалля",
          STREET: "Улица",
          ACTION: "Действия",
          CADASTRAL_NUMBER: "Кадастровый номер",
          TEMPORARY_CADASTRAL_NUMBER: "Нежильных кадастровый номер",
          HOME_NUMBER: "Номер дома",
          HOUSE_TYPE: "Тип дома",
          CONTRACT_NUMBER: "Номер договора",
          CONTRACT_DATE: "Дата договора",
          ELECTRICITY_COATO: "Электричество СОАТО",
          ELECTRICITY_ACCOUNT_NUMBER: "Номер счета электричества",
          PHONE: "Телефон",
          HOME_PHONE: "Домашний телефон",
          RESIDENT_TYPE: "Тип жителя",
          OLD_ACCOUNT_NUMBER: "Старый номер счета",
          ACCOUNT_NUMBER: "Номер счета",
          PNFL: "ПИНФЛ",
          PASSPORT_EXPIRE_DATE: "Срок действия паспорта",
          PASSPORT_NUMBER: "Номер паспорта",
          PASSPORT_ISSUE_DATE: "Дата выдачи паспорта",
          PASSPORT_SERIAL: "Серия паспорта",
          PASSPORT: "Паспорт",
          PASSPORT_GIVEN_DATE: "Дата выдачи паспорта",
          BIRTH_DATE: "Дата рождения",
          TYPE: "Тип",
          PASSPORT_GIVEN_BY: "Кем выдан паспорт",
          RESIDENTS: "Абоненты",
          APPARTMENT: "Квартира",
          ALL_PAYMENTS: "Все платежи",
          N_SALDO: "Начальное сальдо",
          N_SALDO_DEBIT: "Сальдо начало, дебитор",
          N_SALDO_KREDIT: "Сальдо начало, кредитор",
          K_SALDO: "Кон.сальдо",
          QQS: "НДС",
          K_SALDO_DEBIT: "Кон.сальдо, дебитор",
          K_SALDO_KREDIT: "Кон.сальдо, Кредитор",
          HOME_TYPE: "Тип квартиры",
          HOME: "Дом",
          HOME_INDEX: "Индекс дома",
          FLAT: "Кв",
          NUMBER_OF_OWNERS: "Количество собственников",
          OWNERS: "Собственники",
          LAST_PAYMENT_DATE: "Дата последнего платежа",
          LAST_PAYMENT_AMOUNT: "Сумма последнего платежа",
          LAST_PAYMENT_TYPE: "Тип последнего платежа",
        },
        RESIDENT_INFO: {
          PERIOD: "Период",
          INHABITANT_COUNT: "История изменений жителей",
          N_SALDO: "Начальное сальдо",
          ACCRUAL: "Начисление",
          ADDITIONAL_ACCRUAL: "Начис (доп.услуги)",
          ACT: "Акт",
          CHANGE_PHONE_NUMBER: "Изменить номер телефона",
          NACHISLENIA_TYPE: "Тип начисления",
          DEFAULT: "Стандарт",
          CHYM_BASED: "Посещение МСП",
          MAHALLA_BASED: "Посещение махалля",
          IIB_BASED: "На основании данных ОВД о проживающих",

          CONNECTED_RESIDENT: "Подключённый абонент",

          ACT_AMOUNT: "Сумма акта",
          LAST_PAY_DATE: "Последний день оплаты",
          LAST_PAY_AMOUNT: "Окончательная сумма выплаты",
          FROZEN_N_SALDO: "Сальдо замороженной задолженности",
          FROZEN_K_SALDO: "Конец замороженного остатка долга",
          FROZEN_ACT_AMOUNT: "Замороженная сумма акта",
          INDEX: "Индекс",
          HOME_LETTER: "Дом буква",
          FLAT_NUMBER: "Номер квартиры",

          CHASH_AMOUNT: "Поступл. квит.",
          EL_AMOUNT: "Поступл. эл.плат.",
          MUNIS_AMOUNT: "Мунис",
          Q_1031_AMOUNT: "Платежи по БПИ и 1031",
          K_SALDO: "Кон.сальдо",
          PENALTY_FEE: "Пеня",
          ENTITLEMENT: "Предоплата",
          SURCHARGE: "Доплата",
          FRONZEN_DEBT: "Замороженный долг",
          FROZEN_REVENUE: "Поступление",
          DEBT_ACT: "Дебитовый акт",
          FROZEN_DEBT_SETTLEMENT: "Акт о погашении долга",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_PREFIX: "ПО СОСТОЯНИЮ НА",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_MIDDLE: "",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_BY_YEAR: "«01»",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_SUFIX:
            "ГОДА ЗАДОЛЖЕННОСТИ ЗА УСЛУГИ ПО ВЫВОЗУ БЫТОВЫХ ОТХОДОВ НЕ ИМЕЕТ. СПРАВКА ВЫДАНА ПО МЕСТУ ТРЕБОВАНИЯ",
          RESIDENT_REFERENCE_ACCOUNT_NUMBER: "Лицевой",
          RESIDENT_REFERENCE_FIO: "Ф.И.О Абонента",
          RESIDENT_REFERENCE_MAHALLA: "Махалля",
          RESIDENT_REFERENCE_ADDRESS: "Адрес",
          RESIDENT_REFERENCE_INHB: "Количество проживающих",
          RESIDENT_REFERENCE_PHONE: "Телефон",
          RESIDENT_REFERENCE_COMPANY_DIRECTOR: "ДИРЕКТОР ООО",
          RESIDENT_REFERENCE_COMPANY_COMPANY: "Организация",
          RESIDENT_REFERENCE_COMPANY_BANK_NAME: "Наим.банка",
          RESIDENT_REFERENCE_COMPANY_INN: "ИНН",
          RESIDENT_REFERENCE_COMPANY_BANK_REK: "Банк.реквизиты",
          CHECKING_DATA_FROM_THE_HET_DATABASE:
            "Проверка данных из базы данных РЭС",
          CHANGE_HET_ACCOUNT_NUMBER: "Изменить номер счета РЭС",

          NOT_IDENTIFIED_RESIDENTS:
            "Обозначение абонента как неидентифицированного",
          IDENTIFIED_RESIDENTS: "Обозначение абонента как идентифицированного",
          IDENTIFIED_RESIDENTS_TEXT:
            "Вы действительно хотите выполнить это действие?",
          IDENTIFIED: "Идентифицированный",
          IDENTIFIED_DATE: "Дата идентификации",
          NOT_IDENTIFIED: "Не идентифицированный",
          CRITERIES: {
            TITLE: "Критерии идентификации",
            MAIN_TITLE: "Критерии для идентификации абонента",
            PASSPORT: {
              TITLE: "Паспорт:",
              PINFL_INFO1:
                "ПИНФЛ должен быть заполнен, состоять из 14 символов, а также корректно содержать дату рождения в позициях с 2-й по 7-ю цифру;",
              PINFL_INFO2:
                "Серия и номер паспорта должны быть заполнены: серия — из 2 латинских букв, номер — из 7 цифр;",
            },
            CADASTRAL: {
              TITLE: "Кадастр:",
              CADASTRAL_INFO1:
                "Кадастровый номер должен быть заполнен, содержать не менее 15 символов и включать как минимум 4 двойные точки;",
              CADASTRAL_INFO2:
                "Кадастровый код должен соответствовать коду региона;",
              CADASTRAL_INFO3: "Кадастровый номер не должен быть дубликатом;",
            },
            HET: {
              TITLE: "РЭС:",
              HET_INFO1:
                "COATO и расчетный счет должны быть введены, COATO должен состоять из 5 символов и соответствовать району;",
              HET_INFO2:
                "Расчетный счет должен быть зарегистрирован в системе;",
              HET_INFO3:
                "Расчетный счет в системе должен соответствовать счету в РЭС (проверяется через интеграцию);",
              HET_INFO4:
                "COATO и расчетный счет не должны повторяться (за исключением субабонентов);",
            },
            PERSONAL_IMAGE: {
              TITLE: "Личное фото:",
              PERSONAL_IMAGE_INFO1: "Должно быть загружено личное фото;",
              PERSONAL_IMAGE_INFO2:
                "Имя файла фото должно содержать ПИНФЛ и номер паспорта гражданина;",
            },
          },

          TABLE_HEADERS: {
            ID: "ID",
            PERIOD: "Период",
            KVIT_DATE: "Дата квит.",
            KVIT_NO: "№ квит.",
            SUM: "Сумма",
            PAYER_FIO: "Плательщик Ф.И.О",
            PAYMENT_INFO: "Платежная информация",
            EMPLOYEE_INFO: "Ф.И.О. сотрудника",
            PACHKA_ID: "Пачка Id",
            DATE: "Дата",
          },

          HET_INTEGRATION: {
            TABLE_HEADERS: {
              COATO_CODE: "Код СОАТО",
              ELECTRICITY_ACCOUNT_NUMBER: "Номер счета электроэнергии",
              FULL_NAME: "Ф.И.О",
              ADDRESS: "Адрес",
              MAHALLA: "Махалля",
              PHONE: "Телефон",
              PINFL: "ПИНФЛ",
              PASSPORT: "Паспорт",
              INN: "ИНН",
              CADASTRAL_NUMBER: "Кадастровый номер",
            },
          },
        },
        MODAL: {
          ADD_TITLE: "Добавление абонента",
          EDIT_TITLE: "Редактирование абонента",
          DELETE_TITLE: "Удаление абонента",
          DELETE_TEXT:
            "Вы действительно хотите удалить выбранного абонента из системы?",
          DELETE_MULTIPLE_TITLE: "Удаление абонентов",
          DELETE_MULTIPLE_TEXT:
            "Вы действительно хотите удалить выбранних абонентов из системы?",
          BUTTONS: {
            EXIT: "Назад",
            ADD: "Сохранить",
            NEXT: "Вперед",
            BACK: "Назад",
          },
          PRINT_CONTRACT: "Печать контракта",
          PRINT_ACT: "Печать акта",
          FILE_ADD: "Добавить файл:",
          TYPE: "Тип:",
          IMPORT: "Импорт",
          COUNTRY: "Страна:",
          REGION: "Регион:",
          DISTRICT: "Район:",
          VILLAGE: "Махалля:",
          STREET: "Улица:",
          HOME_NUMBER: "Номер дома:",
          FULL_ADDRESS: "Полный адрес:",
          REGISTER_DATE: "Дата регистрации:",
          PASSPORT_NUMBER: "Номер паспорта:",
          PNFL: "ПИНФЛ:",
          STIR: "СТИР:",
          CADASTRAL_NUMBER: "Введите кадастровый номер:",
          COMPANY: "Компания:",
          INHABITANT_CNT: "Количество жителей:",
          IMPORT_RESIDENTS: "Абонентов",
          INN: "ИНН",
          PASSPORT: "Паспортные данные",
          CADASTR: "Кадастровый номер",
          FISH: "Ф.И.О",
          PHONE: "Номер телефона",
          RESIDENT_CARD: "Абонентская карта",
          RESIDENT_CARD_PRINT: "Печать карту абонента",
          RESIDENT_REFERENCE_DOC: "Печать справку",
          CURRENT_PERIOD: "Текущий период",
          CURRENT_YEAR: "Текущий год",
          ALL_PERIOD: "Весь период",
          CURRENT_RESIDENTS:
            "Ввод в excel абонентов, отображающихся в данный момент на странице",
          ALL_RESIDENTS: "Ввод абонентов в excel по другим фильтрам",
          NOT_FOUND_PASSPORT_SYSTEM:
            "В системе Паспорт-Виза информация по данному ПИНФЛ не найдена!",
          UPDATE_RESIDENT_DATA: "Обновить данные",
          SEARCHING_SAME_RESIDENTS: "Поиск абонентов с данным ПИНФЛ",
          RESULT_OF_SEARCHED_RESIDENTS: "Количество абонентов с данным ПИНФЛ",
          SEE_ALL: "Посмотреть все",
          WITH_FROZEN_DEBT: "Данные о замороженной задолженности",
          FROM_MAHALLA: "Из какой махалли",
          TO_MAHALLA: "В какую махаллю",
          SELECT_RESIDENTS: "Выбрать абонентов",
          SELECT_MOVEABLE_RESIDENTS: "Выбрать абонентов для переноса",

          ATTENTION_NODE_1:
            "При переносе абонента он будет отвязан от предыдущей махалли и участка по сбору отходов.",
          ATTENTION_NODE_2:
            "Если предыдущая махалля была заморожена, то после переноса в новую махаллю абонент останется замороженным в текущем периоде. Если новая махалля не заморожена — абонент будет разморожен, начиная со следующего периода.",
          ATTENTION_NODE_3:
            "Если предыдущая махалля не была заморожена, а новая махалля заморожена — абонент в текущем периоде останется активным, но будет заморожен, начиная со следующего периода.",
        },
        MODAL_SEARCH_BY_IIB: {
          COUNTRY: "Страна",
          REGION: "Регион",
          DISTRICT: "Район",
          VILLAGE: "Махалля",
          STREET: "Улица",
          FULL_ADDRESS: "Полный адрес",
          REGISTRATION_DATE: "Дата регистрации",
          CADASTRE: "Номер кадастра",
          PERMANENT_RESIDENCE: "Постоянное место жительства",
          TEMPORARY_RESIDENCE: "Временное место жительства",
        },
        MODAL_CHEKING_PERSONS_OF_HOME: {
          WARNING_MESSAGES:
            "Произошла ошибка при извлечении данных из кадастровой базы!",
          MODAL_TITLE: "ПРОВЕРИТЬ ПРОЖИВАЮЩИХ ПО ПРОПИСКЕ",
          WARNING_MESSAGE_MVD: "Данные из базы МВД не найдены!",
          BUTTON: "Поиск",
          RESIDENTS_DETAIL: {
            NAME: "Ф.И.О",
            ABONENT_ADDRESS: "Полный адрес",
            CADASTRAL_NUMBER: "Кадастровый номер",
            PASSPORT: "№ паспорта",
            PNFL: "ПИНФЛ",
            TITLE:
              "Постоянные и временно зарегистрированные лица Главного управления регистрации миграции и гражданства (паспортно-визовая система",
          },
          PRINT_RESIDENT_TABLE: {
            NAME: "Ф.И.О",
            STATUS: "Статус абонента",
            PNFL: "ПИНФЛ",
            REGISTRATION_DATE: "Дата регистрации",
            DATE_EXCEPTIONS: "Дата исключения из списка",
            DATE_BIRTH: "Дата рождения",
            GENDER: "Пол",
            MALE: "Мужской",
            FEMALE: "Женский",
            ACTIVE: "Активный",
            OTHER_PLEASE_OUT: "Переехал на другой адрес",
            COURT_OUT: "Переехал по решению суда",
            OTHER_OUT: "Переезд на постоянное место жительства за границу",
            DEATH_OUT: "Выдано по причине смерти",
            PLEASE_OUT: "Выдается по требованию арендодателя",
            TEMPORARILY_REGISTERED: "Был во временном списке",
          },
        },
        MODAL_TAB: {
          TAB_1: "Паспортные данные",
          TAB_2: "Информация об абоненте",
        },
        INFORMATION_BASED_ON_PINFL_AND_CADASTRAL_NUMBER:
          "Поиск в кадастровой базе по ПИНФЛ",
        SEARCH_RESIDENT_BY_PINFL_FROM_MIA_DATABASE:
          "Поиск информации о гражданине в базе МВД через ПИНФЛ",
        CHANGE_RESIDENT_ELECTRCITY:
          "Дважды щелкните счет за электроэнергию, чтобы изменить счет за электроэнергию абонента!",
        ABONENT: "Клиент:",
        PERSON_COUNT: "Количество людей:",
        PERSON_COUNT_EDIT_ERROR:
          "У данного абонента нет баланса на текущий период!",
        PINFL_DELETED: "Данные ПИНФЛ абонента успешно удалены.",
        CADASTRAL_DELETED: "Кадастровый номер абонента успешно удалён.",
        PINFL_DELETED_MSG:
          "Вы действительно хотите удалить данные ПИНФЛ выбранного абонента из системы?",
        CADASTRAL_DELETED_MSG:
          "Вы действительно хотите удалить кадастровый номер выбранного абонента из системы?",
        RESIDENT_FILTER: {
          FILTER: "Фильтр",
          COMPANY_NAME: "Название компании",
          ACCOUNT_NUMBER: "Номер счета",
          RESIDENT_ID: "Абонент ID",
          ZONE: "Участок",
          VILLAGE: "Махалля",
          STREET: "Улица",
          RESIDENT_TYPE: "Тип абонента",
          HOME_TYPE: "Тип дома",
          HOUSE_NUMBER: "Дома",
          FLAT_NUMBER: "Кв",
          INHABITANT_CNT: "Количество жителей",
          ELECTRICITY_ACCOUNT_NUMBER: "Номер счета электричества",
          FULL_NAME: "Ф.И.О",
          OLD_ACCOUNT_NUMBER: "Старый номер счета",
          PHONE_NUMBER: "Номер телефона",
          SUBMIT_BUTTON: "Поиск",
          RESET_BUTTON: "Очистить",
          IDENTIFIED: "Статус идентификации",
          ACCOUNT_NUMBER_STATUS: "Статус номера счета",
          ACCOUNT_NUMBER_CHANGED: "Номер счета изменён",
          ACCOUNT_NUMBER_NOT_CHANGED: "Номер счета не изменён",
        },
        RESIDENTS_SEARCH: {
          REGION: "Регион",
          DISTRICT: "Район",
          TITLE: "Поиск абонента",
          JURIDICAL_SUBS: "Юридические лица",
          PHYSICAL_SUBS: "Физические лица",
          RESIDENT_ID: "Абонент ID",
          COMPANY_NAME: "Название компании",
          ACCOUNT_NUMBER: "Лицевой счет",
          OLD_ACCOUNT_NUMBER: "Старый лицевой счет",
          RESIDENT_FIO: "Ф.И.О абонента",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          HOUSE_NUMBER: "Дом",
          FLAT_NUMBER: "Кв",
          INDEX: "Индекс",
          INN: "ИНН",
        },
        INCORRECT_RESIDENT_DATA: {
          FILTER_BY_RESIDENTS: "Фильтр по абонентам",
          OPTIONS: {
            PASSPORT_INFORMATION_IS_INCORRECT: "Паспортные данные неверны",
            THE_CADASTRAL_NUMBER_IS_INCORRECT: "Кадастровый номер неверен",
            PHONE_NUMBER_NOT_ENTERED: "Номер телефона не указан",
            ADDRESS_INFORMATION_IS_INCORRECT: "Адресные данные неверны",
            NO_ELECTRICAL_INFORMATION_INCLUDED:
              "Информация об электроэнергии отсутствует",
          },
          ERROR_OPTIONS: {
            TITLE: "Ошибки",
            PASSPORT_NOT_PROVIDED: "Паспорт не указан",
            PASSPORT_INVALID_LENGTH:
              "Номер паспорта должен состоять из 9 символов",
            PASSPORT_INVALID_LETTER_FORMAT:
              "Первые 2 символа паспорта должны быть заглавными буквами",
            PASSPORT_INVALID_NUMBER_FORMAT:
              "Последние 7 символов паспорта должны быть цифрами",
            PNFL_NOT_PROVIDED: "ПИНФЛ не указан",
            PNFL_INVALID_LENGTH: "ПИНФЛ должен состоять из 14 цифр",
            PNFL_INVALID_FORMAT: "ПИНФЛ должен содержать только цифры",
            BIRTH_DATE_NOT_PROVIDED: "Дата рождения не указана",
            BIRTH_DATE_FUTURE: "Дата рождения не может быть в будущем",
            CADASTRAL_NUMBER_NOT_PROVIDED: "Кадастровый номер не указан",
            CADASTRAL_NUMBER_INVALID_FORMAT:
              "Неверный формат кадастрового номера",
            CADASTRAL_NUMBER_REGION_CODE_MISMATCH:
              "Код области в кадастровом номере не совпадает",
            CADASTRAL_NUMBER_DISTRICT_CODE_MISMATCH:
              "Код района в кадастровом номере не совпадает",
            CADASTRAL_NUMBER_DUPLICATE: "Кадастровый номер уже используется",
            STREET_NOT_SELECTED: "Улица не выбрана",
            MAHALLA_NOT_SELECTED: "Махалля не выбрана",
            ELECTRICITY_ACCOUNT_NOT_PROVIDED:
              "Лицевой счет по электроэнергии не указан",
            PHONE_NUMBER_NOT_PROVIDED: "Номер телефона не указан",
            ELECTRICITY_ACCOUNT_INVALID_LENGTH:
              "Неверная длина лицевого счёта за электроэнергию",
            ELECTRICITY_ACCOUNT_INVALID_FORMAT:
              "Неверный формат лицевого счёта за электроэнергию",
            ELECTRICITY_ACCOUNT_ALL_ZEROS:
              "Лицевой счёт не может состоять только из нулей",
          },
          DUPLICATES: {
            TITLE: "Ошибка при идентификации",
            DUPLICATE_FOUND: "Обнаружен дубликат абонента",
            DUPLICATE_FOUND_VALUE: "Найдено {{value}} дубликат(ов) абонента",
            RESIDENT_ID: "ID абонента",
            DUPLICATE_RESIDENT_ID: "ID дубликата абонента",
            CADASTRAL_NUMBER: "Кадастровый номер",
            DUPLICATE_CADASTRAL_NUMBER: "Дубликат кадастрового номера",
            COMPANY_NAME: "Название организации",
            DISTRICT: "Район",
            ACCOUNT_NUMBER: "Номер счета",
          },
        },
        NON_EXISTENT_RESIDENTS_IN_SYSTEM: {
          PNFL: "ПИНФЛ",
          INN: "ИНН",
          CADASTRAL_NUMBER: "Кадастровый номер",
          FISH: "Ф.И.О",
          ALL: "Все",
          IS_EXISTENT_IN_SYSTEM: "Существует в системе",
          IS_NOT_EXISTENT_IN_SYSTEM: "Не существует в системе",
          IS_NOT_EXISTENT_IN_SYSTEM_EXCEL_DOWNLOAD:
            "Абоненты, полученные из налоговой (Excel).xlsx",

          TABLE_HEADERS: {
            ID: "ID",
            FISH: "Ф.И.О",
            PNFL: "ПИНФЛ",
            INN: "ИНН",
            CADASTRAL_NUMBER: "Кадастровый номер",
            ADDRESS: "Адрес",
            HOUSE_TYPE: "Тип дома",
          },
        },
      },
      IIB_SINXRONIZATSIYA: {
        TABLE_HEADERS: {
          DISTRICT_NAME: "Район",
          CREATED_USER_NAME: "Пользователь, который начал синхронизацию",
          CREATED_AT: "Дата начала",
          FINISHED_AT: "Дата завершения",
          TOTAL_COUNT: "Всего",
          SUCCESS_COUNT: "Успешно",
          FAILED_COUNT: "Неудачно",
          OLD_MIA_INHABITANT_COUNT: "Количество жителей в МВД до обновления",
          NEW_MIA_INHABITANT_COUNT: "Количество жителей в МВД после обновления",
          OLD_ACCRUAL_AMOUNT: "Старые начисления",
          NEW_ACCRUAL_AMOUNT: "Новые начисления",
          DIFFERENCE: "Разница",
        },
        TABLE_HEADERS_OLD: {
          NAME: "Название",
          RESIDENT_COUNT: "Количество абонентов",
          MIA_INHABITANT_COUNT: "Количество проживающих по данным МВД",
          RESIDENT_INHABITANT_COUNT: "Количество жителей в системе",
          SYNCHRONIZATION: "Синхронизация",
          STATUS: "Статус",
          FINISHED: "Завершено",
          IN_PROGRESS: "В процессе",
        },
        MODAL: {
          SYNC_HISTORY: "{{title}} - История синхронизации",
          TITLE: "Синхронизация с МВД",
          TEXT: "Вы действительно хотите выполнить синхронизацию с МВД?",
          BUTTON: "Начать синхронизацию",
          SUCCESS_MESSAGE: "Синхронизация успешно выполнена!",
        },
      },
      BLOCKED_RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          BLOCK_DATE: "Дата блокировки",
          COATO: "СОАТО",
          CUSTOMER_CODE: "Код клиента",
          ACCOUNT_NUMBER: "Номер счета",
          STATUS: "Статус",
          SALDO: "Сальдо",
          MESSAGE: "Сообщение",
          SEND_SMS_WARNING_STATUS: "Статус SMS-сообщения",
          WARNING_DATE: "Дата уведомления",
          CURRENT_DEBT: "Текущая задолженность",
          CURRENT_YEAR_DEBT: "Долг текущего года",
          CURRENT_YEAR: "Текущий год",
          PAYMENT: "Оплата",
          ACT_PAYMENT: "Акт оплаты",
          UNBLOCK_REASON: "Причина разблокировки",
          TOTAL_DEBT_COUNT: "Общее количество должников",
          WARNING_DEBT_SUM: "Сумма предупреждённого долга",
          WARNING_DEBT_COUNT: "Должники на предупреждение",
        },
        MODAL: {
          BLOCK_TITLE: "Блокировка абонента (ов)",
          UNBLOCK_TITLE: "Разблокировать абонента (ов)",
          WARNING_TITLE: "Предупреждение абонента (ов)",
          POTEMTIAL_WARNING_TITLE: "Абоненты, которых можно предупредить",
          ALL_DEBIT_WARNING: "Предупреждение всех должников",
          ALL_DEBIT_BLOCK: "Блокировать всех должников",
          CONFIRMATION_WARNING_TEXT: "Хотите предупредить абонента (ов)?",
          CONFIRMATION_BLOCK_TEXT: "Хотите заблокировать абонентов?",
          CONFIRMATION_ALL_DEBIT_WARNING_TEXT:
            "Хотите предупредить всех должников?",
          CONFIRMATION_UNBLOCK_TEXT: "Хотите разблокировать абонентов?",
          CONFIRMATION_ALL_DEBIT_BLOCK_TEXT:
            "Хотите заблокировать всех должников?",
          WARNING_RESIDENTS: "Предупреждённые абоненты",
          BLOCKED_RESIDENTS: "Заблокированные абоненты",
        },
        REPORT: {
          TOTAL_BLOCK_COUNT: "Количество всех заблокированных абонентов",
          TOTAL_DEBIT: "Общая сумма задолженности заблокированных абонентов",
          BLOCK_DEBIT:
            "Сумма задолженности заблокированных абонентов с 07.2025 по настоящее время",
          PAYMENT: "Платежи, произведённые заблокированными абонентами",
          PAYMENT_SUM:
            "Сумма платежей, совершённых заблокированными абонентами",
          ACT_PAYMENT: "Акты, составленные для заблокированных абонентов",
          ACT_PAYMENT_SUM:
            "Сумма актов, составленных для заблокированных абонентов",
          CREATED_COUNT: "Количество заявок на блокировку, созданных в системе",
          BLOCK_COUNT:
            "Количество абонентов, фактически находящихся в состоянии блокировки",
          UNBLOCK_COUNT: "Количество разблокированных абонентов",
          OPERATION_FAILED_COUNT: "Количество неудачных операций по блокировке",
          CANCEL_BLOCK_COUNT: "Количество отмен блокировки сотрудником",
          CANCEL_CONTRACT_COUNT: "Количество аннулированных договоров",
          NOT_FOUND_ELECTRICITY_ACCOUNT_COUNT:
            "Количество случаев, когда электрический лицевой счёт не определён в системе РЭС",
          SERVER_ERROR_MESSAGE_COUNT:
            "Количество сообщений, не отправленных из-за системных ошибок",
          CREATED: "Создано",
          BLOCK: "Заблокирован",
          ALREADY_BLOCKED_COUNT: "Количество уже заблокированных абонентов",
          UNBLOCK: "Разблокирован",
          OPERATION_FAILED: "Операция блокировки завершилась неудачно",
          CANCEL_BLOCK: "Блокировка отменена",
          CANCEL_CONTRACT: "Договор аннулирован",
          NOT_FOUND_ELECTRICITY_ACCOUNT: "Лицевой счёт не найден",
          SERVER_ERROR_MESSAGE: "Произошла ошибка при блокировке",
          USER_FULL_NAME: "Ф.И.О. сотрудника, отменившего блокировку",
          ERROR_WHEN_BLOCKING:
            "Абоненты, блокировка которых не была выполнена из-за ошибок",
          CANCEL_BLOCK_OPERATION:
            "Абоненты, для которых блокировка была отменена по определённым причинам",
          ALREADY_BLOCK: "Уже заблокирован",
        },
      },
      POTENSIAL_WARNING_RESIDENT: {
        TABLE_HEADERS: {
          ACCOUNT_NUMBER: "Номер счета",
          FULL_NAME: "Ф.И.О",
          K_SALDO: "Кон.сальдо {{date}}",
        },
      },
      CHANGING_ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATA: "Дата",
          NAME: "Наименование",
          COMPANY_NAME: "Название компании",
          NUMBER_ACTS: "Кол-во актов",
          ACTS_INCREASING_NUMBER: "Акты увеличения численности",
          ACTS_REDUCTION_NUMBER: "Акты сокращения численности",
          TOTAL: "Всего",
          APPROVED: "Утвержденный",
          CONTRACT_TERMINATED: "Договор расторгнут",
        },
      },
      OPERATIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Название компании",
          COMPLETED_TIME: "Время окончания",
          EXCEPTION_MESSAGE: "Cообщение о результате",
          EXECUTED_BY: "Выполнитель",
          OPERATION_STATUS: "Статус",
          PERIOD: "Период",
          START_TIME: "Время начала",
        },
        MODAL: {
          CONFIRMATION_TEXT: "Перерасчет текущего периода",
        },
      },
      CASH_PAYMENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Дата",
          COMPANY_NAME: "Предприятие",
          CHECKSUM: "Контрольная сумма",
          TERMINAL: "Терминал",
          CASH: "Наличные",
          PACKAGE_SUMM: "Пачка цена",
          TOTAL: "Общий",
          SPECIAL_PACKAGE: "Специальная пачка",
          WEBSITE: "Веб-сайт",
          MOBILE: "Мобил",
          ANDROID: "Андроид",
          STATUS: "Статус",
          FROM_BANK: "Из банка",
          PACKAGE_DESCRIPTION: "Описание пачка",
          USER_FULLNAME: "Пользователь Ф.И.О",
          ADDRESS: "Адрес",
          INHABITANT_CNT: "Количество жителей",
          CONTRACT_DATE: "Дата договора",
          K_SALDO: "Кон.сальдо",

          //CASH-PAYMENT-ENTITY
          PERIOD: "Период",
          ACCOUNT_NUMBER: "Лицевой счет",
          SUM: "Сумма",
          KVIT_DATE: "Дата квитанции",
          PAYMENT_INFO: "Детали платежа",
          PAYMENT_TYPE: "Тип платежа",
          KVIT_NO: "№ квит.",
          RESIDENT_FIO: "Ф.И.О. абонента",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          KVIT_TYPE: "Тип квитанции",
          HOUSE: "Дом",
          APARTMENT: "Квартира",
          INDEX: "Инд",
          PAYER: "Ф.И.О. плательщика",
          EMPLOYEE_INFO: "Ф.И.О. сотрудника",
          ALL: "Все",
          TO_CART: "Переход на карту",
          PACHKA_ID: "ID пачки",
          FILE_ID: "Прикрепленный файл",
        },
        ACTIONS: {
          CREATE_PACHKA: "Новая пачка",
          POSTING: "Разноска",
        },
        STATUS: {
          ACTIVE: "Да",
          INACTIVE: "Нет",
        },
        MODAL: {
          TITLE: "Добавление нового пачка",
          TITLE_UPDATE: "Редактирования пачка",
          DOWNLOAD_EXCEL: "Скачать Excel",
          EDIT_KVIT: "Редактирование квитанцию",
          DELETE_CONFIRMATION:
            "Вы действительно хотите удалить выбранную квитанцию из системы?",
          DELETE_TITLE: "Удаление квитанции",

          DELETE_PACK_CONFIRMATION:
            "Вы действительно хотите удалить выбранный пачка из системы?",
          DELETE_PACK_TITLE: "Удаление пачка",
          NEW_RECEIPT: "Новая квитанция",

          // ADDITIONAL ASIDE
          RESIDENT_SEARCH: "Поиск абонента",
          RESIDENT_HOUSE: "Дом",
          RESIDENT_INDEX: "Инд.",
          RESIDENT_APARTMENT: "Кв.",
          COMPANY_NAME: "Название компании",
          OLD_ACCOUNT_NUMBER: "Старый номер счета",
          MAHALLA: "Махалля",
        },
        FORM: {
          CREATED_DATE: "Дата",
          CONTROL_SUM_AMOUNT: "Контр. сумма",
          STATUS: "Cтатус",
          STATUS_SPECIAL_PACK: "Спец.пачка",
          STATUS_IS_BANK_CREATED: "Банковские",
          INSPEKTOR: "Инспектор",
          COMMENT: "Комментарий",
          COMPANY_NAME: "Название компании",
          PAYMENT_PARTNERS: "Платежные партнеры",
          KVIT_NO: "№ квит.",
          SUM: "Сумма",
          PAYMENT_TYPE: "Тип платежа",
          PAYMENT_PURPOSE: "Детали платежа",
          FILE_ATTACHMENT: "Прикрепить файл",
          KVIT_TYPE: "Тип квитанции",
          RESIDENT_FIO: "Ф.И.О абонента",
          RESIDENT_PHONE: "Телефон абонента",
        },
        EXCEL: "Наличные расчеты",
      },
      ACT_PACK: {
        TABLE_HEADERS: {
          ID: "ID",
          USER_ID: "Пользователь Ф.И.O",
          RESIDENT_FIO: "Ф.И.О абонента",
          COMPANY_NAME: "Название компании",
          PACK_TYPE_ID: "Тип пачки",
          NAME: "Hаименование",
          STATUS: "Статус",
          CONTROL_LIMIT: "Контрольный номер",
          IS_SPECIAL_PACK: "Специальная пачка",
          CREATED_DATE: "Дата создания",
          ACTS_COUNT: "Количество актов",
          ACT_AMOUNT_SUM: "Сумма актов",
          ACT_CREDIT_COUNT: "Кредиторская задолженность",
          ACT_DEBIT_COUNT: "Дебиторская задолженность",
          ACT_CREDIT_AMOUNT_SUM: "Кредиторская Задолженность (Сумма)",
          ACT_DEBIT_AMOUNT_SUM: "Дебиторская Задолженность (Сумма)",
          INVENTORY_COUNT: "Первичный инвентарь.",
          INVENTORY_AMOUNT_SUM: "(Сумма) первичного инвентаря",
          FILE_ID: "Прикрепленный файл",
          DESCRIPTION: "Комментарий",
        },
        MODAL: {
          NAME: "Наименование:",
          CREATED_DATE: "Дата:",
          DESCRIPTION: "Комментарий:",
          COMPANY_ID: "Компания:",
          PACK_TYPE_ID: "Тип пачки:",
          FILE_ID: "Прикрепленный файл:",
          CONTROL_LIMIT: "Контрольный номер:",
          SELECT_STATUS: "Статус:",
          IS_SPECIAL_PACK: "Специальная пачка:",
          CHOOSE_ACT_PACK: "Выберите пакет действий",

          MODAL_TITLE: "Добавление нового пачка действий",
          UPDATE_MODAL: "Редактирование пачка действий",
          FILE_ATTACHMENT: "Прикрепить файл",
          DELETE_MODAL: "Удаление пачка актов",
          EXCEL_TITLE: "Пачка актов {{date}}",
          ACTS_EXCEL_TITLE: "Акты {{date}}",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный пачка актов из системы?",
          TOAST_DELETE: "Выбранный пачка актов успешно удален!",
          TOAST_SUCCESS: "Новый пачка актов успешно добавлен!",
          TOAST_UPDATE: "Выбранный пачка актов успешно изменен!",
        },
        ACT_PACK_TYPES: {
          SIMPLE: "Оплата не поступила",
          SERVICE_NOT_PROVIDED: "Не обслуживается",
          SPECIAL: "Специальный",
          CANCEL_CONTRACT: "Расторжение договора",
          INVENTORY: "Изменение количества человек",
          MIB: "Автор Mib",
          ECO_PAY_INVENTORY: "Ecopay для инвентаря",
          FROZEN: "Замороженная задолженность",
        },
        ACTS: {
          TABLE_HEADERS: {
            ID: "ID",
            ACT_NUMBER: "Номер акта",
            ACT_PACK_ID: "Пачка актов",
            PACK_TYPE_ID: "Тип пачки",
            RESIDENT_ID: "Абонент",
            STATUS: "Статус",
            ACT_TYPE_ID: "Тип акта",
            AMOUNT: "Сумма",
            USER_ID: "Пользователь Ф.И.О",
            UPDATED_BY_FULL_NAME: "Пользователь, который обновил Ф.И.О",
            UPDATED_AT: "Дата обновления",
            FILE_ID: "Прикрепленный файл",
            ACT_ACTION_ID: "Действие акта",
            OLD_INHABITANT_COUNT: "Количество предыдущих жителей",
            START_PERIOD: "Период начала",
            END_PERIOD: "Конечный период",
            CURRENT_INHABITANT_COUNT: "Количество новых жителей",

            DESCRIPTION: "Комментарий",

            CREATED_AT: "Дата создания",
            CREATED_BY: "Пользователь, который создал",

            CONFIRMED_AT: "Дата утверждения",
            CONFIRMED_BY: "Проверенный пользователь",

            WARNED_AT: "Дата уведомления",
            WARNED_BY: "Предупрежденный пользователь",
            WARNING_CONCLUSION: "Краткое содержание предупреждения",

            CANCELLED_AT: "Дата отмены",
            CANCELLED_BY: "Пользователь, который отменил",
            CANCELLATION_CONCLUSION: "Заключение об отмене",
          },
          MODAL: {
            WARNING_TITLE: "Вы не можете выбрать более 100 действий!",
            FILTER_RESIDENT_TITLE: "Показаны первые 50 результатов",

            MODAL_TITLE: "Добавление нового акта",
            UPDATE_MODAL: "Редактировать акт",
            DELETE_MODAL: "Удаление акта",

            CHECK_MODAL: "Утверждение акта",
            APPROVED_MODAL: "Принятие актов",
            WARNING_MODAL: "Предупреждение",
            CANCEL_MODAL: "Отмена акта",

            DELETE_MODAL_SUBTITLE:
              "Вы действительно хотите удалить выбранный акт из системы?",
            CHECK_MODAL_SUBTITLE:
              " Вы действительно хотите подтвердить выбранный акт?",
            APPROVED_MODAL_SUBTITLE:
              "Вы действительно хотите принять выбранные акты?",
            CANCEL_MODAL_SUBTITLE:
              "Вы действительно хотите отменить выбранные акты?",
            WARNING_MODAL_SUBTITLE:
              "Вы действительно хотите предупредить выбранные акты?",
            FILD_REQUARED_TITLE:
              "Не нужно загружать файл для текущего периода!!",

            CONFIRMED_SUCCESS: "Выбранные действия были успешно подтверждены",
            WARNING_SUCCESS: "Отдельные действия были успешно предупреждены",
            CANCELLED_SUCCESS: "Выбранные действия были успешно отменены",
            NO_PERMISSION: "У вас нет разрешения на это действие",

            TOAST_DELETE: "Выбранный акт успешно удален!",
            TOAST_SUCCESS: "Новый акт успешно добавлен!",
            TOAST_UPDATE: "Выбранный акт успешно изменен!",
            SUCCESS: "Действие выполнено успешно!",

            ACT_NUMBER: "Номер акта:",
            ACT_PACK_ID: "ID пачки актов:",
            PACK_TYPE_ID: "Пачка тури:",
            RESIDENT_ID: "Абонент:",
            STATUS: "Тип акта:",
            AMOUNT: "Сумма:",
            FILE_ID: "Прикрепленный файл:",
            DESCRIPTION: "Комментарий:",
            MAIN: "Основание",
            INHABITANTS_CNT: "Количество жителей:",
            CURRENTLY_INHABITANTS_CNT: "Текущее количество жителей:",
            DATA_PERIOD: "Период данных:",
            DATA_PERIOD_TO: "Период данных до:",
            ACT_SUM_BY_QQS: "Сумма акта по периоду НДС:",
            ACT_SUM_NO_QQS: "Сумма акта без НДС:",
            TOTAL_ACT_SUM: "Общая сумма акта:",
            SHOW_PERIOD: "Давр бўйича",
            K_SALDO: "Кон.сальдо",
            PERIOD_SALDO: "Сальдо на начало периода:",
            PERIOS_N_SALDO: "Сальдо до конца периода:",
            ADDRESS: "Адрес:",
            THIS_PERIOD_ACT_AMOUNT: "Сумма акта за текущий период:",
          },
        },
        EXCEL: "Пачка оплаты наличными",
      },
      TARIFFS: {
        TARIFFS_POPULATION: {
          TITLE: "Население",
          DESC: "1 месяц на 1 человека",
        },
        TARIFFS_JURIDICAL_SUBS: {
          TITLE: "Юридические лица",
          DESC: "за 1м3 отходов",
        },
        TARIFFS_JURIDICAL_SUBS_BUDGET: {
          TITLE: "Юридические лица (Бюджет)",
          DESC: "за 1м3 отходов",
        },
        FORM: {
          QQS: "НДС:",
          RATE_WITH_QQS: "Стоимость (с НДС)",
          NEW_TARIFF: "Новый тариф",
          CATEGORY_SELECT: "Категория:",
          COMPANY_SELECT: "Компания:",
          START_DATE: "Начало:",
          END_DATE: "Конец:",
          RATE: "Цена:",
          SMCH_RATE: "ТБО Цена:",
          QMCH_RATE: "ЖБО Цена:",
          POLIGON_RATE: "Полигон Цена:",
          NAME_UZ: "Название тарифа:",
          NAME_RU: "Название тарифа:",
          NAME_CRL: "Название тарифа:",
          NAME_EN: "Название тарифа:",
          DESCRIPTION_UZ: "Описание тарифа:",
          DESCRIPTION_RU: "Описание тарифа:",
          DESCRIPTION_CRL: "Описание тарифа:",
          DESCRIPTION_EN: "Описание тарифа:",
        },
        MODAL: {
          ADD_SERVICE: "Дополнительные услуги:",
          MODAL_TITLE: "Добавление нового тарифа ",
          UPDATE_MODAL: "Редактирование тарифа ",
          DELETE_MODAL: "Удаление тарифа ",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный тариф из системы?",
          TOAST_DELETE: "Выбранный тариф успешно удален!!",
          TOAST_SUCCESS: "Новый тариф добавлен успешно!",
          TOAST_UPDATE: "Тариф успешно обновлен!",
        },
      },
      PLANS: {
        POPULATION: {
          TABLE_NAME: "Население",
          TABLE_HEADERS: {
            ID: "ID",
            NAME: "Наименование",
            START_DATE: "Начало",
            END_DATE: "Конец",
            RATE: "Цена",
            ADD_SERVICE: "Дополнительные услуги",
            SMCH_RATE: "ТБО(м\u00B3)",
            QMCH_RATE: "ЖБО(тонна)",
            POLIGON_RATE: "Полигон(м\u00B3)",
            DESCRIPTION: "Комментарий",
            ACTION: "Действие",
          },
        },
        LEGAL_S: {
          TABLE_NAME: "Юридические лица",
        },
        LEGAL_S_B: {
          TABLE_NAME: "Юридические лица (Бюджет)",
        },
        MODAL: {
          PLAN: "Выберите категорию:",
          START_DATE: "Начало:",
          END_DATE: "Конец:",
          RATE: "Цена:",
          ADD_SERVICE: "Дополнительные услуги:",
          SMCH_RATE: "ТБО Цена:",
          QMCH_RATE: "ЖБО Цена:",
          POLIGON_RATE: "Полигон Цена:",
          NAME_UZ: "Название тарифа:",
          NAME_RU: "Название тарифа:",
          NAME_CRL: "Название тарифа:",
          NAME_EN: "Название тарифа:",
          DESCRIPTION_UZ: "Описание тарифа:",
          DESCRIPTION_RU: "Описание тарифа:",
          DESCRIPTION_CRL: "Описание тарифа:",
          DESCRIPTION_EN: "Описание тарифа:",
          MODAL_TITLE: "Добавление нового тарифа ",
          UPDATE_MODAL: "Редактирование тарифа ",
          DELETE_MODAL: "Удаление тарифа ",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный тариф из системы?",
          TOAST_DELETE: "Выбранный тариф успешно удален!!",
          TOAST_SUCCESS: "Новый тариф добавлен успешно!",
          TOAST_UPDATE: "Тариф успешно обновлен!",
        },
      },
      APPEAL: {
        APPEAL_BUTTON: "Видеть",
        APPEAL_TEXT: "Текст заявления",
        REJECT_TEXT: "Текст отказа от ответственности",
        ANSWER_TEXT: "Введите текст ответа",
        ANSWER: "Текст ответа",
        FILE_ATTACHMENT: "Прикрепить файл",
        TABLE_HEADERS: {
          ID: "ID",
          ABONENT_FIO: "Ф.И.О заявителя",
          ABONENT_LICSHET: "Лицевой счет",
          REQUEST_TYPE_NAME: "Тип запроса",
          ABONENT_REQUEST_STATUSES_ID: "Статус",
          PHONE: "Tелефон",
          ABONENT_AREA: "Район",
          ABONENT_COMPANY: "Название компании",
          ABONENT_ADRES: "Адрес",
          EMAIL: "E-mail",
          CHANNEL: "Канал",
          CREATED_DATE: "Дата поступления",
          ACCEPTED_DATE: "Дата приема",
          EXECUTED_DATE: "Дата выполнения",
          CANCELED_DATE: "Дата отмены",
        },
        ADDRESS: "Адрес",
        SELECT: {
          APPLICATIONS_STATUS: "Статус заявки",
          APPLICATIONS_TYPE: "Тип заявки",
          COMPANY_NAME: "Название компании",
          NEIGHBORHOOD: "Махалля",
        },
        CAN_NOT_ACCEPT: "Вы не можете принять апелляцию",
        CAN_NOT_REJECT: "Вы не можете отклонить апелляцию",

        SUBMIT_ANSWER: "Отправить ответ",
        REJECT_REQUEST: "Редактирование предложения",
        EDIT_APPLICATION: "Редактирование предложения",
        CREATED: "Создано (в очереди)",
        ACCEPTED: "Принято (в стадии изучения)",
        COMPLETED: "Выполнено",
        CANCELLED: "Отменено",
        SYSTEM_CANCELLED: "Отменено системой",
        BUTTONS_ACCEPTANCE_APPLICATION: "Прием заявки",
        ACCEPTED_CONFIRMATION_TEXT: "Действительно хотите принять апелляцию?",
        BUTTONS_REFUSAL_APPLICATION: "Отказ от заявки",
        REJECTED_CONFIRMATION_TEXT: "Действительно хотите отклонить апелляцию?",
        GO_TO_CARD: "Перейти на карту",
        WRITE_ANSWER: "Напишите ответ",
        DELETE_MODAL: "Удалить заявку",
        DELETE_MODAL_SUBTITLE:
          "Вы действительно хотите удалить выбранную заявку из системы?",
        TOAST_DELETE: "Выбранная заявка успешно удалена!",
        TOAST: {
          REJECT_REQUEST: "Действие выполнено успешно!",
          SUBMIT_ANSWER: "Действие выполнено успешно!",
        },
        RESIDENT_FILTER: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCEPTED_DATE: "Дата приема",
            ACCOUNT_NUMBER: "Номер счета",
            CANCELED_DATE: "Дата отмены",
            CHANNEL: "Канал",
            COMPLETED_AT: "Дата выполнения",
            CREATED_AT: "Дата создания",
            DISTRICT: "Район",
            EMAIL: "E-mail",
            FIRST_NAME: "Имя",
            LAST_NAME: "Фамилия",
            MAHALLA_NAME: "Махалля",
            ONLINE_APPEAL_STATUS: "Статус заявки",
            ONLINE_APPEAL_TYPE: "Тип заявки",
            PATRONYMIC: "Отчество",
            PHONE: "Телефон",
            RESIDENT_ID: "Абонент ID",
            STREET: "Улица",
          },
        },
        MODAL_GEOLOCATION: "Посмотреть на карте",
        TITLE_ASIDE_DETAIL: "Заявления",
        DOWNLOAD_FILE: "Прикрепленный файл",
        APPEAL_FILE: "Справочные файлы",
      },
      MY_GOV_APPEAL: {
        TABLE_HEADERS: {
          APPLICATION_NUMBER: "Номер заявления",
          ABONENT_FIO: "Ф.И.О. автора обращения",
          ABONENT_LICSHET: "Номер счёта абонента",
          ABONENT_REQUEST_STATUSES_ID: "Статус запроса",
          ANSWER: "Текст ответа",
          ACCEPTED_DATE: "Дата передачи в исполнение",
          ACCEPTED_FULL_NAME: "Ф.И.О. исполнителя",
          COMPLETED_DATE: "Дата выполнения",
          COMPLETED_FULL_NAME: "Ф.И.О. завершившего",
          CANCELLED_DATE: "Дата отмены",
          CANCELLED_FULL_NAME: "Ф.И.О. отменившего",
          COMMENT_CREATED_DATE: "Дата создания в MyGov",
          MY_GOV_ACCOUNT_NUMBER: "Номер счёта заявителя",
          COMMENT: "Текст заявления",
          CREATED_DATE: "Дата создания в системе",
        },
        FILTER: {
          PLACEHOLDER_ACCOUNT_NUMBER: "Счет номер",
        },
        ACCEPTED_TO: "Сосредоточение внимания на исполнении",
        ANSWER_TO: "Обратная связь",
        CREATED: "Создано (Очередь)",
        ACCEPTED: "Принято",
        ERROR: "Ошибка",
        COMPLETED: "Выполнено",
        CANCELLED: "Отменено",
        BUTTONS_ACCEPTANCE_APPLICATION: "Принятие",
        ACCEPTED_CONFIRMATION_TEXT: "Вы действительно хотите подать апелляцию?",
        BUTTONS_ANSWER_APPLICATION: "Написание ответа",
      },
      ORG_EMPLOYEES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          COMPANY_NAME: "Название компании",
          FIO: "Ф.И.О",
          JOB_TITLE: "Должность",
          EMAIL: "E-mail",
          PHONE: "Телефон",
          LOGIN: "Логин",
          ATTACHED_FILE: "Прикрепленный файл",
          STATUS: "Статус",
          ADDRESS: "Адрес",
          ROLE_DESCRIPTION: "Описание роли",
        },
        JOB_TITLE: {
          TITLE_1: "Управление",
          TITLE_2: "Водитель",
          TITLE_3: "Инспектор",
          TITLE_4: "Оператор",
          TITLE_5: "Бухгалтер",
          TITLE_6: "Оператор Центра",
          TITLE_7: "Инспектор Центра",
          TITLE_8: "DXSH",
        },
        ACTION: {
          ADD_EMPLOYEES: "Добавить сотрудника",
          CHANGE_DATA: "Изменить данные",
          CHANGE_PASSWORD: "Изменить пароль",
        },
        STATUS: {
          ACTIVE: "Aктивный",
          INACTIVE: "Неактивный",
          BUTTON: "Новый",
        },
        ORG_EMPLOYEES_MODAL: {
          TITLE: "Добавить сотрудника",
          TITLE_2: "Редактировать информацию о сотрудниках",
          FISH: "Ф.И.О :",
          TABEL_NUMBER: "Табельный номер:",
          ADDRESS: "Адрес:",
          COMMENT: "Комментарий:",
          FILE: "Файл вложение:",
          SELECT_FILE: "Выберите файл",
          EMPLOYEE: "Удалить выбранного сотрудника",
          CONFORMATION:
            "Вы действительно хотите удалить сотрудника из системы?",
          CONFIRMATION_MODAL_TEXT: "Выбранный сотрудник успешно удален!",
          SUBMIT_MODAL: "Сотрудник успешно добавлен!",
          SUBMIT_MODAL_EDITED: "Выбранный сотрудник успешно изменен!",
        },
        ENGANGE: {
          TITLE: "Список махаллей, прикрепленных к инспектору",
          BUTTON: "Разделение",
          MAHALLA_NAME: "Название махалли",
          ACTION: "Действие",
          ENGANGE_MODAL_TITLE: "Добавление махалли",
        },
        EMPTY_COMPONENT: {
          TITLE: "Информация о сотруднике",
          TEXT: "Выберите абонента из списка",
        },
        TOAST_SUCCESS: {
          TITLE: "Действие выполнено успешно!",
        },
        DELETE_MODAL: {
          TITLE: "Разделение окрестностей",
          TEXT: "Хотите удалить этот элемент?",
        },
      },
      PAYMENTS: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DATE: "Период",
          HOUSE_NUMBER: "Дом",
          FLAT_NUMBER: "Кв",
          TERMINAL_NUMBER: "По терминалу",
          FACIAL: "Лицевой",
          ZIPCODE: "Индекс",
          PAID: "Оплачено",
          PAID_CANCELED: "Не оплачено",
          TRANSACTION_TIME: "Время транзакции",
          SUM: "Сумма",
          CHECKSUM: "Контрольная сумма",
          USER_FULLNAME: "Ф.И.О абонента",
          TRANSACTION: "Транзакция",
          FILE: "Файл",
          PARTNER_PAYMENT_NAME: "Платежный партнер",
          STATUS: "Cтатус",
          NEIGHBORHOOD: "Махалля",
          STREET: "Улица",
          ACTION: "Действия",
        },
        MODAL: {
          DELETE_MODAL: "Удалить платеж",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный платеж из системы?",
          TOAST_DELETE: "Выбранный платеж успешно удален!",
        },
      },
      VILLAGES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DISTRICTS: "Район",
          NAME: "Наименование",
          INSPECTOR_FULLNAME: "Ф.И.О. инспектора",
          CREATED_BY_USER: "Создавший пользователь",
          DATE_OF_CREATION: "Дата создания",
          COMMENT: "Комментарий",
          ACTION: "Движение",
        },
      },
      COURT_WARNING: {
        COURT_CREATE: "Время предупреждения",
        COURT_UPDATE: "Обновленное время",
        LANG_PDF: "Язык PDF",
        UZ: "Узбекский язык (UZ)",
        UZ_CYRL: "Кирилл (УЗ)",
        RU: "Русский язык (РУ)",
        COURT_STATUS: "Статус суд",
        FOR_GMAIL: "Для почты",
        PRINT: "Печать",
        SUM: "сум",
        DEBT: "дебитор",
        COURT_WARNING_IN_CABINET: "Предупреждение суда",
        DOWNLOAD_FILE_NAME: "Судебные-уведомления.pdf",
        CONFIRM_TEXT:
          "После ввода утвержденного файла абонент получает уведомление. Файлы формы-1 и карты абонента создаются автоматически, для этого необходимо правильно ввести паспортные данные абонента!",
        FILE_APPROVED_LOAD: "Подтвержденная загрузка файла предупреждения",
        FILE_APPROVED: "Подтвержденный файл",
        TOAST_COURT_WARNING_SUCCESS: "Предупреждение создано!",
        WARNING_FILE: "Файл предупреждения",
        WARNING_FILE_PDF: "Файл предупреждения.pdf",
        FORMA_1_PDF: "Форма-1.pdf",
        ABONENT_CART_PDF: "Карта абонента.pdf",
        SENT_TO_COURT_DOCUMENT_PDF: "Файл для отправки в суд.pdf",
        COURT_ORDER_PDF: "Решение суда.pdf",
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Название компании",
          NAME: "Ф.И.О",
          PERSONAL_ACCOUNT: "Лицевой счет",
          ADDRESS: "Адрес",
          STATUS: "Статус",
          WARNING_DATE: "Дата предупреждения",
          COURT_DATE: "Дата передачи в суд",
          SUM: "Сумма",
          FILE: "Файл",
          USER_CREATED: "Пользователь создан",
          USER_CREATED_DATE: "Дата создания",
          USER_UPDATE: "Измененный пользователь",
          USER_UPDATE_DATE: "Дата изменения",
        },
        SUBSCRIBERS_TABLE_HEADERS: {
          ID: "ID",
          NAME: "Ф.И.О",
          PERSONAL_ACCOUNT: "Лицевой счет",
          NEIGHBORHOOD: "Махалля",
          STREET: "Улица",
          HOME: "Дом",
          APARTMENT: "Кв",
          INDEX: "Индекс",
        },
        FILTER: {
          FILTER_SEARCH: "Поиск",
        },
        POSTING_AKT: {
          PERSONAL_ACCOUNT: "Лицевой счет",
          PERSONAL_ACCOUNT1: "Лицевой счет:",
          NAME: "Ф.И.О.",
          ADDRESS: "Адрес",
          NUMBER_RESIDENTS: "Кол-во прожив.",
          WARNING_DATE: "Дата уведомления",
          FILE_ADD: " Прикрепить файл",
          PLACEHOLDER_WARNING_AMOUNT: "Сумма предупреждения",
          PLACEHOLDER_WARNING_DATE: "Дата предупреждения ",
          PLACEHOLDER_BASE: "Основание",
        },
        SELECT: {
          PLACEHOLDER_COMPANY: "Название компании",
          PLACEHOLDER_STATUS: "Статус",
          PLACEHOLDER_QUARTER: "Квартал",
          PLACEHOLDER_STREET: "Улица",
        },
        INPUT: {
          PLACEHOLDER_HOME: "Дом",
          PLACEHOLDER_IND: "Индекс",
          PLACEHOLDER_APARTMENT: "Квартира",
        },
        SUBSCRIBERS_MODAL: {
          TITLE: {
            SUBSCRIBERS: "Подписчики",
          },
        },
        MODAL: {
          COURT_WARNING_TITLE: "Передача в суд",
          EDIT_TITLE: "Редактирование суммы",
          CONFIRM_TITLE: "Подтверждение статуса",
          CONFIRM_TEXT:
            "Вы действительно хотите подать на это предупреждения в суд?",
          CONFIRM_TEXT_ONE:
            "Вы действительно хотите подать на это предупреждение в суд?",
          CONFIRM_TEXT_FILE:
            "Вы действительно хотите прикрепить этот государственный контракт к району?",
          CONFIRM_TOASTR: "Информация успешно  проверена!",
          SUM: "Сумма",
        },
        STATUS: {
          NEW: "Новый",
          COURT_IN_PROGRESS: "В судебном процессе",
        },
        WARNING_MODAL: {
          TITLE: "Уведомление подписчиков",
          TEXT: "Вы действительно хотите уведомить выбранных абонентов?",
          COURT_WARNING_IN_CABINET:
            "Вы действительно хотите оповестить выбранного абонента?",
        },
        GREEN_TEXT: "Долг погашен полностью",
        YELLOW_TEXT:
          "Частично погашена задолженность (от {{ percentage }}% до 99.9%)",
        RED_TEXT:
          "Частично погашена задолженность (от 0% до {{ percentage }}%)",
        SEND_COURT_ACTION: "Передача в суд",
        DEBTORS_RESIDENTS_WARNING:
          "Уведомлять могут только абоненты, имеющие задолженность и не уведомленные в течение {{ tem }} месяцев.",
      },
      COURT_ACTION: {
        COURT_DECISION_MESSAGE: "Объяснение решения суда",
        COURT_SEND_MESSAGE: "Суджа отправить сообщение",
        STATUS: "Состояние",

        CANCEL_COURT_WARNING:
          "Вы уверены, что хотите отменить пробную версию выбранного абонента?",
        EXCEL_NAME: "Судебные процессы.xlsx",
        COMMENT_STATUS: {
          ELECTRON_PAYMENT: "Электронные платежи",
          PAYMENT_1031: "БПИ и 1031 платеж",
          CASH_PAYMENT: "Оплата наличными",
          MUNIS_PAYMENT: "Платежи МУНИС",
          ACT: "Аcт платежи",
        },
        PAYMENT_CONFIRM: {
          CONFIRMED: "Подтверждено",
          CONFIRMED_CANCELLED: "Отменено",
          PAYMENT_PERFORMED: "Подтверждено",
          PAYMENT_CANCELLED: "Отменено",
        },
        ADD_ADDITIONAL_DECISION_FILE: "Загрузка судебного решения",
        END_COURT: "Завершение суда",
        END_COURT_TOAST: "Суд окончен",
        UPLOAD_MIB_FILE: "Загрузка файла MIB",
        SENT_TO_COURT_TEXT: "Документы отправлены в суд.",
        CLAIM_FILE_TEXT: "Введите иск для отправки в суд.",
        DOCUMENT_PREPARATION_END: "Заполнение судебных документов",
        FORM_1_FILE_NAME: "Форма-1",
        ABONENT_CARD_FILE_NAME: "Абонентская карта",
        CLAIM_FILE_NAME: "Заявка",
        MAHALLA_FILE_NAME: "Общественный договор микрорайона",
        MIB: "Загрузить MIB-файл",
        DOCUMENT_PREPARATION_SUCCESS: "Документ успешно создан",
        FROM: "Баланс (от)",
        TO: "Баланс (до)",

        TAB_TITLE: {
          FILE: "Файл",
          PAYMENT: "Платежи",
          COURT_HISTORY: "История суда",
        },

        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Название компании",
          NAME: "Ф.И.О",
          ACCOUNT_NUMBER: "Лицевой счет",
          STATUS: "Статус",
          WARNING_DATE: "Дата предупреждения",
          COURT_DATE: "Дата передачи в суд",
          SUM: "Сумма уведомления",
          DEBT_RANGE: "Диапазон задолженности",
          USER_CREATED_DATE: "Создан",
          USER_UPDATE: "Измененный пользователь",
          USER_UPDATE_DATE: "Дата изменения",
        },
        STATUS_OPTION: {
          CANCELLED: "Отменено",
          NOTIFIED: "Оповещен",
          NEW: "Оповещение создано",
          WARNED: "Предупрежденный",
          DOCUMENT_PREPARATION: "Подготовление судебных документов",
          DOCUMENTS_FORMALIZED: "Документы для суда готовы.",
          DOCUMENTS_SENT: "Документы отправлены в суд",
          COURT_DECISION: "Занесен постановление суда ",
          MIB_EXECUTION: "Ориентация на производительность",
          DEBT_PAID: "Задолженность полностю оплачен",
        },
        DETAILS: {
          BUTTON_TITLE: "Детали",
          TITLE: "Детали",
          NAME: "Ф.И.О:",
          PERSONAL_ACCOUNT: "Лицевой:",
          AMOUNT_OWED: " Все должний сумма",
          TIME_DEBT: "Время задолженности",
          NUMBER_RESIDENT: "Кол-во прожив.",
          LEFT: " Остаток",
          MADE_PAYMENT: "Платеж произведен",
          ADDRESS: "  Адрес",
          ACTION: " Действия",
          BUTTON_FILE: "Файл",
          BUTTON_PAYMENTS: "Платежи",
          BUTTON_HISTORY: "История суда",
          BUTTON_ENTRY_ORDER: " Введите решение суда",
          WARNING_FILE: "Файл предупреждения",
          JUDGMENT_FILE: "Судебные документы",
          SENDING_FILE: "Отправка файлов в суд",
          SEND_TO_COURT: "Отправить в суд",
        },
        MODAL: {
          TITLE: " Введите решение суда",
          LOAD_FILE: "Загрузка файла суда",
          COMMENT: "Комментарий",
          TOAST_SUCCESS: "Решение суда сохранено успешно!",
          TEXT: "Этот документ является окончательным решением судебного заседания по долгу!",
        },
        MODAL_FILE: {
          TITLE: "Добавить файл",
          TYPE_FILE: "Выберите тип файла",
          FILE_BUTTON: "Прикрепите файл",
          COMMENT: "Комментарий",
          TOAST_SUCCESS: "Файл  добавлен успешно!",
        },
        TABLE_HEADERS_PAYMENT: {
          ID: "ID",
          STATUS: "Статус",
          PAYMENT: "Оплата",
          PAYMENT_DATA: "Дата платежа",
          NOTE: "Комментарий",
        },
        TABLE_HEADERS_HISTORY: {
          ID: "ID",
          CHANGE_FIELD: "Измененный поль",
          STATUS: "Статус",
          FROM: "От",
          TO: "До",
          NOTE: "Примечание",
        },
        CONTRACT_MAHALLA: "Маҳаллая контракт",
      },
      EMPLOYEES_ACTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Ф.И.О сотрудника",
          OPERATION_DATE: "Дата операции",
          SUBSCRIBER_NAME: "Ф.И.О абонента",
          PERSONAL_ACCOUNT: "Лицевой счет",
          JOB_TYPE: "Типы работ",
          COMPANY_NAME: "Название компании",
          CHANNEL: "Канал",
          WAS: "Было",
          BECAME: "Стало",
          ACTION: "Действие",
        },
      },
      FROZEN_DEBT_ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Название компании",
          NAME: "Ф.И.О",
          ACCOUNT_NUMBER: "Номер счета",
          NUMBER_RESIDENT: "Кол-во прожив.",
          DATA_FILE: "Дата акта",
          STATUS: "Cтатус",
          SUM: "Тўлов сўндириш(сумма)",
          DEBT_SUM: "Қарздорлик сўндириш(сумма)",
          ACT_SUMMA: "Актни сўндириш(сумма)",
          ACT_NUMBER: "Номер акта",
          ACT_COMMENTARY: "Детали акта",
          // DETAILS_ACT: "Детали акта",
          FILES: "Прикрепленный файл",
          USER: "Пользователь",
          PAY_SUM: "Сумма платежа",
          INCOME_SUM: "Сумма выручки",
          ACT_SUM: "Сумма по актам",
          ACTION: "Действие",
        },
        MODAL: {
          TITLE: "Абоненты",
          START_SALDO: "Замороженный долг салдо начала: ",
          END_SALDO: "Замороженный долг салдо начала конец: ",
          ACT: "Замороженные долги акти: ",
          ADDRESS: "Адрес: ",
          ALL_FROZEN_DEBT: "Всего Замороженная долг выплати: ",
          ALL_DEBT_ACTS: "Всего Дебитовый акт: ",
          SUMMA: "Невыполнение обязательств (сумма): ",
          EXCEL_TITLE: "Замороженные долги {{date}}",
        },
        FILTER: {
          BUTTON_FILTER: "Задолженность",
          TITLE_COMPANY: "Информация",
          TITLE_AKT: "Информация о долгах",
        },
      },
      NOTIFICATION_RESTRICTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATA: "Информация",
          COMPANY_NAME: "Название компании",
          DISTRICT_NAME: "Район",
          PERIOD: "Период",
        },
        MODAL: {
          SMS_QUANTITY: "Количество SMS",
          AMOUNT: "Сумма",
          AMOUNT_FROM: "Баланс (от)",
          AMOUNT_TO: "Баланс (до)",
          ID: "ID",
          COMPANY_NAME: "Название компании",
          YEAR: "Год",
          MONTH: "Месяц",
          NOTIFICATION_LIMIT_COUNT: "Ограничительное количество сообщений",
          REGISTRATION_NOTIFICATION_COUNT:
            "Количество регистрационных сообщений",
          ANOTHER_NOTIFICATION_COUNT: "Количество других сообщений",
          CAUTION_COUNT: "Количество предупреждений",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить ограничитель выбранных сообщений из системы?",
          DELETE_MODAL: "Отключить ограничитель сообщений",
          EDIT_MODAL_TITLE: "Редактировать ограничитель сообщений",
        },
        FILTER: {},
      },
      MUNIS: {
        TABLE_HEADERS: {
          PERIOD: "Период",
          COMPANY_NAME: "Название компании",
          ACCOUNT_NUMBER: "Лицевой счет",
          DOCUMENT_NUMBER: "№ документа",
          DOCUMENT_DATE: "Дата документа",
          DAY_PAYMENT: "Дата оплаты",
          TIME_PAYMENT: "Время платежа",
          SUMMA: "Сумма (сум)",
          RESIDENT_FIO: "Ф.И.О абонента",
          SEND_MFO: "Отправитель MFO",
          SELF_MFO: "Принимающая МФО",
          BANK_MFO: "МФО",
          HASH: "HASH",
          TRANSACTION_ID: "ID транзакции",
          X_R: "Номер счета отправителя",
          X_Q: "Номер счета получателя",
          INN: "ИНН компании",
          OWN_INN: "ИНН (свой)",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          FLAT_NUMBER: "Кв",
          NAME: "Hаименование",
          BANK_ID: "БАНК ID",
          KVITANTSIYA: "Квитанция ID",
          SYSTEM_ID: "Система ID",
          PURPOSE: "Детали платежа",
          CODE: "Код",
          DELETE: "Удален",
        },
        PLACEHOLDER_COMPANY_NAME: "Название компании",
        DOWNLOAD_EXCEL_TITLE: "Платежи МУНИС",
        STATUS: {
          SUCCESS: "Успешно",
          DELETE: "Удален",
          ERROR_FILE: "Ошибка загрузки файла",
          CREATED: "Создано",
          SURCHARGES_ARE_AVAILABLE_DURING_PROCESSING: "Была переплата",
        },
        PREVIOUS_AMOUNT: "Предыдущая сумма",
        AMOUNT: "Сумма",
      },

      FREEZING_MAHALLA: {
        TABLE_HEADERS: {
          MAHALLA_ID: "Махалля",
          MAHALLA_NAME: "Название махалли",
          START_FROZEN_DATE: "Начальный период",
          REGION: "Регион",
          DISTRICT: "Район",
          COMPANY_NAME: "Название компании",
          PERIOD: "Период",
          FILE_NAME: "Название файла",
          DESCRIPTION: "Комментарий",
          STATUS: "Статус",
          ACTIVE: "Замороженный",
          CANCELED: "Отменен",
          WAITING: "Ожидание",
          FINISHED: "Завершен",
        },
        FORMS: {
          SELECT_MAHALLA: "Выберите махалла",
          MAHALLA_NAME: "Название махалли",
          START_FROZEN_DATE: "Начальный период",
          END_FROZEN_DATE: "Конечный период",
          FILE: "Файл",
          DESCRIPTION: "Комментарий",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Заморозить махалли",
          EDIT_MODAL_TITLE: "Редактирование замороженной махалли",
        },
        CONFIRMATION: {
          CANCEL_TITLE: "Отмена замораживания махалля",
          CANCEL_TEXT: "Вы действительно хотите отменить заморозку махалля ?",
          FINISHED_TITLE: "Окончание периода заморозков в окрестностях",
          FINISHED_TEXT:
            "Вы действительно хотите положить конец периоду заморозков в этом районе?",
          FINISHED_WARNING:
            "Для абонентов в этом районе расчет платы начинается со следующего периода!",
          DELETE_TITLE: "Удалить период, когда заморозка района закончилась",
          DELETE_TEXT:
            "Вы действительно хотите удалить период, когда заморозка района закончилась?",
        },
      },

      FROZEN_RESIDENTS: {
        DELETE_TITLE: "Удалить период, когда заморозка абонента закончилась",
        DELETE_TEXT:
          "Вы действительно хотите удалить период, когда заморозка абонента закончилась?",
      },

      FREEZING_STREETS: {
        ADD_MODAL_TITLE: "Заморозить улицу",
        CONFIRMATION_FINISHED_TITLE: "Отмена замораживания улицы",
      },

      COMPARATIVE_DATA: {
        TITLE: "Сравнение данных",
        TITLE_1: "Информация в базе данных МИБ",
        TITLE_2: "Данные в кадастровой базе данных",
        TITLE_3: "Данные в базе данных РЭС",
        WARNING_MESSAGE: "Кадастровый номер этого абонента не включен!",
        INVALID_SOATO_NUMBER: "Номер SOATO абонента неверен!",
        COLUMNS: {
          DATA: "Данные",
          IN_THE_BASE: "В базе",
          SYSTEM: "Система",
          PROTSENT: "Процент",
          ACTIONS: "Действия",
        },
        TABLE_COLUMNS: {
          CADASTRAL_NUMBER: "кадастровый номер",
          INHABITANT_CNT: "количество жителей",
          PNFL: "ПИНФЛ",
          PASSPORT: "паспорт",
          LAST_NAME: "Фамилия",
          FIRST_NAME: "Имя",
          PATRONYMIC: "Отчество",
          ADDRESS: "Адрес",
        },
        TABLE_COLUMNS2: {
          CADASTRAL_NUMBER: "кадастровый номер",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          MAHALLA_NAME: "Махалля",
          OWNER_OF_THE_HOUSE: "Владелец дома",
          PASSPORT_NUMBER: "Номер паспорта",
          INN: "ИНН",
          PNFL: "ПИНФЛ",
          EDIT_FULL_ADDRESS: "Редактировать адрес",
        },
      },
      SEND_COURT_ACTION: "Передача в суд",

      CADASTR_PUSH: {
        NAME: "Название",
        CREATED_AT: "Дата создания",
        TRANSACTION_CODE: "Код транзакции",
        ORIGIN: "Источник",
        OLD_CAD_NUM: "Старый кадастровый номер",
        CAD_NUM: "Кадастровый номер",
        REGION_NAME: "Область",
        DISTRICT_NAME: "Район",
        MAHALLA_NAME: "Махалля",
        STREET_NAME: "Улица",
        HNUM_TYPE: "Тип номера дома",
        HNUM: "Номер дома",
        KNUM_TYPE: "Тип кадастрового номера",
        HOST_PART: "Доля",
        HOST_PARTY_TYPE_CODE: "Код стороны",
        HOST_PARTY_TYPE_DESCRIPTION: "Описание стороны",
        LAND_FUND_TYPE: "Тип земельного фонда",
        LAND_USE_TYPE: "Тип использования земли",
        LEGAL_TYPE: "Юридический тип",
      },
    },
    LEASING: {
      STATISTICS: {
        TITLE: "Статистика",
        BY_REGIONS: {
          TITLE: "Количество договоров аренды по регионам",
          CONTRACTS_COUNT: "Количество договоров аренды",
        },
        BY_STATUS: {
          TITLE: "Количество договоров аренды по статусу",
        },
        BY_YEARLY: {
          TITLE: "Количество договоров аренды за период",
        },
        BY_MONTHLY: {
          TITLE: "По месяцам",
        },
        INFO_CARD: {
          TITLE: "Информация",
        },
        BY_PRICE: {
          TITLE: "По цене",
        },
      },
      SUB_MENU: {
        TECHNIQUES_TITLE: "Техника и оборудование",
        DOCUMENT_TYPES_TITLE: "Типы документа",
        CONFIGURATIONS_TITLE: "Настройки",
        PROCESS_TITLE: "Лизинг процесс",
        PAYMENT_LIST_TITLE: "Список платежей",
        LEASING_INFO_TITLE: "Лизинг",
      },
      APROVE_LEASING: "Вы действительно хотите одобрить этот договор лизинг?",
      TECHNIQUES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          DETAIL: "Детали",
        },
        MODAL: {
          PRICE: "Цена",
          USD_PRICE: "Цена в долларах США",
          UZS_PRICE: "Цена в сумах",
          DESCRIPTION: "Комментарий",
          WITH_QQS: "с НДС",
          WITHOUT_QQS: "без НДС",
          QQS: "НДС",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранную технику из системы?",
        },
      },
      DOCUMENT_TYPE: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          DESCRIPTION: "Комментарий",
        },
        null: "Выбранный",
        CREATED: "Выбранный",
        UPLOADED: "Готов проверить",
        APPROVED: "Подтверждён",
        REJECTED: "Отклоненный",

        MODAL: {
          DOCUMENT_ADD: "Добавить тип документа",
          DOCUMENT_REMOVE: "Удаление тип документа",
          DOCUMENT_ADD_CONFIRMATION: "Введенное документ не добавлен",
          DOCUMENT_UPDATE: "Редактирование тип документа",
          TITLE_DELETE: "Удаление типа документа",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный тип документа из системы?",
          APROVE_DOCUMENT: "Вы действительно хотите утвердить этот документ?",
          REJECT_DOCUMENT: "Вы действительно хотите отклонить этот документ?",
          NAME_UZ: "Название (UZ):",
          NAME_RU: "Название (РУ):",
          NAME_CRL: "Название (УЗ):",
          NAME_EN: "Название (EN):",
          COMMENTARY_UZ: "Комментарий (UZ)",
          COMMENTARY_RU: "Комментарий (РУ)",
          COMMENTARY_CRL: "Комментарий (УЗ)",
        },
      },
      CONFIGURATION: {
        LEASING_CONTRACT: "Лизинг договор",
        UPDATE_LEASING_CONTRACT_UZS: "Редактирование лизинг договор",
        UPDATE_LEASING_CONTRACT_USD:
          "Редактирование  лизинг валютный ($) договор",
        ORGANIZATION_INFO: "Информация организации",
        ORGANIZATION_NAME: "Название организации",
        ORGANIZATION_ADDRESS: "Адрес организации",
        BANK_CONFIG_TITLE: "Банковские данные",
        BANK_NAME: "Название банка",
        STIR: "Банк STIR",
        BANK_MFO: "Банк МФО",
        LEASING_INFO: "Информация о лизинге",
        LEASING_PERIOD: "Срок лизинга (месяц)",
        LEASING_GRACE: "Льготный период (месяц)",
        YEARLY_WARRANTY: "Гарантийный срок (месяц)",
        KM_WARRANTY: "Гарантия пробег (км)",
        LEASING_PERCENTAGE: "Лизинг процент (%)",
        DOWN_PAYMENT_PERCENTAGE: "Процент первоначального взноса (%)",
        PENALTY_PAYMENT_PERCENTAGE: "Пеня процент (%)",
        COMMISSION_PERCENTAGE_PERCENTAGE: "Процент выплаты комиссии (%)",
        LEASING_PERIOD_1: "Срок лизинга",
        LEASING_GRACE_1: "Льготный период",
        YEARLY_WARRANTY_1: "Гарантийный срок",
        KM_WARRANTY_1: "Гарантия пробег",
        LEASING_PERCENTAGE_1: "Лизинг процент",
        DOWN_PAYMENT_PERCENTAGE_1: "Процент первоначального взноса",
        PENALTY_PAYMENT_PERCENTAGE_1: "Пеня процент",
        COMMISSION_PERCENTAGE_PERCENTAGE_1: "Процент выплаты комиссии",
        QQS_PERCENTAGE: "Процент НДС",
        QQS_PERCENTAGE_1: "Процент НДС (%)",

        ACCOUNT_NUMBERS: "Номера счетов",
        ACCOUNT_NUMBERS_PENALTY: "Номер счета Пенья",
        ACCOUNT_NUMBERS_DOWN_PAYMENT: "Номер счета для первоначального взноса",
        ACCOUNT_NUMBERS_USD: "Номера счетов в долларах США",

        EXCHANGE_RATES: "Курсы валют",
        EXCHANGE_NAMES: "Названия валют",
        EXCHANGE: "Валюта",
        BUY: "Покупка",
        SELL: "Продажа",
        USD: "1 США доллар, USD",
        EUR: "1 Евро, EUR",
        RUB: "1 Рубль, RUB",
      },
      PROCESS: {
        TABLE_HEADERS: {
          ID: "ID",
          NO: "№",
          AMOUNT: "Сумма",
          COMMISSION: "Комиссия",
          DOWN_PAYMENT: "Первоначальньй взнос",
          LEASING_GRACE: "Льготный период",
          LEASING_PERCENTAGE: "Лизинг процент",
          LEASING_PERIOD: "Срок аренды",
          PENALTY_PAYMENT: "Пеня",
          STATUS: "Статус",
          APPLICATION_CREATED: "Заявка создан",
          IN_DOC_GATHERING: "Документы собираются",
          CHECKING_DOCUMENTS: "Проверка документов",
          REJECTED_BY_CENTER: "Отклонено центром",
          APPROVED_BY_CENTER: "Одобрено центром",
          REJECTED_BY_DIRECTOR: "Отклонено директором",
          WAITING_DECISION: "Ожидается решение",
          CONTRACT_APPROVED: "Документы одобрены",
          CONTRACT_AGREED: "Одобрен для контракта",
          CONTRACT_REJECTED: "Документы отклонены ",
          IN_PAYMENT_PERIOD: "В процессе оплаты",
          CLOSED: "Закрыто",
          SUBMITTED_DOCUMENTS: "Поданные документы",
          REVIEW: "На рассмотрении...",
          MORTAGAGED_PROPERTY: "О заложенном имуществе",

          PRINCIPAL_DEBT: "Основной долг",
          PRINCIPAL_REPAYMENT: "Погашение основной суммы долга",
          PERCENTAGE_REPAYMENT: "Процентная оплата",
          DAYS_OF_MONTH: "Дни месяца",
          TOTAL_MONTHLY_REPAYMENT: "Общий ежемесячный платеж",
          DATE: "Дата",
        },
        MODAL: {
          PROCESS_ADD: "Добавить лизинг",
          PROCESS_EDIT: "Редактирование лизинга",
          TITLE_DELETE: "Удаление лизинга",
          DOWN_PAYMENT: "Первоначальный взнос",
          COMPANY: "Название компании",
          AMOUNT: "Сумма",
          LEASING_PERCENTAGE: "Лизинг процент",
          PENALTY_PAYMENT: "Пеня",
          COMMISSION: "Комиссия",
          LEASING_PERIOD: "Срок аренды",
          LEASING_GRACE: "Льготный период",
          TECHNIQUES_TITLE: "Техники",
          TECHNIQUES_COUNT: "Кол-во техники",
          MESSAGE_DELETE:
            "Вы действительно хотите удалить выбранную лизинг из системы?",
          LEASING_CALCULATE: "Рассчитать Лизинг",
          CALCULATE: "Рассчитать",
          PROCESS_DOCUMENT_REQUIREDMENTS: "Необходимые документы",
          GO_SELECTED_DOCS:
            "Хотите вернуться к выбранным документам (загруженные документы будут удалены)?",
          LIZING_INFO:
            "Если вы не заплатите предварительный взнос в размере 10% от общей стоимости лизинга, то вы должны заложить имущество в размере не менее 10% от общей стоимости лизинга!",
          DIRECTOR: "Директор:",
          PRIMARY_CHECK_STATUS: "Первичный осмотр",
          DIRECTOR_CHECK_STATUS: "Подать в лизинговую комиссию",
          COMMISSION_CHECK_STATUS: "Заявление комиссии",
          STATEMENT_LABEL: "Протокол",
          STATEMENT_EXTRACT_LABEL: "Выписка из протокола",
          TERMS_OF_LEASING: "Условия аренды",
          CONCLUSION_LABEL: "Заключение",
          LEASING_DOCUMENTS_LIST:
            "Список документов, которые компания должна предоставить для лизинга",
          MY_TASKS: "Мои задачи",
          CONTRACT_DATE: "Дата договора",
          BRANCH_DIRECTOR_FIO: "Ф.И.О директора филиала",
          FIRST_PAYMENT_DATE: "Дата первого платежа",
        },
        CALCULATION_TABLE: {
          YEAR: "Год",
          LEARNING_COUNT_DOC:
            "График лизинговых платежей ({{count}} единица оборудования)",
          LEASING_PRICE: "Общая сумма лизинге",
          LEASING_DOWN_PAYMENT_PERCENTAGE: "Предоплата",
          PERCENT: "Процентная ставка",
          LEASING_GRACE: "Льготный период",
          LEASING_DEBT: "Задолженность по лизинг",
          FIRST_COMMISION_PAYMENT: "Единовременный комиссионный платеж",
          TOTAL: "Итого",
        },
      },
      PAYMENT_LIST_TITLE: {
        TABLE_HEADERS: {
          ID: "ID",
          PENALTY_PAYMENT: "Пеня",
          LEASING_ID: "Лизинг ID",
          PERIOD: "Период",
          PERCENTAGE_PAYMENT: "Процентная оплата",
          MAIN_DEBT: "Основной долг",
          MONTHLY_PAYMENT: "Ежемесячный платеж",
          PAID_DATE: "Дата оплаты",
          PAYMENT_RECEIPT_FILE: "Файл квитанции",
          DESCRIPTION: "Комментарий",

          PAYMENT_AMOUNT: "Сумма платежа",
          PAID_AT: "Время ввода в систему",
        },
        MODAL: {
          ADD_TITLE: "Добавление платежа",
          UPDATE_TITLE: "Редактирование платежа",
          DELETE_TITLE: "Удаление платежа",
          PAYMENT: "Сумма:",
          PAID_DATE: "Дата оплаты:",
          PAYMENT_RECEIPT: "Файл квитанции:",
          IS_USD: "В долларах США",
          DESCRIPTION: "Комментарий:",
        },
      },
    },
    ERROR_PAGE: {
      NOT_FOUND_TITLE: "Страница не найдена!",
      RETURN_HOME: "Главная",
      SYSTEM_ERROR: "Ошибка сервера!",
      ACCESS_LIMITED: "Доступ ограничен!",
    },
    DATEPICKER: {
      WEEKDAYS_SHORT: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
      MONTHS: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
      WEEK: "Неделя",
      MONTH: "Месяц",
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: "Количество выбранных записей: ",
        ALL: "Все",
        SUSPENDED: "Приостановленный",
        ACTIVE: "Активный",
        FILTER: "Фильтр",
        BY_STATUS: "по статусу",
        BY_TYPE: "по типу",
        BUSINESS: "Бизнес",
        INDIVIDUAL: "Индивидуальный",
        SEARCH: "Поиск",
        IN_ALL_FIELDS: "во всех областях",
      },
      ECOMMERCE: "электронная коммерция",
      CUSTOMERS: {
        CUSTOMERS: "Клиенты",
        CUSTOMERS_LIST: "Список клиентов",
        NEW_CUSTOMER: "новый клиент",
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: "Удаление клиента",
          DESCRIPTION: "Вы уверены, что хотите навсегда удалить этого клиента?",
          WAIT_DESCRIPTION: "Клиент удаляет...",
          MESSAGE: "Клиент удален",
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: "Удалить клиентов",
          DESCRIPTION:
            "Вы уверены, что хотите навсегда удалить выбранных клиентов?",
          WAIT_DESCRIPTION: "Клиенты удаляют...",
          MESSAGE: "Выбранные клиенты удалены",
        },
        UPDATE_STATUS: {
          TITLE: "Статус обновлен для выбранных клиентов.",
          MESSAGE: "Статус выбранных клиентов успешно обновлен.",
        },
        EDIT: {
          UPDATE_MESSAGE: "Клиент обновлен",
          ADD_MESSAGE: "Клиент создан",
        },
      },
    },
    GENERAL: {
      RECEIPT_ISSUERS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Наименование",
          COMPANY_NAME: "Название компании",
        },
        MODAL: {
          TITLE_SAVE: "Добавление новых квитанций владельца",
          TITLE_UPDATE: "Редактировать квитанции владельцев",
          COMPANY: "Компания:",
          NAME_UZ: "Название (UZ)",
          NAME_RU: "Название (РУ)",
          NAME_CRL: "Название (УЗ)",
          NAME_EN: "Название (EN)",
          CONFIRMATION_MODAL_TEXT:
            "Вы хотите удалить выбранного поставщика квитанций?",
          TOAST_DELETE: "Выбранный поставщик квитанций успешно удален!",
          TOAST_SUCCESS: "Новый поставщик квитанций добавлен успешно!",
          TOAST_UPDATE: "Поставщик квитанций успешно обновлен!",
        },
      },
    },
    NOTIFICATIONS: {
      TABLE_HEADERS: {
        ID: "ID",
        NAME: "Наименование",
      },
      MODAL: {
        EXCEL_TITLE: "Информация об уведомлении {{date}}.xls",
        MODAL_TITLE: "Добавление нового уведомления",
        UPDATE_MODAL: " Редактирование уведомления",
        DELETE_MODAL: "Удаление уведомления",
        DELETE_MODAL_SUBTITLE:
          "Вы действительно хотите удалить  выбранное  уведомление?",
      },
    },

    GEOGRAPHY: {
      MODAL_BUTTON: {
        ADD_BUTTON: "Сохранить",
        CANCEL: "Отмена",
        SOATO: "Код СОАТО",
      },
      REGIONS: {
        CAB_TAB_1: "Узбекский язык",
        CAB_TAB_2: "Кирилл",
        CAB_TAB_3: "Русский язык",
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          NAME: "Наименование",
          CREATE_DATE: "Дата создания",
          CADASTRAL_CODE: "Кадастровый код",
        },
        MODAL: {
          MODAL_TITLE: "Добавление региона",
          UPDATE_MODAL: "Редактировать региона",
          DELETE_MODAL: "Удаление региона",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный регион из системы?",
          NAME_UZ: "Название (UZ):",
          NAME_RU: "Название (РУ):",
          NAME_CRL: "Название (УЗ):",
          NAME_EN: "Название (EN):",
          TOAST_DELETE: "Выбранный регион успешно удален!",
          TOAST_SUCCESS: "Новый регион добавлен успешно!",
          TOAST_UPDATE: "Выбранный регион обновлен успешно!",
        },
      },
      DISTRICTS: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION: "Регион",
          NAME: "Наименование",
          CREATOR: "Создавший пользователь",
          CREATED_AT: "Дата создания",
        },
        MODAL: {
          TITLE_SAVE: "Добавление района",
          TITLE_UPDATE: "Редактирование района",
          TITLE_DELETE: "Удаление района",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный район из системы?",
          NAME_UZ: "Название (UZ):",
          NAME_RU: "Название (РУ):",
          NAME_CRL: "Название (УЗ):",
          NAME_EN: "Название (EN):",
          TOAST_DELETE: "Выбранный район успешно удален!",
          TOAST_SUCCESS: "Новый район добавлен успешно!",
          TOAST_UPDATE: "Выбранный район обновлен успешно!",
        },
        IMPORT: {
          BUTTON: "Импорт",
          MODAL_TITLE: "Импорт статистики районов",
          INFO_TITLE: "Информация",
          INFO_DESCRIPTION:
            "Ввод дополнительных данных для статистики районов. Принимаются только файлы в формате Excel.",
          DOWNLOAD_TEMPLATE: "Скачать шаблон файла",
          SELECT_FILE: "Выберите Excel файл",
        },
      },
      VILLAGES: {
        INFO: "У махалли в жёлтой строке отсутствуют координаты!",
        FROZEN_INFO: "Махалля в синей строке заморожена!",
        FILTER_BTN: "Желтые ряды",
        LEGAL_INFO: "Зона легальных абонентов в желтых полосах не включена!",
        MODAL: {
          TITLE_SAVE: "Добавление махалли",
          TITLE_UPDATE: "Редактирование махалли",
          TITLE_DELETE: "Удаление махалли",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранный махаллю из системы?",
          COMPANY: "Название компании",
          GPS_BASED: "На основе GPS",
          DEFAULT: "Типичный",
          MONTHLY_TRIPS_NUMBER: "Количество посещат в месяц",
          MIN_MILAGE:
            "Минимальное расстояние, которое необходимо преодолеть (км)",
          MIN_DURATION_IN: "Минимальное время пребывания по соседству (минут)",
          MIN_MOVING_DURATION: "Минимальное время действия (минут)",
          AFFECT_ON_VISIT: "При посещении влияет на начисление",
          ACTUAL_BALANCE_CALCULATE_INDICATOR:
            "Внедрение сумм, рассчитанных через GPS",
          GPS_ACCRUAL_CONFIRMATION_FILEID:
            "Файл-основание для начисления по GPS для махалли",
          MAHALLA_FILE: "Файл-основание для создания махалли",
          GPS_ACCRUAL_START_DATE: "GPS бўйича ҳисоблаш бошланиш санаси",
          MIN_STOPS_COUNT: "Минимальное количество остановок",
          MAX_AVERAGE_SPEED: "Максимальная средняя скорость (км/ч)",
          ACCURAL_TYPE: "Тип начисления",
          SECTOR_TYPE: "Тип сектора",
          FIRST_SECTOR: "1-сектор",
          SECOND_SECTOR: "2-сектор",
          THIRD_SECTOR: "3-сектор",
          FOURTH_SECTOR: "4-сектор",
          UNASSIGNED: "Не назначен",
          NAME_UZ: "Имя махалли (UZ)",
          NAME_RU: "Имя махалли (РУ)",
          NAME_CRL: "Имя махалли (УЗ)",
          COMMENTARY_UZ: "Комментарий (UZ)",
          COMMENTARY_RU: "Комментарий (РУ)",
          COMMENTARY_CRL: "Комментарий (УЗ)",
          WARNING_TITLE:
            "Так как у данного махалли есть связанные территории, некоторые поля можно не заполнять!",
          CHECKING_TITLE:
            "Проверяется, принадлежит ли махалля к какому-либо району...",
        },
      },
      STREETS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Наименование",
          COMMENTARY: "Комментарий",
        },
        MODAL: {
          TITLE_SAVE: "Добавление улицы",
          TITLE_UPDATE: "Редактирование улицы",
          TITLE_DELETE: "Удаление улицы",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранную улицу из системы?",
          NAME_UZ: "Имя улицы (UZ)",
          NAME_RU: "Имя улицы (РУ)",
          NAME_CRL: "Имя улицы (УЗ)",
          NAME_EN: "Имя улицы (EN)",
          COMMENTARY_UZ: "Комментарий (UZ)",
          COMMENTARY_RU: "Комментарий (РУ)",
          COMMENTARY_CRL: "Комментарий (УЗ)",
          TOAST_DELETE: "Выбранная улица успешно удалена!",
          TOAST_SUCCESS: "Новая улица успешно добавлена!",
          TOAST_UPDATE: "Выбранная улица успешно обновлена!",
        },
      },
      SELECT_INPUT: {
        COMPANY_NAME: "Название компании",
        INSPECTOR_FULLNAME: "Ф.И.О инпектора",
      },
      POLYGON: {
        SYNC_UP: "Синхронизация",
        SUCCESS: "Успешно",
        MODAL_TITLE: "Редактирование полигон",
        TABLE_HEADERS: {
          NAME: "Наименование",
          DESCRIPTION: "Комментарий",
        },
      },
      WASTE_COLLECTION_AREA: {
        WASTE_COLLECTION_AREA_EXEL_TITLE: "Абоненты, прикрепленные к МСП",
        TABLE_HEADERS: {
          NAME: "Наименование",
          STREET_NAME: "Улица",
          CADASTRAL_NUMBER: "Кадастровый номер",
          LATTITUDE: "Широта",
          LONGITUDE: "Долгота",
          BOX_COUNT: "Количество ящиков",
          DESCRIPTION: "Комментарий",
        },
        FORMS: {
          VILLAGE: "Махалля",
          STREET: "Улица",
          CADASTRAL_NUMBER: "Кадастровый номер",
          NAME: "Наименование",
          LATTITUDE: "Широта",
          LONGITUDE: "Долгота",
          BOX_COUNT: "Количество ящиков",
          DESCRIPTION: "Комментарий",
          MINIMUM_TIME: "Время нахождения на объекте (минута)",
          BOXES: "Ящики",
          SIZE: "Размер",
          COUNT: "Количество",
          AFFECT_ON_VISIT: "При посещении влияет на начисление",
          WASTE_COLLECTION_AREA_RADIUS: "Радиус зоны сбора отходов",
          MINIMUM_TIME_IN_MINUTES:
            "Минимальное время пребывания на МСП (минуты)",
          WASTE_SORT_AVAILABLE: "Площадка для раздельного сбора отходов",
          NUMBER_OF_TRIPS: "Количество поездок",
        },
        MODAL: {
          TITLE_SAVE: "Добавить поле",
          TITLE_UPDATE: "Редактировать поле",
          TITLE_DELETE: "Удалить поле",
          ADD_WCA_VIA_FILE_IMPORT: "Добавить через импорт",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранное поле из системы?",
          NUMBER_OF_TRIPS: "Редактировать количество поездок",
        },
      },
      WCA_BINDING_RESIDENTS: {
        TABLE_HEADERS: {
          RESIDENT_ID: "ID абонента",
          FIRST_NAME: "Имя",
          LAST_NAME: "Фамилия",
          PATRONYMIC: "Отчество",
          ACCOUNT_NUMBER: "Номер счета",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          FLAT_NUMBER: "Квартира",
          HOME_INDEX: "Индекс дома",
        },
        FILTER_FORM: {
          MAHALLA: "Махалля",
          STREET: "Улица",
          ACCOUNT_NUMBER: "Номер счета",
          RESIDENT_ID: "ID абонента",
          FILTER_RESIDENTS: "Фильтровать абонентов",
        },
        ACTIONS: {
          BINDING_RESIDENTS: "Привязать абонентов",
          MULTIPLE_DELETE: "Выборочное удаление",
          MOVE_RESIDENTS: "Переместить абонентов",
        },
        MODAL: {
          TITLE: "Присоединение абонентов к зоне сбора отходов",
          MERGE_RESIDENTS_INTO_ANOTHER_CHYM:
            "Присоединение абонентов к другому месту сбора отходов",
          UNBINDING_TITLE: "Удаление подключенных абонентов",
          CONFIRM_TITLE:
            "Вы действительно хотите удалить выбранних абонентов из зоны сбора отходы?",
        },
      },
      VILLAGE_CLASSIFIER: {
        VILLAGES_CLASSIFIER: "Синхронизировать махалли",
        VILLAGES_CODE_CLASSIFIER: "Синхронизация кода Махалли",
        TABLE_HEADERS: {
          MAHALLA_FROM_CLASSIFIER: "Махалля из классификатора",
          MAHALLA_FROM_TOZA_MAKON: "Махалля взята из Тоза-макон",
          INDEX: "Индекс сходства",
          OBJECT_ID: "Объект ID",
          CAOTO_CODE: "Код Соато",
          NAME: "Наименование",
          SELECTED_MAHALLA: "Избранные махалли",
          CLASSIFIER_REGION: "Класс.Область",
          CLASSIFIER_DISTRICT: "Класс.Районы",
          VILLAGE_CODE: "Код махалли",
        },
        CONFIRM_TEXT:
          "Вы действительно хотите синхронизировать выбранные махалля?",
      },
      RESIDENT_ACCRUAL: {
        TABLE_HEADERS: {
          VISIT: "Посещение",
          DATE: "Дата",
          IN_TIME: "Время входа",
          OUT_TIME: "Время выхода",
          ACCOUNT_NUMBER: "Номер счета",
          FISH: "Ф.И.О",
          INHABITANT_CNT: "Кол-во жителей",
          TARIFF: "Тариф (Сум)",
          CALCULATED: "Рассчитано",
          STATUS: "Статус",
          MOVED: "Перемещен",
          UNMOVED: "Не перемещен",
        },
        MODAL: {
          TITLE: "Начисленная сумма",
          EXCEL_TITLE: "Начисленная_сумма.xlsx",
          MAP_TITLE: "История движения",
        },
      },
      MAHALLA_AREA: {
        TABLE_HEADERS: {
          NAME: "Название территории",
          VILLAGE_NAME: "Название махалли",
          AFFECT_TO_BALANCE: "Влияет на начисления при посещении",
          MONTHLY_TRIPS_NUMBER: "Количество посещений в месяц",
          MIN_MILAGE:
            "Минимальное расстояние, которое необходимо преодолеть (км)",
          MIN_MOVING_DURATION: "Минимальное время действия (минут)",
          MIN_STOPS_COUNT: "Минимальное количество остановок",
          MAX_AVERAGE_SPEED: "Максимальная средняя скорость (км/ч)",
          ACTION: "Действие",
        },
        MODAL: {
          ADD_MAHALL_AREA: "Добавить территорию",
          UPDATE_MAHALL_AREA: "Редактировать территорию",
          TITLE_DELETE: "Удалить поле",
          DELETE_MODAL_SUBTITLE:
            "Вы действительно хотите удалить выбранное поле из системы?",
        },
      },
      MAHALLA_AREA_ZONE_BINDED_RESIDENTS: {
        TITLE: "Абоненты, прикреплённые к территории",
        TABLE_HEADERS: {
          NAME: "Ф.И.О",
          ACCOUNT_NUMBER: "Номер счета",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          FLAT_NUMBER: "Квартира",
          HOME_INDEX: "Индекс дома",
        },
        MODAL: {
          BIND_RESIDENTS_TITLE: "Прикрепление абонента к территории",
          CONFIRMATION_MODAL_TEXT:
            "Вы действительно хотите удалить выбранных абонентов из зоны обслуживания?",
        },
        ACTIONS: {
          BINDING_RESIDENTS: "Привязать абонентов",
          MULTIPLE_DELETE: "Выборочное удаление",
          MOVE_RESIDENTS: "Переместить абонентов",
        },
      },
      MAHALLA_AREA_ZONE_AUTOMOBILE_VISITS: {
        TITLE: "Посещения",
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Номер автомобиля",
          VISIT_DATE: "Дата посещения",
          AUTOMOBILE_NUMBER_AND_MODEL: "Номер и модель автомобиля",
          COMPANY_NAME: "Название компании",
          DRIVER: "Водитель",
          TIME_IN: "Время входа",
          TIME_OUT: "Время выхода",
          DURATION_IN_TIME: "Продолжительность пребывания на территории",
          MOVING_DURATION_IN_TIME: "Продолжительность времени в движении",
          PARKING_DURATION_IN_TIME: "Продолжительность времени отсутствия",
          MILEAGE: "Пройденное расстояние (км)",
          STOPS_COUNT: "Количество остановок",
          AVG_SPEED: "Средняя скорость (км/ч)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
          ON_MAP: "На карте",
          VISIT_COUNT: "Количество посещений",
        },
      },
      MAHALLA_AREA_VISIT_ANALYSIS_ROUTE: {
        TITLE: "Анализ визитов в территорию махалли",
      },
      MAHALLA_AREA_VISIT_POINTS: {
        TITLE: "Точки посещений геозоны",
        ADD_BUTTON: "Добавить точки для посещения геозоны",
        POINT_ASSIGNATION: "Отметить точки посещения геозоны",
        CANCEL: "Отмена",
      },
    },
    SPRAVOCHNIK: {
      PAYMENT_PARTNERS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Наименование",
          USERNAME: "Имя пользователя",
          IS_ACTIVE: "Статус",
          TYPE: "Тип",
          COMMISSION: "Комиссия",
        },
        MODAL: {
          ONLINE: "Онлайн",
          OFLINE: "Офлайн",
          NAME: "Наименование",
          USERNAME: "Имя пользователя",
          PASSWORD: "Пароль",
          ACCESS_TOKEN: "Сгенерировать",
          TITLE_SAVE: "Добавление нового платежного партнера",
          TITLE_UPDATE: "Редактирование платежного партнера",
          TITLE_DELETE: "Удаление платежного партнера",
          CONFIRMATION_MODAL_TEXT:
            "Вы действительно хотите удалить выбранного партнера?",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT:
            "Вы действительно хотите изменить статус выбранного платежного партнёра?",
        },
      },
      STATUS_TYPES: {
        ACT_TYPES: {
          TITLE: "Типы актов",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
          },
          MODAL: {
            TITLE_SAVE: "Добавить Тип акта",
            TITLE_UPDATE: "Редактировать Тип акта",
            TITLE_DELETE: "Удаление типа действия",
            NAME_UZ: "Имя Тип судебных дел (UZ)",
            NAME_RU: "Имя Тип судебных дел (РУ)",
            NAME_CRL: "Имя Тип судебных дел (УЗ)",
            USERNAME: "имя пользователя",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранного акта?",
            TOAST_DELETE: "Тип действия успешно удален!",
            TOAST_SUCCESS: "Новый акт добавлен успешно!",
            TOAST_UPDATE: "Тип действия успешно обновлен!",
            TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",
          },
        },
        ACT_ACTIONS_TYPES: {
          TITLE: "Типы действий",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
          },
          MODAL: {
            TITLE_SAVE: "Добавление нового типа действия",
            TITLE_UPDATE: "Редактирование типа действия",
            TITLE_DELETE: "Удаление типа действия",
            NAME: "Наименование",
            USERNAME: "имя пользователя",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранного акта?",
            TOAST_DELETE: "Тип действия успешно удален!",
            TOAST_SUCCESS: "Новый тип действия успешно добавлен!",
            TOAST_UPDATE: "Тип действия успешно обновлен!",
            TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",
          },
        },
        POSITION_TYPES: {
          TITLE: "Типы позиций",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
            STATUS: "Статус",
          },
          MODAL: {
            TITLE: "Типы ролей",
            TITLE_SAVE: "Добавить Тип позици",
            TITLE_UPDATE: "Редактировать Тип позици",
            TITLE_DELETE: "Удалить Тип позици",
            NAME_UZ: "Имя Тип позиций (UZ)",
            NAME_RU: "Имя Тип позиций (РУ)",
            NAME_CRL: "Имя Тип позиций (УЗ)",
            USERNAME: "имя пользователя",
            STATUS: "Статус",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранного позицию?",
            MODAL_BUTTONS: {
              CHANGE: "Save",
              CANCEL: "Cancel",
              ADD: "Add",
            },
            TOAST_DELETE: "Выбранный Тип позици успешно удален!",
            TOAST_SUCCESS: "Новый Тип позици добавлен успешно!",
            TOAST_UPDATE: "Тип позици успешно обновлен!",
            TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",
          },
        },
        ACT_STATUS: {
          TITLE: "Статусы действий",
          MODAL_ADD: {
            TITLE: "Добавление нового статуса акта",
            TOAST_SUCCESS: "Новый статус успешно добавлен!",
          },
          MODAL_EDIT: {
            TITLE: "Редактирование статуса акта",
            TOAST_EDIT: "Статус акта успешно обновлен!",
          },
          MODAL_DELETE: {
            TITLE: "Удаление статуса акта",
            TOAST_DELETE: "Статус акта успешно удален!",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранный статус?",
          },
        },
        PACK_TYPES: {
          TITLE: "Типы пачков",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
          },
          MODAL: {
            TITLE_SAVE: "Добавить Тип Пачка",
            TITLE_UPDATE: "Редактировать Тип Пачка",
            TITLE_DELETE: "Удалить Тип Пачка",
            NAME_UZ: "Имя Тип пачков (UZ)",
            NAME_RU: "Имя Тип пачков (РУ)",
            NAME_CRL: "Имя Тип пачков (УЗ)",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранного Пачка?",
            MODAL_BUTTONS: {
              CHANGE: "Save",
              CANCEL: "Cancel",
              ADD: "Add",
            },
            TOAST_DELETE: "Выбранный Тип пачка успешно удален!",
            TOAST_SUCCESS: "Новый Тип пачка добавлен успешно!",
            TOAST_UPDATE: "Тип пачка успешно обновлен!",
            TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",
          },
        },
        LIGITATION_STATUS_TYPES: {
          TITLE: "Статусы судебных дел",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
          },
          MODAL: {
            TITLE_SAVE: "Добавление нового типа судебного дела",
            TITLE_UPDATE: "Редактирование типа судебных дел",
            TITLE_DELETE: "Удаление типа судебных дел",
            NAME: "Наименование",
            USERNAME: "имя пользователя",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранный тип судебных дел?",
            TOAST_SUCCESS: "Успешно добавлен новый тип судебного дела!",
            TOAST_DELETE: "Выбранный тип судебного дела успешно удален!",
            TOAST_UPDATE: "Успешно обновлен тип выбранных судебных дел!",
            TOAST_SELECT_ROW: "Пожалуйста, выберите строку !",
          },
        },
        OWNER_SHIP_TYPES: {
          TITLE: "Тип компания",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
            SHORT_NAME: "Короткое имя",
          },
          MODAL: {
            TITLE_SAVE: "Добавить тип компания",
            TITLE_UPDATE: "Редактировать тип компания",
            TITLE_DELETE: "Удалить тип компания",
            NAME: "Наименование",
            SHORT_NAME: "Короткое имя",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранного тип компания?",
            MODAL_BUTTONS: {
              CHANGE: "Save",
              CANCEL: "Cancel",
              ADD: "Add",
            },
            TOAST_DELETE: "Выбранный тип компания успешно удален!",
            TOAST_SUCCESS: "Новый тип компания добавлен успешно!",
            TOAST_UPDATE: "Тип компания успешно обновлен!",
            TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",
          },
        },
        ORGANIZATION_TYPES: {
          TITLE: "Типы организаций",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
            ORG_TYPE_ID: "Тип организации",
          },
          MODAL: {
            TITLE_SAVE: "Добавление нового типа полей",
            TITLE_UPDATE: "Редактирование типа полей",
            TITLE_DELETE: "Удаление типа полей",
            NAME_UZ: "Название (UZ):",
            NAME_CRL: "Название (УЗ):",
            NAME_RU: "Название (РУ):",
            ORG_TYPE_ID: "Тип организации:",

            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранную организацию?",
            TOAST_SUCCESS: "Новый тип полей успешно добавлен!",
            TOAST_UPDATE: "Тип полей успешно обновлен!",
            TOAST_DELETE: "Выбранный тип полей успешно удален!",
            TOAST_SELECT_ROW: "Пожалуйста, выберите строку!",
          },
        },
        APPEAL_STATUS: {
          TITLE: "Статус апелляции",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
            SHORT_NAME: "Короткое имя",
          },
          MODAL_ADD: {
            TITLE: "Добавление статуса онлайн-заявки",
            TOAST_SUCCESS: "Статус онлайн-заявки успешно добавлен!",
          },
          MODAL_EDIT: {
            TITLE: "Редактирование статуса онлайн-заявки",
            TOAST_EDIT: "Статус онлайн-заявки успешно обновлен!",
          },
          MODAL_DELETE: {
            TITLE: "Удаление статуса онлайн-заявки",
            TOAST_DELETE: "Статус онлайн-заявки успешно удален!",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранный статус онлайн-заявки?",
          },
        },
        APPEAL_TYPE: {
          TITLE: "Тип онлайн-заявки",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
            SHORT_NAME: "Короткое имя",
          },
          MODAL_ADD: {
            TITLE: "Добавление нового типа онлайн-заявки",
            TOAST_SUCCESS: "Тип онлайн-заявки успешно добавлен!",
          },
          MODAL_EDIT: {
            TITLE: "Редактирование типа онлайн-заявки",
            TOAST_EDIT: "Тип онлайн-заявки успешно обновлен!",
          },
          MODAL_DELETE: {
            TITLE: "Удаление типа онлайн-заявки",
            TOAST_DELETE: "Выбранный тип онлайн-заявки успешно удален!",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранный  тип онлайн заявки?",
          },
        },
        COURT_FILE_TYPES: {
          TITLE: "Тип судебных дел",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Наименование",
          },
          FORM: {
            NAME_UZ: "Имя Тип судебных дел (UZ)",
            NAME_RU: "Имя Тип судебных дел (РУ)",
            NAME_CRL: "Имя Тип судебных дел (УЗ)",
          },
          MODAL_ADD: {
            TITLE: "Добавление новый тип судебных дел",
            TOAST_SUCCESS: "Тип судебных дел успешно добавлен!",
          },
          MODAL_EDIT: {
            TITLE: "Редактирование тип судебных дел",
            TOAST_EDIT: "Тип судебных дел успешно обновлен!",
          },
          MODAL_DELETE: {
            TITLE: "Удаление тип судебных дел",
            TOAST_DELETE: "Выбранный тип судебных дел успешно удален!",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранный тип судебных дел?",
          },
        },
      },
      TEMPLATES: {
        TABLE_LANGUAGE: "Язык",
        TABLE_CONTENT: "Содержание",
        MODAL_SAVE_TITLE: "Добавление новый документ",
        MODAL_SAVE_TITLE_CONTRACT: "Добавление контракта",
        MODAL_SAVE_TITLE_EV_DOC: "Добавление акта",
        MODAL_SAVE_TITLE_NOTIFICATION: "Добавление уведомления",
        MODAL_UPDATE: "Редактирование документ",
        MODAL_UPDATE_TITLE_CONTRACT: "Редактирование контракта",
        MODAL_UPDATE_TITLE_EV_DOC: "Редактирование акта",
        MODAL_UPDATE_TITLE_NOTIFICATION: "Редактирование уведомления",
        MODAL_DELETE: "Удаление документ",
        MODAL_DELETE_EV_DOC: "Удаление акта",
        MODAL_DELETE_NOTIFICATION: "Удаление уведомления",
        TEMPLATES_TYPE: "Тип документа",
        TEMPLATE_IN_UZ: "Shartnoma shabloni (UZ)",
        TEMPLATE_IN_RU: "Шаблон контракта (РУ)",
        TEMPLATE_IN_CRL: "Шартнома шаблони (УЗ)",
        CONFIRMATION_MODAL_TEXT: "Вы хотите удалить этот документ?",
        CONFIRMATION_MODAL_TEXT_EV_DOC:
          "Вы действительно хотите удалить выбранный акт из системы?",
        CONFIRMATION_MODAL_TEXT_NOTIFICATION:
          "Вы действительно хотите  удалить выбранное уведомление из системы?",
        INDIVIDUAL: "Индивидуальный",
        LEGAL: "Юридическ",
      },
      TEMPLATE_TYPES: {
        SMS: {
          TABLE_HEADERS: {
            SHORT_NAME: "Сокращенное имя",
            SMS_TITLE: "Заголовок SMS",
            CONTENT_SMS: "Текст SMS",
          },
          MODAL: {
            TITLE_SAVE: "Добавить новый шаблон СМС",
            TITLE_UPDATE: "Редактировать шаблон СМС",
            TITLE_DELETE: "Удаление шаблона СМС",
            DELETE_MODAL_SUBTITLE:
              "Вы действительно хотите удалить выбранное шаблона СМС из системы?",
          },
        },
      },
    },
    WORK1031: {
      PAYMENT_LIST: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Дата",
          TRANSFER_PAYMENT: "№ плат.поруч",
          SUM_1: "Сумма",
          SUM_2: "Общая сумма выплат",
          COMPANY_NAME: "Назв.организации",
          QUANTITY: "Кол-во",
          STATUS: "Cтатус",
          REGISTRATION_DATE: "Дата реестра",
          NAME: "Ф.И.О пользователя",
          COMMENT: "Комментарий",
        },
        MODAL: {
          TITLE_ADD: "Добавить платеж",
          TITLE_EDIT: "Обновление платежа",
          TITLE_DELETE: "Удалить платеж",
          CONFIRMATION_MODAL_TEXT: "Вы хотите удалить этот платеж?",
          TOAST_SUCCESS: "Новый платеж успешно добавлен!",
          TOAST_SUCCESS_EDIT: "Платеж обновлен!",
          TOAST_DELETE: "Оплата удалена!",
          PLACEHOLDER_COMPANY_NAME: "Наим. компании:",
          PLACEHOLDER_ORGANIZATIONS: "Организации:",
          PLACEHOLDER_SUM: "Сумма:",
          PLACEHOLDER_TRANSFER_PAYMENT: "№ плат.поруч:",
          PLACEHOLDER_STATUS: "Статус:",
          PLACEHOLDER_DATE: "Дата:",
          PLACEHOLDER_REGISTRATION_DATE: "Дата реестра:",
          PLACEHOLDER_COMMENT: "Комментарий:",
        },
      },
      PAYMENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_EMPLOYEE: "Сотрудник организации",
          ORGANIZATION_PAYMENT_PACK: "Пачка оплаты",
          PAYER_FIO: "Ф.И.О плательщика",
          AMOUNT: "Сумма",
          PAYMENT_DATE: "Дата оплаты",
          PURPOSE: "Цель",
          COMMENT: "Комментарий",
        },
        MODAL: {
          EXCEL_TITLE: "Отчет в разрезе платежей по БПИ и 1031 {{date}}.xlsx",
          ORG_EXPORT_TITLE: "Организации по БПИ и 1031 {{date}}.xlsx",
          ORG_EMPLOYEES_EXPORT_TITLE:
            "Отчетность работников организаций по БПИ и 1031 {{date}}.xlsx",
          TITLE_ADD: "Добавить платеж",
          FILET_RESULT: "Результаты поиска",
          TITLE_EDIT: "Обновление платежа",
          TITLE_DELETE: "Удалить платеж",
          EXPORT: "Экспорт в Excel",
          CONFIRMATION_MODAL_TEXT:
            "Вы действительно хотите удалить выбранный платеж?",
          TOAST_SUCCESS: "Новый платеж успешно добавлен!",
          TOAST_SUCCESS_EDIT: "Платеж обновлен!",
          TOAST_DELETE: "Оплата удалена!",

          ORGANIZATION_EMPLOYEE: "Сотрудник организации:",
          ORGANIZATION_PAYMENT_PACK: "Пачка оплаты:",
          PAYER_FIO: "Ф.И.О плательщика:",
          AMOUNT: "Сумма:",
          PURPOSE: "Цель:",
          COMMENT: "Комментарий:",
        },
      },
      ORGANIZAION_LIST: {
        TABLE_HEADERS: {
          ID: "ID",
          CompanyID: "Компания",
          NAME: "Название организации",
          EMPLOYEE_COUNT: "Кол-во сотруд",
          DIRECTOR_FIO: "Ф.И.О директора",
          DEBITORS: "Дебиторы",
          CREDITORS: "Кредиторы",
          COUNT: "Кол-во",
          PAYMENT: "Сумма платежей за текущий период",
          SUM: "Сумма",
          PHONE_NUMBER: "Номер телефона",
          EMAIL: "E-mail",
          BANK_MFO: "Банк МФО",
          STIR: "STIR",
          BANK_ACCOUNT: "Банковский счет",
          ADDRESS: "Адрес",
          DESCRIPTION: "Комментарий",
          IS_BUDGET_ORG: "Бюджетная организация",
          OKED: "ОКЭД",
        },
        MODAL: {
          TITLE_ADD: "Добавление организации",
          TITLE_EDIT: "Редактирование организации",
          TITLE_DELETE: "Удаление организации",
          TITLE_EXPORT: "Экспорт списка организаций",
          CONFIRMATION_MODAL_TEXT:
            "Вы действительно хотите удалить выбранную организацию из системы?",
          TITLE_IMPORT_EMPLOYEES: "Импорт списка сотрудников организации",
          BUTTON_IMPORT_EMPLOYEES: "Импортировать сотрудников",
          DATE: "Введите дату:",
          CompanyID: "Компания:",
          NAME: "Название организации:",
          DIRECTOR_FIO: "Ф.И.О директора:",
          PHONE_NUMBER: "Номер телефона:",
          EMAIL: "E-mail:",
          BANK_MFO: "Банк МФО:",
          STIR: "STIR:",
          BANK_ACCOUNT: "Банковский счет:",
          ADDRESS: "Адрес:",
          DESCRIPTION: "Комментарий:",
          IS_BUDGET_ORG: "Бюджетная организация:",
          OKED: "ОКЭД:",
        },
      },

      ORGANIZAION_DEPARTMENT: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_ID: "Название организации",
          NAME: "Название отдела организации",
          DESCRIPTION: "Комментарий",
        },
        MODAL: {
          TITLE_ADD: "Добавление раздела организации",
          TITLE_EDIT: "Редактирование раздела организации",
          TITLE_DELETE: "Удаление раздела организации",
          CONFIRMATION_MODAL_TEXT:
            "Вы действительно  хотите удалить этот раздел организации из системы?",

          ORGANIZATION_ID: "Название организации:",
          NAME: "Название отдела организации:",
          DESCRIPTION: "Комментарий:",
        },
      },
      ORGANIZATION_EMPLOYEES: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_ID: "Название организации",
          FULLNAME: "Ф.И.О сотрудника",
          ABONENT_FIO: "Ф.И.О абонента",
          POSITION: "Должность",
          TABLE_NUMBER: "Табличка №",
          REZIDENT: "Резидент",
          ACCOUNT_NUMBER: "Номер счета",
          NEIGHBORHOOD: "Махалля",
          STREET: "Улица",
          HOUSE: "Дом",
          INDEX: "Индекс",
          KV: "Квартира",
          LIVING_COUNT: "Кол-во жителей",
          PERIOD: "Период",
          SATART_SALDO: "Начальное сальдо",
          ACT: "Акт",
          CALCULATED: "Начисление",
          QAMOUNT: "Поступление",
          END_SALDO: "Кон.сальдо",
          DESCRIPTION: "Комментарий",
        },
        MODAL: {
          TITLE_ADD: "Добавление сотрудника в организационный отдел",
          TITLE_EDIT: "Редактирование сотрудника организационного отдела",
          TITLE_DELETE: "Удаление сотрудника организационного отдела",
          TITLE_EXPORT: "Организация экспорт сотрудников в ехcел",
          CONFIRMATION_MODAL_TEXT:
            "Вы действительно хотите удалить этого сотрудника организационного отдела из системы?",
          ACCOUNT_NUMBER: "Номер счета:",
          FULLNAME: "Имя сотрудника:",
          REZIDENT_FULLNAME: "Абoнент Ф.И.О:",
          POSITION: "Должность:",
          TABLE_NUMBER: "Табличка №:",
          DESCRIPTION: "Комментарий:",
          REZIDENT: "Резидент",
        },
        FILTER: {
          LITSEVOY: "Номер счета",
          MAHALA: "Махалля",
          STREET: "Улица",
          HOME: "Дом",
          FLAT: "Квартира",
          TABLE_NUMBER: "Табличка №",
          FULLNAME: "Сотрудник Ф.И.О",
          SEARCH_EMPLOYEES: "Поиск сотрудников",
          SEARCH_RESIDENTS: "Поиск по подписчикам",
        },
      },
    },
    REPORTS: {
      REPORT_TYPE_MAHALLA: "Махалля",
      REPORT_TYPE_STREET: "Улица",
      PUBLIC_CONTRACT_REPORT: {
        TITLE: "Отчет по договору публичной оферты",
        MAHALLA_COUNT: "Количество махаллей",
        ATTACH_MAHALLA_CONTRACT_TOTAL:
          "Общее количество махаллей, к которым прикреплен новый образец публичного договора",
        ATTACH_MAHALLA_CONTRACT_COUNT:
          "Количество махаллей, к которым прикреплён новый образец публичного договора на выбранную дату",
        WARNING_COUNT:
          "Общее количество отправленных SMS по публичному договору",
        CONFIRM_RESIDENT_COUNT:
          "Количество абонентов, ознакомившихся и подтвердивших (публичный договор) через SMS",
        UN_ATTACH_MAHALLA_CONTRACT_COUNT:
          "Количество махаллей, к которым не прикреплен новый образец публичного договора",
        UN_CONFIRM_RESIDENT_COUNT:
          "Количество абонентов, не подтвердивших (публичный договор) через SMS",
      },
      RESIDENTS_FEEDBACK_REPORT: {
        TABLE_HEADERS: {
          NAME: "Hаименование",
          RESIDENT_FEEDBACK_EXCELLENT:
            "Количество отзывов со статусом «Отлично»",
          RESIDENT_FEEDBACK_GOOD: "Количество отзывов со статусом «Хорошо»",
          RESIDENT_FEEDBACK_SATISFACTORY:
            "Количество отзывов со статусом «Удовлетворительно»",
          RESIDENT_FEEDBACK_UNSATISFACTORY:
            "Количество отзывов со статусом «Неудовлетворительно»",

          RESIDENT_FEEDBACK_CONTRACT: "Количество договоров публичной оферты",
        },
      },
      PNFL_CADASTR_COUNT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          PNFL_COUNT: "ПИНФЛ",
          PNFL_PERCENT: "Всего введенные ПИНФЛ в %",
          CADASTRE_PERCENT: "Всего введенные номера кадастров в %",
          RESIDENT_COUNT: "Всего абонентов",
          CADASTRAL_NUMBER_COUNT: "Кадастровый номер",
        },
        INPUTS: {
          OWNER_SHIP_TYPES: "Тип компании",
        },
      },

      RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT: {
        TABLE_HEADERS: {
          NAME: "Hаименование",
          TOTAL: "Общее количество абонентов с аннулированной идентификацией",
          INVALID_PASSPORT_SERIAL_COUNT:
            "Количество недействительных серий паспортов",
          INVALID_PINFL_COUNT: "Количество недействительных ПИНФЛ",
          PHOTO_COUNT: "Количество фотографий",
          INVALID_CADASTRAL_NUMBER_COUNT:
            "Количество недействительных кадастровых номеров",
          CYRILLIC_COUNT: "Количество Ф.И.О на кириллице",
          INVALID_COATO_COUNT: "Количество недействительных кодов СОАТО",
          INVALID_ELECTRICITY_ACCOUNT_NUMBER_COUNT:
            "Количество недействительных номеров лицевого счёта по электроэнергии",
          COATO_MATCHDISTRICTCOATO_COUNT:
            "Количество абонентов, у которых СОАТО района не совпадает с СОАТО абонента",
          DUPLICATE_CADASTRAL_NUMBER_COUNT:
            "Количество дубликатов кадастровых номеров",
          DUPLICATE_ELECTRICITY_ACCOUNT_NUMBER_COUNT:
            "Количество дубликатов номеров лицевого счёта по электроэнергии",
        },
        CANCELED_RESIDENTS: {
          TABLE_HEADERS: {
            FIO: "Ф.И.О",
            ACCOUNT_NUMBER: "Лицевой счет",
            REASON_STATUS: "Статус причины",
            DATE: "Дата",
          },
          REASON_STATUS: {
            DEFAULT: "По умолчанию",
            INVALID_PINFL: "Недействительный ПИНФЛ",
            INVALID_PASSPORT_SERIAL: "Недействительная серия паспорта",
            PHOTO: "Фотография",
            INVALID_CADASTRAL_NUMBER: "Недействительный кадастровый номер",
            CYRILLIC: "Кириллическая запись",
            INVALID_COATO: "Недействительный код СОАТО",
            INVALID_ELECTRICITY_ACCOUNT_NUMBER:
              "Недействительный номер лицевого счёта по электроэнергии",
            COATO_MATCH_DISTRICT_COATO: "Совпадение СОАТО с районным СОАТО",
            DUPLICATE_CADASTRAL_NUMBER: "Дубликат кадастрового номера",
            DUPLICATE_ELECTRICITY_ACCOUNT_NUMBER:
              "Дубликат номера лицевого счёта по электроэнергии",
          },
        },
      },
      ELECTRICITY: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          RESIDENT_COUNT: "Количество абонентов",
          CADASTRAL_NUMBER_COUNT:
            "Номер кадастрового номера, введенного в систему",
          INSERTED_ETC_ACCOUNT_COUNT:
            "Количество абонентов, у которых введен номер лицевого счета ЭТК",
          CADASTRE_NUMBER_COUNT_BY_ETC_ACCOUNT:
            "Номер кадастрового номера, введенного в систему (По данным ЭТК л/с введен в систему)",
          PHONE_NUMBER_COUNT:
            "Абонентский номер, по которому номер телефона вводится в систему",
          ETC_ACCOUNT_PERCENT:
            "% от общего количества абонентов к числу абонентов, у которых включен персональный номер ЭТК",
          NOT_INSERTED_ETC_ACCOUNT_COUNT:
            "Количество абонентов без номера счета ETK",
        },
        TABLE_HEADERS_2: {
          ACCOUNT_NUMBER: "Лицевой счет",
          CADASTRAL_NUMBER: "Кадастровый номер",
          COMPANY_NAME: "Наим. компании",
          ELECTRICITY_ACCOUNT_NUMBER: "Лицевой элекртосеть",
          FULL_NAME: "Ф.И.О",
          INN: "ИНН",
          PHONE_NUMBER: "Телефон",
          STREET_NAME: "Улица",
        },
        MODAL_TITLE: "Абоненты",
        EXCEL_NAME: "Отчет о сравнении электроэнергии",
      },
      MAHALLA_DEBITORS_ANALYSIS: {
        PERIOD: "Период",

        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          ABONENT_COUNT: "Кол-во абонентов",
          TOTAL_PEOPLE_COUNT: "Кол-во прожив",
          CALCULATED: "Начисление",
          COUNT: "Кол-во",
          SUM: "Сумма",
          TOTAL: "Итого",
          CREDITORS: "Кредиторы",
          DEBTORS: "Дебиторы",
          DEBTORS_0_TO_50_000: "Задолженность (0-50 000)",
          DEBTORS_50_000_TO_100_000: "Задолженность (50 000-100 000)",
          DEBTORS_100_000_TO_300_000: "Задолженность (100 000-300 000)",
          DEBTORS_300_000_TO_500_000: "Задолженность (300 000-500 000)",
          DEBTORS_500_000_TO_1_000_000: "Задолженность (500 000-1 000 000)",
          DEBTORS_1_000_000_UPPER: "Долг свыше 1 000 000",

          CREDITORS_0_TO_50_000: "Кредитор (0-50 000)",
          CREDITORS_50_000_TO_100_000: "Кредитор (50 000-100 000)",
          CREDITORS_100_000_TO_300_000: "Кредитор (100 000-300 000)",
          CREDITORS_300_000_TO_500_000: "Кредитор (300 000-500 000)",
          CREDITORS_500_000_TO_1_000_000: "Кредитор (500 000-1 000 000)",
          CREDITORS_1_000_000_UPPER: "Кредит свыше 1 000 000",

          CREDITORS_TOOLTIP:
            "Имеются абоненты с предоплатой больше 300 000 сум",
        },
      },
      COURT_PROCESS_ANALYSIS_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          TOTAL: "Итого",
          FROM_THAT: "Из этого",
          TO_5: "до 5 дней",
          FROM_5_TO_10: "от 5 до 10 дней",
          FROM_10_TO_30: "от 10 до 30 дней",
          FROM_30_TO_60: "от 30 до 60 дней",
          MORE_60: "больше 60 дней",
        },
        COURT_STATUS: {
          WARNED: "Оповешен",
          DOCUMENT_PREPARATION: "Подготовление судебных документов",
          DOCUMENTS_SENT: "Документы отправлены в суд",
          COURT_DECISION: "Занесен постановление суда ",
          DEBT_PAID: "Задолженность полностью оплачен",
        },
        PLACEHOLDER: {
          STATUS: "Статус",
        },
      },
      DHSH_1: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          ABONENT_COUNT: "Кол-во абонентов",
          TOTAL_PEOPLE_COUNT: "Кол-во прож.",
          N_SALDO: "Начальное сальдо",
          START_PERIOD_DT_COUNT: "Кол-во ДТ (Нач.периода)",
          START_DT_COUNT: "На начало ДТ",
          END_PERIOD_DT_COUNT: "Кол-во ДТ (Кон.периода)",
          END_DT_COUNT: "На конец ДТ",
          START_PERIOD_KT_COUNT: "Кол-во КТ (Нач.периода)",
          START_KT_COUNT: "На начало КТ",
          END_PERIOD_KT_COUNT: "Кол-во КТ(Кон.периода)",
          END_KT_COUNT: "На конец КТ",
          CALCULATED: "Начисление",
          REVENUE: "Поступление",
          INCOME_KVIT: "Денежные выплаты",
          INCOME_E_PAYMENT: "Поступл. эл.плат.",
          INCOME_MUNIS_PAYMENT: "Поступл. Мунис",
          INCOME_1031_PAYMENT: "Платежи по БПИ и 1031",
          INCOME_ACT: "Акт",
          K_SALDO: "Кон.сальдо",
          NEW_ABONENT_COUNT: "Количество новых абонентов",
          NEW_ABONENT_N_SALDO: "Начало(Нач.периода) баланса новых абонентов",

          TOTAL_INCOME: "Общий доход",
        },
      },
      RESIDENTS_HIGH_DEBT_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Ф.И.О",
          ACCOUNT_NUMBER: "Лицевой счет",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          INDEX: "Индекс",
          KV: "Кв.",
          inhabitants: "Кол-во прожив",
          SALDO_BEGINING: "Начальное сальдо",
          WAS_CALCULED: "Начисление",
          CALCULATED: "Начисление",
          ACT: "Акт",
          PAYMENTS: "Платежи",
          TOTAL: "Всего",
          MUNIS: "Мунис",
          CASH: "Наличные",
          TERMINAL: "По терминалу",
          PAYNET: "Paynet",
          PAYME: "Payme",
          UPAY: "UPay",
          CLICK: "Click",
          PLATEJI_1031: "Платежи_1031",
          SALDO_END: "Кон.сальдо",
        },
        PLACEHOLDER_FILTER: {
          COMPANY_NAME: "Название компании",
          COMPANY_TYPE: "Тип компании",
          N_SALDO_RANGE: "Диапазон задолженности",
        },
      },
      ONLINE_APPEALS_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          ALL_APPEALS: "Общее количество заявок (месяц)",
          UNANSWERED_APPEALS: "Количество неотвеченных запросов",
          APPLICATION_RECEIVED: "Количество полученных заявок",
          ANSWERED_APPEALS: "Количество отвеченных запросов",
          APPLICATION_REJECTED: "Количество отклоненных запросов",
        },
      },
      COURT_PROCESS_PERIODIC: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          RESIDENTS_DEBT: "Абоненты должники",
          WARNED: "Оповешен",
          DOCUMENT_PREPARATION: "Подготовление судебных доку...",
          SEND_TO_COURT: "Документы отправлены в суд",
          COURT_DECISION: "Занесен постановление суда",
          DEBT_PAID_FULL: "Задолженность полностю опл...",
          COUNT: "Кол-во",
          SUMMA: "Сумма",
        },
        RESIDENT_DATATABLE: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCOUNT_NUMBER: "Номер счета",
            NAME: "Ф.И.О",
            STATUS: "Статус",
            WARNING_DATE: "Дата предупреждения",
            WARNING_AMOUNT: "Сумма предупреждения",
            N_SALDO: "Начальное сальдо",
            COMPANY_NAME: "Название компании",
            CREATED_BY_USER: "Создавший пользователь",
          },
          WARNED_FILE: "Предупреждающий файл",
          DOCUMENT_PREPARATION_FILE: "Судебные документы",
          COURT_DECISION: "Судебный приказ",
        },

        WARNED_FILE: "Файл предупреждения",
        DOCUMENT_PREPARATION_FILE: "Документы суда",
        COURT_DECISION: "Распоряжение суда",

        SEND_TO_COURT_FILE: "Судебные документы",
        COURT_ORDER: "Судебные решения",
      },
      UNPAID_RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          ABONENT_COUNT: "Кол-во абонентов",
          COUNT: "Кол-во",
          DEBTOR: "Задолженность",
          DEBTOR_0_3_MONTH: "Задолженность оплаты на 0 - 3 месяц",
          DEBTOR_3_6_MONTH: "Задолженность оплаты на 3 - 6 месяц",
          DEBTOR_6_12_MONTH: "Задолженность оплаты на 6 - 12 месяц",
          DEBTOR_12_36_MONTH: "Задолженность оплаты на 12 - 36 месяц",
          DEBTOR_36_UPPER_MONTH: "Задолженность оплаты более на 36 месяц",
        },
        DEBTOR: "Задолженность",
        CREDITOR: "Предоплата",
      },
      MUNIS_REPORTS: {
        RESIDENTS_LIST: "",
        TABLE_HEADERS: {
          ID: "ID",
          PERIOD: "Период",
          COMPANY_NAME: "Название компании",
          ACCOUNT_NUMBER: "Лицевой счет",
          DOCUMENT_NUMBER: "№ документа",
          DOCUMENT_DATE: "Дата документа",
          DAY_PAYMENT: "Дата оплаты",
          TIME_PAYMENT: "Время платежа",
          SUMMA: "Сумма",
          RESIDENT_FIO: "Ф.И.О абонента",
          BANK_MFO: "МФО",
          HASH: "Р/С",
          INN: "ИНН",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          FLAT_NUMBER: "Кв",
          NAME: "Hаименование",
          PURPOSE: "Детали платежа",
          DELETE: "Состояние",
        },
        RESIDENTS_TABLE: {
          ID: "ID",
          NAME: "Ф.И.О",
          ACCOUNT_NUMBER: "Номер счета",
          INHABITANT_CNT: "Количество жителей",
          SUMMA: "Сумма",
          COMPANY_NAME: "Название компании",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          INDEX: "Индекс",
        },
      },
      MUNIS_PAYMENTS: {
        TABLE_HEADERS: {
          PERIOD: "ID",
          NAME: "Hаименование",
          TOTAL: "Всего",
          ACTIVE_CONTRACT: "По активным договорам",
          CANCEL_CONTRACT: "По расторгнутым договорам",
          PAYMENT_COUNT: "Кол-во платежей",
          SUM: "Сумма",
        },
        DEBTOR: "Предоплата",
        CREDITOR: "Задолженность",
      },
      RESIDENTS_WITH_HIGH_INDEBTEDNESS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          TOTAL_MONTHLY: "Итого ежемесячно",
          RESIDENTS: "Aбоненты",
          INHB_COUNT: "Кол-во прожив.",
          N_SALDO: "Начальное сальдо",
          BY_FILTER: "По фильтру",
          CALCULATED: "Начисление",
          ACT: "Акт",
          REVENUE: "Платежи",
          REVENUE_TOTAL: "Всего",
          MUNIS: "МУНИС",
          CASH: "Наличные",
          TERMINAL: "По терминалу",
          PAYNET: "Paynet",
          PAYME: "Payme",
          U_PAY: "UPay",
          CLICK: "Click",
          PAYMENT_1031: "Платежи по БПИ и 1031",
          MONTH_END: "В конце месяца",
          K_SALDO: "Кон.сальдо",
          INV_ACT: "Акты инвентаризации",
          ONLINE_PAYMENTS: "Онлайн платежи",

          ACCOUNT_NUMBER: "Лицевой счет",
          PAYMENT: "Платежи",
          CALCULATE: "Начисление",
          DATE: "Дата посл. инв.акта",
          MAHALLA_NAME: "Махалля",
          STREET: "Улица",
          HOUSE: "Дом",
          INDEX: "Инд.",
          FLAT_NUMBER: "Кв",
          FILES: "Прикрепленный файл",
        },
      },
      ELECTRICITY_PAYMENTS_REPORTS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          TOTAL: "Всего",
          COUNT: "Кол-во",
          SUMMA: "Сумма",
          PAYNET: "Paynet",
          PAYME: "Payme",
          UPAY: "UPay",
          CLICK: "Click",
          UZ_POCHTA: "УзПочта",
          EcoPay: "EcoPay",
          Oson: "Oson",
          UZUM_BANK: "UZUM BANK",
        },
      },
      REPORT_ANALYTICAL_SMS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Hаименование",
          TOTAL_SMS_SEND: "Общее количество отправленных SMS",
          TOTAL_DEBT: "Общая сумма долга",
          TOTAL_PAYMENT_NUMBER: "Количество платных подписчиков",
          TOTAL_PAYMENT_SUM: "Выплаченная сумма",
          SUCCESS_SMS: "Успешные СМС (%)",
        },
      },
      REVENUES_DXSH_2: {
        TABLE_HEADERS: {
          NAME: "Hаименование",
          FROZEN_DEBT:
            "Замороженная дебиторская задолженность на начало периода",
          FROZEN_REVENUE: "Поступления от замороженных долгов",
          MONTH_END_DEBT: "Задолженность на конец месяца",
          DXSH_COSTS_20: "Расходы по взысканию ГЧП (20%)",
          DXSH_COSTS_80: "Взыскание замороженной задолженности (80%)",
        },
      },
      REVENUES_DXSH: {
        TABLE_HEADERS: {
          NAME: "Hаименование",
          TOTAL_REVENUE_AMOUNT: "Общая сумма выручки",
          FROM_THAT: "Из этого",
          RECEIPTS: "Квитанции",
          ELECTRONIC_PAYMENTS: "Электронные платежи",
          MUNIS: "МУНИС",
          REVENUE_1031: "Квитанции БПИ и 1031",
          DHSH_REVENUES: "ГЧП поступления",
          FROZEN_DEBT: "Замороженный долг",
          MONTH_START_DEBT: "Задолженность за месяц",
          REVENUE: "Поступление",
          AKT: "Aкт",
          MONTH_END_DEBT: "Задолженность на конец месяца",
          DXSH_PAYMENT_20: "Расходы по взысканию ГЧП",
          FROZEN_DEBT_80: "Взыскание замороженной задолженности",
        },
        RESIDENTS_TABLE: {
          NAME: "Ф.И.О",
          ACCOUNT_NUMBER: "Лицевой счет",
          PERIOD: "Период",
          COMPANY_NAME: "Название компании",
          FRONZEN_DEBT: "Замороженный долг",
          N_SALDO: "Начальное сальдо",
          REVENUE: "Поступление",
          AKT: "Акт",
          DEBT_ACT: "Дебитовый акт",
          K_SALDO: "Кон.сальдо",
        },
      },
      NOTICE_LIMITS_REPORTS: {
        NAME: "Hаименование",
        TOTAL_SMS_SEND: "Общее количество отправленных СМС ",
        FOR_REGISTRATION: "Для регистрации",
        FROM_THAT: "Из этого",
        FROM_NOTIFICATIONS: "Для предупреждений",
        LIMITS: "Лимит",
        WAS_USED: "Росход",
        OTHER_TYPE: "Другие виды СМС",
      },
      GPS_WORKING_TIME: {
        ON_MAP_MODAL_TITLE: "Ежедневная карта маршрутов спецтехники",
        ON_MAP_MODAL_NO_DATA: "Маршрут не найден",
        ON_MAP_MODAL_START_BTN: "Посмотреть движение маршрута",
        ON_MAP_MODAL_CHOSEN_DATE_BTN: "Посмотреть маршрута",
        ON_MAP_MODAL_PAUSE_BTN: "Пауза",
        ON_MAP_MODAL_CONTINUE_BTN: "Продолжить движения",
        ON_MAP_MODAL_STOP_BTN: "Остановить движение маршрута",
        ON_MAP_MODAL_END_TIME: "Время окончания движения",
        ON_MAP_MODAL_ACTION_START_TIME: "Время начала действия",
        ON_MAP_MODAL_ACTION_END_TIME: "Время окончания действия",
        ON_MAP_MODAL_ATTENTION:
          "Введите день, время начала и время окончания, чтобы увидеть ежедневную карту маршрутов спецтехники!",
        TABLE_HEADERS_REPUBLIC: {
          NAME: "Название",
          NUMBER_TOTAL_TECHNIQUE: "Общее количество техник",
          ON_AVERAGE: "Усреднено по общему количеству методик",
          NUMBER_DAYS_WORK: "Количество рабочих дней",
          TOTAL_TIME: "Общее время",
          ENGINE_ACTIVE_TIME: "Активное время двигателя",
          ENGINE_NO_ACTIVE_TIME: "Время простоя двигателя",
          MOVE_TIME: "Время в движении",
          MOTIONLESS_ENGINE_ACTIVE_TIME: "Холостой ход, время работы двигателя",
          TOTAL_KILOMETER: "Пройденное расстояние (км)",
          AVERAGE_SPEED: "Средняя скорость (км/ч)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
        },
        TABLE_HEADERS_COMPANY: {
          VEHICLE_NUMBER: "Номер автомобиля",
          NUMBER_DAYS_WORK: "Количество рабочих дней",
          TOTAL_TIME: "Общее время",
          ENGINE_ACTIVE_TIME: "Активное время двигателя",
          ENGINE_NO_ACTIVE_TIME: "Время простоя двигателя",
          MOVE_TIME: "Время в движении",
          MOTIONLESS_ENGINE_ACTIVE_TIME: "Холостой ход, время работы двигателя",
          TOTAL_KILOMETER: "Пройденное расстояние (км)",
          AVERAGE_SPEED: "Средняя скорость (км/ч)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
          ON_MAP: "На карте",
        },
        TABLE_HEADERS: {
          DATE: "Дата",
          ACTION_START_TIME: "Время начала движения",
          ACTION_START_LOCATION: "Место, где началось действие",
          ACTION_END_TIME: "Времые завершение действии",
          ACTION_END_LOCATION: "Место, где завершается действие",
          TOTAL_TIME: "Общее время",
          ENGINE_ACTIVE_TIME: "Активное время двигателя",
          ENGINE_NO_ACTIVE_TIME: "Время простоя двигателя",
          AVERAGEMILAEGE_PERDAY: "Среднее дневное пройденное расстояние (км)",
          MOVE_TIME: "Время в движении",
          MOTIONLESS_ENGINE_ACTIVE_TIME: "Холостой ход, время работы двигателя",
          TOTAL_KILOMETER: "Пройденное расстояние (км)",
          AVERAGE_SPEED: "Средняя скорость (км/ч)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
        },
        DAY: "День",
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Отчет в разрезе провинций о работе специальной мусоровозной техники {{date}}",
          BY_REGION:
            "Отчет в разрезе районов о работе специальной мусоровозной техники {{date}}",
          BY_DISTRICT:
            "Отчет в разрезе предприятий о вводе в эксплуатацию специальной мусоросжигательной техники {{date}}",
          BY_COMPANY:
            "Отчет в разрезе автомобилей о запуске специальной техники для вывоза отходов {{date}}",
          BY_AUTOMOBILE:
            "Отчет о работе специальной мусоровозной техники {{date}}",
        },
      },
      VISITS_TO_POLYGON: {
        TABLE_HEADERS: {
          VISITS_COUNT_FOR_LAST_DAY:
            "Количество посещений за последний день ({{items}})",
          VISITS_COUNT_FOR_LAST_WEEK:
            "Количество посещений за последнюю неделю ({{from}} - {{to}})",
          VISITS_COUNT_FOR_LAST_MONTH:
            "Количество посещений за последний месяц ({{from}} - {{to}})",
          VISITS_COUNT_FOR_LAST_DAY1: "Количество посещений за последний день",
          VISITS_COUNT_FOR_LAST_WEEK1:
            "Количество посещений за последнюю неделю",
          VISITS_COUNT_FOR_LAST_MONTH1:
            "Количество посещений за последний месяц",
          AUTO: "Автомобиль",
          COMPANY: "предприятие",
          DATE: "Дата",
          TIME_IN: "Время входа",
          TIME_OUT: "Время выхода",
        },
        FILTER_COMPONENT: {
          START_DATE_FOR_CALCULATE_INTERVAL:
            "Начальная дата для расчета интервала",
        },
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Количество посещений полигонов в разрезе регионов {{date}}",
          BY_REGION:
            "Количество посещений полигонов в разрезе районов {{date}}",
          BY_DISTRICT: "Количество посещений в разрезе полигонов {{date}}",
          BY_POLIGON_DAY:
            "Количество ежедневных посещений в разрезе полигонов {{date}}",
          BY_POLIGON_WEEK:
            "Количество еженедельных посещений в разрезе полигонов {{date}}",
          BY_POLIGON_MONTH:
            "Количество посещений в месяц в разрезе полигонов {{date}}",
        },
      },
      VISITS_TO_LEGAL: {
        LOCATION_ON_THE_MAP: "Местоположение на карте",
        LEGAL_RESIDENT_NAME: "Юридический абонент",
        ADDRESS: "Адрес",
        DIRECTOR: "Директор",
        IS_ADDRESS: "Район {{ village }}, улица {{ street }}",
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Количество посещений в разрезе регионов юридических абонентов {{date}}",
          BY_REGION:
            "Количество посещений в разрезе районов юридических абонентов {{date}}",
          BY_DISTRICT:
            "Количество посещений в разрезе юридических абонентов {{date}}",
          BY_POLIGON_DAY:
            "Количество ежедневных посещений в разрезе юридических абонентов {{date}}",
          BY_POLIGON_WEEK:
            "Количество еженедельных посещений в разрезе юридических абонентов {{date}}",
          BY_POLIGON_MONTH:
            "Количество посещений в месяц в разрезе юридических абонентов {{date}}",
        },
      },
      ENTRY_TIME: {
        REGION_LEVEL_TABLE_HEADERS: {
          NAME: "Название",
          DURATION_IN_TIME: "Продолжительность пребывания на территории",
          MOVING_DURATION_IN_TIME: "Продолжительность времени в движении",
          PARKING_DURATION_IN_TIME: "Продолжительность времени отсутствия",
          MILEAGE: "Пройденное расстояние (км)",
          STOPS_COUNT: "Количество остановок",
          AVG_SPEED: "Средняя скорость (км/ч)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
          VISIT_COUNT: "Количество посещений",
        },
        MAHALLA_LEVEL_TABLE_HEADERS: {
          VISIT_DATE: "Дата",
          AUTOMOBILE_NUMBER_AND_MODEL: "Номер и модель автомобиля",
          COMPANY_NAME: "Название компании",
          DRIVER: "Водитель",
          TIME_IN: "Время входа",
          TIME_OUT: "Время выхода",
          DURATION_IN_TIME: "Продолжительность пребывания на территории",
          MOVING_DURATION_IN_TIME: "Продолжительность времени в движении",
          PARKING_DURATION_IN_TIME: "Продолжительность времени отсутствия",
          MILEAGE: "Пройденное расстояние (км)",
          STOPS_COUNT: "Количество остановок",
          AVG_SPEED: "Средняя скорость (км/ч)",
          MAX_SPEED: "Максимальная скорость (км/ч)",
          ON_MAP: "На карте",
        },
        EXCEL_TITLE: "Время въезда-выезда техники в регионы {{date}}",
        ALL_ROADS_ON_MAP: "Все визиты",
      },
      MFA_1: {
        TABLE_HEADERS: {
          NAME: "Название",
          DEBT_INTEREST: "Задолж.(увелич/уменьш)",
          INV: "Кол-во перв. инв",
          ABONENTS_COUNT: "Количество абонентов",
          TOTAL: "Всего",
          NEW_ABONENTS: "Новые абоненты",
          NUMBER_OF_INHABITANTS: "Количество жителей",
          COUNT: "Кол-во",
          SUMMA: "Сумма",
          N_SALDO: "Начальное сальдо",
          START_DT: "На начало дебитор",
          START_DT_COUNT: "На начало дебитор",
          START_KT_COUNT: "На начало кредитор",
          CALCULATE: "Начисление",
          QQS_PRICE: "сумма НДС",
          ALL_PAYMENTS: "Все платежи",
          COMPANIES_COUNT: "Количество компаний",
          CASH_RECEIPTS: "Поступл. квит.",
          ELECTRONIC_PAYMENTS: "Электронные платежи",
          MUNIS: "МУНИС",
          MIB_AND_1031: "БПИ и платежи по 1031",
          AKT: "Акт",
          K_SALDO: "Кон.сальдо",
          END_DT_COUNT: "На конец ДТ",
          END_KT_COUNT: "На конец КТ",
          MAHALLA: "Махалля",
        },
      },
      MFA_4: {
        TABLE_HEADERS: {
          NAME: "Название",
          AKT_COUNT: "Количество актов",
          AKT_SUMMA: "Сумма актов",
          DEBITORS: "Дебитор",
          COUNT: "Количество",
          SUMMA: "Сумма",
          CREDITOR: "Kредитор",
          INVENTORY: "Предв.инвентаризация",
          CANCEL_CONTRACT: "Отменить договор",
          CANCEL_AKT: "Отмененные акты",
        },
      },
      MFA_2: {
        TABLE_HEADERS: {
          NAME: "Название",
          CURRENT_PERIOD: "Текущий период",
          CURRENT_RATE: "Текущий тариф",
        },
      },
      MFA_6: {
        TABLE_HEADERS: {
          NAME: "Название",
          TOTAL: "Всего",
          MAHALLA_COUNT: "Количество махалли",
          ABONENTS_COUNT: "Количество абонентов",
          INHABITANT_CNT: "Количество жителей",
          DEBTOR: "Задолженность",
          CREDITORS: "Кредитор",
          DT_COUNT: "Количество",
          DT_SUM: "Сумма",
          KT_COUNT: "Количество",
          KT_SUM: "Сумма",
          PARTIALLY_DELETED_MAHALLA: "Частично отключённые Махалли",
          PARTIALLY_DELETED_INHABITANT: "Частично стертое население",
          COMPLETELY_DELETED_MAHALLA: "Полностью отключённые Махалли",
          COMPLETELY_DELETED_INHABITANT: "Полностью отключённые население",
          INCOME: "Доход",
          TEMPORARILY_DELETED: "Временно отключен",
          COUNT: "Количество",
          SUMMA: "Сумма",
        },
      },
      MFA_16: {
        TABLE_HEADERS: {
          NAME: "Название",
          TOTAL_AMOUNT: "Общая сумма",
          TOTAL_CALCULATE: "Всего начислено",
          POPULATION: "Население",
          PAID_ABONENTS: "Количество оплаченных абонентов",
          HOW_MUCH_DEBITOR: "Сумма погашенной дебиторской задолженности",
          HOW_MUCH_CREDITOR: "Сумма погашенной кредиторской задолженности",
          NUMBER_OF_INHABITANTS: "Количество жителей",
          CALCULATE: "Начисление",
          TOTAL: "Всего",
          CHASH_AMOUNT: "Поступление",
          REVENUE: "Поступление",
          TERMINAL: "По терминалу",
          BANK: "Банковские",
          MIB_AND_1031: "БПИ и платежи по 1031",
          MUNIS: "МУНИС",
          ELECTRONIC_INCOME: "Поступл. эл.плат",
          JURIDICAL: "Юридические лица",
          ORGANIZATION_COUNT: "Количество организаций",
        },
        RESIDENTS_TABLE: {
          FISH: "Ф.И.О",
          TOTAL_AMOUNT: "Общая сумма",
          NUMBER_OF_INHABITANTS: "Количество жителей",
          CASH_INCOMES: "Денежные выплаты",
          INCOMES_1031: "БПИ и 1031 квитанция",
          MUNIS_AMOUNT: "Мунис",
          ACT_AMOUNT: "Сумма акта",
          ACCOUNT_NUMBER: "Лицевой счет",
          ACCRUAL: "Начисление",
          N_SALDO: "Начальное сальдо",
          K_SALDO: "Кон.сальдо",
          ELECTRONIC_INCOME: "Поступл. эл.плат",
        },
      },
      MONITORING_ABONENT: {
        TABLE_HEADERS: {
          NAME: "Название",
          PRESCRIBED_CNT: "Количество резидентов в расчетной базе",
          SUCCESS_MIA_PRESCRIBED_CNT: "Количество жителей базы МВД",
          DIFFIRENCE: "Разница",
          ERROR_MIA_PRESCRIBED_CNT:
            "Количество людей,  ввевших  ошибочный кадастровый номер",
          NULL_MIA_PRESCRIBED_CNT:
            "Число людей, не имеющих кадастрового номера",
          RESIDENT_COUNT: "Количество абонентов",
          IDENTIFIED_COUNT:
            "Количество идентифицированных в выбранный момент времени",
          UNIDENTIFIED_COUNT: "Количество неидентифицированных",
          TOTAL_IDENTIFIED_COUNT: "Общее количество идентифицированных",
          IDENTITY_SHARE: "Процент идентифицированных абонентов (%)",
          FOREIGN_IDENTIFIED_COUNT:
            "Общее количество идентифицированных абонентов иностранных государств",
          FOREIGN_IDENTIFIED_COUNT_BY_DATE:
            "Количество идентифицированных абонентов иностранных государств за выбранный период",
        },
        REGISTERED_ABONENT: {
          TABLE_HEADERS: {
            ID: "ID",
            NAME: "Название",
            ACCOUNT_NUMBER: "Лицевой счет",
            MAHALLA_NAME: "Махалля",
            STREET_NAME: "Улица",
            HOME_NUMBER: "Дом",
            FLAT: "Кв",
            HOME_INDEX: "Индекс дома",
            COMPANY_NAME: "Название компании",
          },
        },
      },
      MFA_8: {
        TABLE_HEADERS: {
          NAME: "Название",
          TOTAL: "Всего",
          SUCCESS: "Успешно",
          UNSUCCESSFUL: "Не отправлено",
          REGISTRATION: "Зарегистрироваться",
          PAYME: "Платежи",
          DEBT_WARNINGS: "Предупреждения о задолженности",
          OTHER: "Прочее",
          ETK_SMS: "Отправлено СМС о подключении к РЭС",
        },
      },
      MUNIS: {
        TABLE_HEADERS: {
          NAME: "Название",
          COUNT: "Количество",
          SUMMA: "Сумма",
        },
      },
      SMS_COLLECTION: {
        TABLE_HEADERS: {
          NAME: "Название",
          COUNT: "Количество",
          SUCCESS: "Успешно",
          UNSUCCESSFUL: "Не отправлено",
        },
      },
      NUMBER_DAILY_ABONENTS: {
        TABLE_HEADERS: {
          NAME: "Название",
          MONTH: "Всего за месяц",
          COUNT: "Количество абонентов",
          INHABITANT_CNT: "Количество жителей",
        },
      },
      ACT_STATUS: {
        TABLE_HEADERS: {
          NAME: "Название",
          TOTAL_ACT_COUNT: "Общее количество актов",
          NEW_ACT_COUNT: "Количество новых актов",
          CANCEL_ACT_COUNT: "Количество отмененных актов",
          CONFIRMED_ACT_COUNT: "Количество утвержденных актов",
          WARNED: "Количество уведомленных актов",
          TOTAL: "Всего",
          CURRENT: "Текущий",
          EXPIRED: "Истекший",
          FIXED_ACT_COUNT: "Акты об устранении недостатков",
          WARNED_FIXED_ACT_COUNT:
            "Количество действий, которыми было исправлено уведомление",
          CONFIRMED_CANCELLED_ACTS_COUNT:
            "Количество подтвержденных и отмененных голосов",
        },
        RESIDENT_TABLE_HEADERS: {
          COMPANY: "Название компании",
          PERIOD: "Период",
          ACCOUNT_NUMBER: "Лицевой счет",
          DATA_FILE: "Дата акта",
          SUM: "Сумма",
          ACT_COMMENTARY: "Детали акта",
          ACT_TYPE_ID: "Тип акта",
          MAHALLA_NAME: "Махалля",
          STREET_NAME: "Улица",
          HOME_NUMBER: "Дом",
          HOME_INDEX: "Индекс дома",
          FLAT: "Кв",
        },
      },
      ABONENT_CHANGE: {
        TABLE_HEADERS: {
          NAME: "Название",
          START_MONTH: "Количество абонентов на начало месяца",
          CURRENT_MONTH: "В этом месяце",
          END_MONTH: "Количество абонентов на конец месяца",
          ABONENT_COUNT: "Количество абонентов",
          INHABITANT_COUNT: "Количество населения",

          TOTAL_DECREASED: "Общее уменьшение",
          TOTAL_INCREASED: "Итого увеличилось",
          DELETED_SYSTEM: "Из них: удалено из системы",
          NEW_ADD_SYSTEM: "Из них: добавлено в систему",
        },
      },
      COURT_ACTION_STATUS: {
        TABLE_HEADERS: {
          NAME: "Название",
          TOTAL: "Всего",
          COUNT: "Количество",
          SUMMA: "Сумма",
          CURRENT: "Текущий",
          EXPIRED: "Истекший",
          WARNED: "Предупреждено",
          DOCUMENT_PREPARATION: "Подготовка судебных документов",
          SEND_TO_COURT: "Документы отправлены в суд",
          COURT_DECISION: "Судебное решение вынесено",
          DEBT_PAID_FULL: "Долг полностью погашен",
          FROM: "Дебитор (От)",
          TO: "Дебитор (До)",
        },
      },
      REVENUES_BY_EMPLOYEES: {
        TABLE_HEADERS: {
          NAME: "Название",
          MAHALLA_COUNT: "Количество махалли",
          ABONENT_COUNT: "Количество абонентов",
          DIFFERENCE: "Разница",
          INHABITANT_COUNT: "Число населения",
          PLANS: "План",
          INCOME: "Доход",
          ONE_DAY_INCOME: "Суточный план",
          ONE_MONTH_INCOME: "Доход относительно месячного плана",
          N_SALDO: "Начальное сальдо",
          K_SALDO: "Кон.сальдо",
          DEBITORS: "Дебитор",
          DEBITORS_DIFFERENCE: "Разница дебитора %",
          CREDITOR: "Кредитор",
          CREDITOR_DIFFERENCE: "Разница Кредитор %",
        },
      },
      F_3_DHJ: {
        TABLE_HEADERS: {
          NAME: "Название",
          ABONENTS_COUNT: "Количество абонентов",
          INHABITANT_CNT: "Количество жителей",
          START_DT_COUNT: "На начало дебитор",
          END_DT_COUNT: "На конец дебитор",
          START_KT_COUNT: "На начало кредитор",
          END_KT_COUNT: "На конец кредитор",
          TOTAL_CALCULATE: "Всего начислено",
          CALCULATE: "Начисление",
          DOPLATA: "Оплата",
          REVENUE: "Поступление",
          AKT: "Акт",
          CREDITOR: "Kредитор",
        },
      },
      RESIDENT_VISITS_ACCRUALS: {
        TABLE_HEADERS: {
          NAME: "Название",
          TOTAL: "Всего",
          COUNT: "Количество",
          SUMMA: "Сумма",
          ACCRUALS: "Начисления количество абонентов",
          RESIDENT_COUNT: "Общее количество подключенных абонентов",
        },
      },
      DEBT_SETTLE: {
        TABLE_HEADERS: {
          NAME: "Название",
          COUNT: "Количество",
          SUMMA: "Сумма",
          DEBTOR_SUMMA: "Сумма задолженности",
          PERCENTAGE: "Процент %",
          START_MONTH_DEBTOR_ABONENTS:
            "Должники на начало месяца по отношению к первому месяцу",
          START_MONTH_FILTER_DEBTOR_ABONENTS:
            "Должники на начало месяца по фильтру",
          NEXT_MONTH_INCOME: "Общие поступления за следующий месяц",
          NEXT_MONTH_DEBTOR_INCOME:
            "Общие поступления, взысканные по задолженности в следующем месяце",
          NEXT_MONTH_AKT_DEBTOR:
            "Взысканная дебиторская задолженность по актам в следующем месяце",
          NEXT_MONTH_FILTER_DEBTOR:
            "Взысканная дебиторская задолженность по фильтру в следующем месяце",
          NEXT_MONTH_FILTER_DEBTOR_EXACTLY:
            "Точно взысканная дебиторская задолженность по фильтру в следующем месяце",
          IDENTIFIED_DEBTORS_COUNT:
            "Количество абонентов-должников, прошедших идентификацию",
          IDENTIFIED_MONTHLY_DEBTORS_COUNT:
            "Количество выявленных должников за один месяц",
        },
        PERIOD: "Период",
        ONE_MONTH: "1 месяц",
        THREE_MONTHS: "3 месяц",
        SIX_MONTHS: "6 месяц",
      },
      GRAPH_CONTROL: {
        TABLE_HEADERS: {
          NAME: "Название",
          MAHALLA_COUNT: "Количество махалли",
          RESIDENT_COUNT: "Количество абонентов",
          AUTOMOBILE_COUNT: "Количество автомобилей",
          WASTE_COLLECTION_AREA_COUNT: "Количество площадей для сбора отходов",
          RESIDENT_WASTE_COLLECTION_AREA_COUNT:
            "Количество абонентов, закрепленных за площадкой для сбора отходов",
          RESIDENT_WASTE_COLLECTION_AREA_INHABITANT_COUNT:
            "Количество жителей, закрепленных за площадкой для сбора отходов",
          SUB_MAHALLA_COUNT: "Количество  суб-махалли",
          SUB_MAHALLA_REIDENTS_COUNT: "Количество абонентов суб-махалли",
          SUB_MAHALLA_REIDENTS_INHABITANT_COUNT: "Население в  суб махалли",
          VISIT_GRAPH_COUNT: "График количества посещений",
          TOTAL_VISIT_GRAPH_FILE_COUNT:
            "Общее количество графических файлов посещений",
          TOTAL_SORT_ENABLED_WASTE_COLLECTION_AREA_COUNT:
            "Количество площадок для сбора отходов с раздельным сбором",
          RESIDENT_WASTEAREA_PERCENTAGE:
            "Процент абонентов, прикреплённых к площадке сбора о",
          SUB_MAHALLA_RESIDENTS_PERCENTAGE: "Процент абонентов в суб-махалли",
          BOUND_RESIDENTS_PERCENTAGE: "Процент всех прикреплённых абонентов",
          UNBOUND_RESIDENTS_PERCENTAGE: "Процент всех неп",
        },
      },
      DUPLICATE_CADASTRAL: {
        TABLE_HEADERS: {
          NAME: "Название",
          COUNT: "Количество",
          CADASTRAL_NUMBER: "Кадастровый номер",
        },
      },
      ACT_TYPE: {
        TABLE_HEADERS: {
          NAME: "Название",
          SIMPLE: "Платеж не поступил",
          SERVICE_NOT_PROVIDED: "Услуга не предоставлена",
          CANCEL_CONTRACT: "Расторжение договора",
          INVENTORY: "Изменение количества людей",
          FROZEN: "Замороженная задолженность",
          COUNT: "Количество",
          SUMMA: "Сумма",
          TOTAL: "Всего",
          ALL_ACTS: "Все акты",
          CREDIT: "Kpeдитoвый",
          DEBIT: "Дебетовый",
          CREDITOR: "Кредитор",
          DEBTOR: "Дебитор",
          ECO_PAY: "EcoPay Инвентаризация",
        },
      },
      HET_WARNING: {
        WARNING_COUNT: "Общее количество предупреждений",
        CREATED_COUNT: "Количество предупреждений, созданных в системе",
        SENT_COUNT: "Количество предупреждений, принятых РЭС",
        DELIVERED_COUNT: "Доставленные абонентам уведомления",
        DELIVERED_PAYMENT: "Сумма платежей",
        TRANSMITTED_COUNT: "Количество отправленных оператору",
        NOT_FOUND_ELECTRICITY_ACCOUNT_COUNT:
          "Количество лицевых счетов, не найденных в базе РЭС",
        INVALID_CONSUMER_PHONE_NUMBER_COUNT:
          "Количество абонентов с некорректным номером телефона в РЭС",
        SERVER_ERROR_MESSAGE_COUNT: "Количество ошибок на стороне сервиса РЭС",
        FAILED_COUNT: "Количество сообщений, не отправленных SMS-сервисом",
        COMPLETED_COUNT:
          "Количество абонентов, снятых с предупреждения (через оплату или акт)",
        CANCEL_WARNING_COUNT:
          "Количество предупреждений, отмененных сотрудниками",
        ELECTRICITY_ACCOUNT_NUMBER_CHANGED:
          "Количество абонентов, у которых изменён номер лицевого счёта в РЭС",
        CANCEL_CONTRACT_COUNT: "Количество расторгнутых договоров",
        TOTAL_DEBIT_SUM: "Общая сумма задолженности предупрежденных абонентов",
        WARNING_DEBIT_SUM:
          "Сумма задолженности по предупрежденным (с 07.2025 по текущее время)",
        MAHALLA_COUNT:
          "Количество махаллей, которым было отправлено предупреждение",
        ACCEPTED: "Принято HET",
        SMS_SERVICE_STATUS: "Статус SMS-сервиса",
        PAYMENT: "Платежи, произведённые предупреждёнными абонентами",
        PAYMENT_SUM: "Сумма оплат, произведённых предупреждёнными абонентами",
        ACT_PAYMENT: "Акты, составленные для предупреждённых абонентов",
        ACT_PAYMENT_SUM:
          "Сумма актов, составленных для предупреждённых абонентов",
        CREATED: "Создано",
        SENT: "Отправлено",
        DELIVERED: "Доставлено",
        TRANSMITTED: "Передано оператору",
        NOT_DELIVERED: "Не доставлено",
        REJECTED: "Отклонено",
        FAILED: "Ошибка при отправке",
        EXPIRED: "Истек срок доставки",
        COMPLETED: "Завершено",
        ELECTRICITY_ACCOUNT_NUMBER_CHANGEDS:
          "Изменён СОАТО или номер лицевого счёта за электроэнергию",
        CANCEL_CONTRACT: "Договор расторгнут",
        CANCEL_WARNING: "Предупреждение отменено",
        NOT_FOUND_ELECTRICITY_ACCOUNT: "Код потребителя не найден в базе РЭС",
        INVALID_CONSUMER_PHONE_NUMBER:
          "Некорректный номер телефона потребителя в РЭС",
        SERVER_ERROR_MESSAGE: "Ошибка сервиса РЭС",
        CHANGE_MSG_STATUS_TIME: "Время изменения статуса сообщения",
        USER_FULL_NAME: "Ф.И.О. сотрудника, отменившего предупреждение",
        SENT_TO_BLOCK_COUNT: "Количество отправленных на блокировку",
        SENT_TO_BLOCK: "Отправлено на блокировку",
        ERROR_SEND_WARNING_SMS:
          "Количество предупреждающих сообщений, не доставленных из-за ошибок",
        CANCEL_WARNING_OPERATION:
          "Количество абонентов, для которых предупреждение было отменено по определённым причинам",
        ACCRUAL_TYPE: "Тип начисления",
        DEFAULT: "Обычный",
        GPS_BASED: "На основе GPS",
        LAST_WARNING_DATE: "Дата последнего предупреждения",
        LAST_BLOCK_DATE: "Дата последней блокировки",
        VISIT_BY_IMPACT_ON_ACCRUALS: "Посещения по влиянию на начисления",
        BY_GPS_CALCULATED_AMOUNTS: "По суммам, рассчитанным через GPS",
        VISITS_AFFECTING_ACCRUALS: "Посещения, повлиявшие на начисления",
        VISITS_NOT_COUNTED: "Посещения, не учтённые в расчётах",
        GPS_INCLUDED_AMOUNTS: "Суммы, рассчитанные через GPS, добавлены",
        GPS_EXCLUDED: "Не учитываемые по GPS",
        PERIODS: "Периоды",
        ALL_PERIOD: "Все",
        CURRENT_MONTH: "Текущий месяц",
        LAST_MONTH: "Прошлый месяц",
        MULTIPLE_WARNING: "Выбрать предупреждение",
        MULTIPLE_BLOCK: "Блокировка выбранных предупреждённых",
        MULTIPLE_AUTO_LIST: "Формирование списка",
        AUTO_LIST_BUTTON: "Добавить выбранные в список",
        REMOVE_FROM_AUTO_LIST_BUTTON: "Удалить выбранные из списка",
        IN_LIST: "В списке",
        START_HET_WARNING: "Предупреждение зарегистрированных",
        START_HET_WARNING_POPUP:
          "Функция уведомления должников махаллей, включённых в список, посредством HET",
        START_HET_WARNING_TITLE: "Начать предупреждение",
        START_HET_WARNING_MSG:
          "При этом должникам выбранных махаллей будут выполняться уведомительные действия от имени HET. Вы действительно хотите отправить уведомления должникам махаллей, включённых в список?",
        START_HET_BLOCK: "Заблокировать зарегистрированных",
        START_HET_BLOCK_POPUP:
          "Функция блокировки предупреждённых абонентов махаллей, включённых в список, посредством HET",
        START_HET_BLOCK_TITLE: "Начать блокировку",
        START_HET_BLOCK_MSG:
          "При этом предупреждённым абонентам выбранных махаллей будут выполняться действия блокировки от имени HET. Вы действительно хотите заблокировать предупреждённых абонентов махаллей, включённых в список?",
        HET_BLOCK: "Заблокированные",
        HET_WARNING: "Предупрежденные",
        HET_WARNING_ERROR: "Ошибки при предупреждении",
        BY_AUTO_LIST: "По списку",
        AUTO_LIST_ENABLED: "В списке",
        AUTO_LIST_DISABLED: "Не в списке",
        MAHALLA_PAYMENT:
          "Платежи, выполненные махаллями, которым было отправлено уведомление",
      },
      HET_WARNING_POSSIBLE_RESIDENTS: {
        IDENTIFICATION_COUNT: "Количество идентифицированных абонентов",
        DEBIT_COUNT: "Общее количество абонентов-должников",
        TOTAL_DEBIT: "Общая задолженность",
        WARNING_DEBIT: "Задолженность, подлежащая предупреждению",
        WARNING_DEBIT_PERIOD:
          "Задолженность, подлежащая предупреждению (сформирована с 07.2025)",
        TOTAL_GPS_RESIDENTS: "Абоненты-должники, добавленные по GPS в MFY",
        TOTAL_GPS_RESIDENT_COUNT_AND_IDENTIFY_COUNT:
          "Абоненты, добавленные по GPS в MFY и прошедшие идентификацию",
        IDENTIFY: "Идентификация",
        IDENTIFY_DATE: "Дата идентификации",
        GPS_ENABLE_STATUS: "Статус GPS",
        DISABLED: "Отключен",
        ENABLED_CHYM: "через МСП",
        ENABLED_MAHALLA: "через маҳалла",
        WARNING_COUNT_PERIOD:
          "Кол-во абонентов для предупреждения (сформировано с 07.2025)",
        WARNING_COUNT: "Абоненты для предупреждения",
        MAHALLAS_COUNT: "Кол-во махаллей",
        TOTAL_RESIDENTS_COUNT: "Общее кол-во абонентов",
      },
    },
    RESIDENT_CARD: {
      ACTION_BUTTONS: {
        EDIT_RESIDENT_DATA: "Изменить данные абонента",
        NEW_RECEIPT: "Новая квитанция",
        NEW_ACT: "Новый акт",
        NEW_ACT_CHANGES_HABITANTS: "Новый акт (изменение количества жителей)",
        CHANGE_INHABITANT_CNT: "Изменение количества жителей",
        CHANGE_RESIDENT_INFO: "Изменение данных",
        CHANGE_HOUSE: "Измен.кол-во жильцов",
        FIRST_INVENTAR: "Предв. инвентаризация",
        TERMINATE_CONTRACT: "Расторжение договора",
        CONTRACT: "Продление контракта",
        FIRST_INV: "Первый инвентарь",
        IMPORT_PERIOD_SALDO: "Импорт сальдо на период",
      },
      CANCELLATION_OF_CONTRACT: {
        MODAL_TITLE: "Подтвердить",
        MODAL_TEXT:
          "После отмены абонентского договора повторное подключение невозможно! Вы уверены, что хотите выполнить это действие?",
        BALANCE_IN_HABITANT_ERROR:
          "Количество жителей и текущий баланс абонента должны быть равны нулю.",
        BALANCE_ERROR: "Текущий баланс абонента должен быть равен нулю.",
        HABITANT_ERROR: "Число жителей абонента должно быть равно нулю.",
        SUCCESS_TOAST: "Контракт был расторгнут",
      },
      CONTRACT: {
        MODAL_TITLE: "Продление контракта",
        MODAL_TEXT: "Хотите продлить договор с этим абонентом?",
        SUCCESS_TOAST: "Контракт был продлен.",
      },
      TABS: {
        RESIDENT_INFO: "Данные абонента",
        DXSH: "ОСВ",
        CASH_INCOMES: "Денежные выплаты",
        INCOMES_1031: "БПИ и 1031 квитанция",
        PAYMENT_TRANSACTION: "Электронные платежи",
        MUNIS: "MUNIS",
        AKT_RESIDENT: "Акты",
        RESIDENT_APPEAL: "Абонентские обращения",
        RESIDENT_APPEAL_TO_COURT: "Судебный иск",
        WASTE_COLLECTION_AREAS: "Сумма рассчитанная через МСП",
        ORG_EMPLOYEE: "Сотрудники организации",
        FROZEN_RESIDENTS: "История замораживания",
        RELATION_RESIDENTS: "Номера субсчетов",
        FROZEN_DEBT_ACTS: "Акт замораживания долга",
        ACTIONS: "Действия",
        OLD_ACTIONS: "Старые действия",
        INHABITANTS: "Жители",
        CALCULATION_BY_MAHALLA: "Сумма рассчитанная по махалле",
        HET_WARNING_RESIDENT: "История предупреждений РЭС",
        HET_BLOCK_RESIDENT: "История блокировок РЭС",
      },
      RESIDENT_INFO: {
        CARDS: {
          DESC1: "Период",
          DESC2: "Количество жителей",
          DESC3: "Проживающее на базе МВД.",
          DESC4: "Рассчитано",
          DESC5: "Оплата",
          RESERVE: "кредитор до {{reserve}}",
        },
        CARD_LIST: {
          EMAIL: "E-mail",
          PHONE: "Номер телефона",
          HOME_PHONE: "Домашний телефон",
          PASSPORT_NUMBER: "Номер паспорта",
          PASSPORT_NUMBERS: "ЖШШИР",
          CONTRACT_NUMBER: "Номер контракта",
          SHOT_NUMBER: "Номер счета",
          COMPANY_LOCATION: "Адрес компании",
          CONTRACT_DATE: "Время заключения контракта",
          OWNER_COMPANY: "Владелец компании",
          NOT_INCLUDE_EMAIL: "E-mail не включены",
          NOT_INCLUDE_PHONE: "Номер телефона не включен",
          NOT_INCLUDE_HOME_PHONE: "Домашний телефон не включен",
          NOT_INCLUDE_PASSPORT_NUMBER: "Номер паспорта не включен",
          COMPANY_NAME: "Название компании",
          ADDRESS: "Адрес",
          INN: "ИНН",
          CADASTRAL_NUMBER: "Кадастровый номер",
          ELECTRIC_NUMBER: "Номер электросети",
          ELECTRIC_COATO: "Электрическая энергия COATO",
          DATE_APPROVE_CONTRACT: "Дата утверждения контракта",
        },
        CHART_WIDGETS: {
          TITLE1: "Статистика платежей (cум)",
          TITLE2: "Статистика задолженности / справедливости (Сум)",
          INCOM: "Поступление",
          CALCULATED: "Начисление",
          DEBT: "Долг",
          CURRANCY: "cум",
        },
        INCOMES: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCOUNT_NUMBER: "Номер счета",
            SUM: "Сумма",
            COMPANY_NAME: "Название компании",
            PAYER: "Плательщик Ф.И.О",
            OVERALL_SUM: "Общая сумма",
            PURPOSE: "Цель",
            DESCRIPTION: "Комментарий",
          },
          MODAL: {
            TITLE_ADD: "Добавление входных данных",
            TITLE_EDIT: "Редактировать вход",
            TITLE_DELETE: "Удаление белья",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранную информацию из системы?",
            TOAST_SUCCESS: "Новый вход успешно добавлен!",
            TOAST_SUCCESS_EDIT: "Вход успешно отредактирован!",
            TOAST_DELETE: "Вход удален!",
          },
        },
        ACTIONS: {
          CANCEL_HET_WARNING: "Отмена предупреждения от РЭС",
          CANCEL_HET_WARNING_MESSAGE:
            "Вы действительно хотите отменить предупреждение для этого абонента от РЭС?",
          CANCEL_HET_BLOCK: "Снятие блокировки от РЭС",
          CANCEL_HET_BLOCK_MESSAGE:
            "Вы действительно хотите снять блокировку для этого абонента от РЭС?",
          BLOCKED_DATE_FROM_HET: "Дата блокировки от РЭС:",
          WARNED_DATE_FROM_HET: "Дата предупреждения от РЭС:",
          TABLE_HEADERS: {
            ID: "ID",
            ENTITY_NAME: "Название действия",
            ACCOUNT_NUMBER: "Номер счета",
            RESIDENT_FIO: "Ф.И.О абонента",
            WORK_TYPE_NAME: "Тип работы",
            USER_FULL_NAME: "Ф.И.О пользователя",
            COMPANY_NAME: "Название компании",
            CHANNEL: "Канал",
            CHANGED_VALUE: "Измененное значение",
            ORIGINAL_VALUE: "Исходное значение",
            CHANGED_VALUE_ORIGINAL: "Исходное измененное значение",
            OPERATION: "Операция",
            CHANGE_DATE: "Дата изменения",
            VIEW: "Просмотр",
            OLD_PARAMS: "Старые параметры",
            NEW_PARAMS: "Новые параметры",
            CREATED_AT: "Дата создания",
          },
        },
      },
      DHJ: {},
      FROZEN_RESIDENTS: {
        TABLE_HEADERS: {
          DESCRIPTION: "Комментарий",
          FILE_NAME: "Файл",
          FROM_DATE: "Начальный период",
          TO_DATE: "Конечный период",
        },
        COMPONENTS: {
          INITIAL_PERIOD: "Начальный период",
          FINAL_PERIOD: "Конечный период",
          TOTAL_DURATION: "Общий период:",
          MONTH: "месяц",
          DAY: "день",
          ATTACHED_FILE: "Прикрепленный файл",
          FROZEN_RESIDENTS: "Замороженные абоненты",
        },
        MODALS: {
          ADD_FREEZING_RESIDENTS: "Временное замораживание абонента",
          UN_FREEZING_RESIDENTS: "Размораживание",
          CONFIRM_TEXT: "Вы действительно хотите разморозиться?",
        },
      },
      INHABITANTS: {
        FULL_NAME: "Ф.И.О",
        BIRTH_DATE: "Дата рождения",
        PNFL: "ПИНФЛ",
        REGISTRATION_DATE: "Дата регистрации",
        SEX: "Пол",
      },
    },

    ERROR_LIST: {
      NOT_FOUND: "Запрошенная информация не найдена!",
      PINFL_NOT_VALID: "Неправильный ПИНФЛ!",
      CADASTRAL_NUMBER_ERROR:
        "Этот кадастровый номер не относится к области или району абонента!",
      POPUP_RESTRICTED:
        "Вам не разрешено открывать страницу печати в вашем браузере!",
      SERVER_ERROR: "Ошибка сервера!",
      ACCESS_DENIED: "Доступ ограничен!",
      BAD_REQUEST: "Неправильный запрос!",
      FIELD_IS_REQUIRED: "Поля не должна быть пустым",
      INVALID_EMAIL_ADDRESS: "Неверный адрес электронной почты",
      MINLENGTH_REQUIRED:
        "Поля должна иметь не менее {{requiredLength}} символов",
      MAXLENGTH_REQUIRED:
        "Поля должна иметь не более {{requiredLength}} символов",
      MIN_REQUIRED: "Значение не должно быть меньше {{min}}.",
      MAX_REQUIRED: "Значение не должно быть больше {{max}}",
      PATTERN_REQUIRED:
        "Поля должна содержить этих символов {{requiredPattern}}",
      BETWEEN: "Значения должна быт между {{x}} и {{y}}",
      INVALID_LENGTH: "INN должна быт между {{minLength}} и {{maxLength}}",
      IP_NOT_VALID: "Указан неправильный IP-адрес",
      CONFIRM_PASSWORD_ERROR: "Произошла ошибка при подтверждении пароля!",
      NUMERIC: "В этом поле пишутся только цифры!",
      LOWERCASE: "В этом поле пишутся только строчные буквы!",
      UPPERCASE: "В этом поле пишутся только заглавные буквы!",
      MAX_FILE_SIZE: "Размер файла не должен превышать {{size}}",
      ONE_UPPERCASE: "Должен быть хотя бы 1 заглавную букву",
      ONE_LOWERCASE: "Должен быть хотя бы 1 строчную букву",
      ONE_NUMBER: "Должно быть хотя бы 1 число",
      ONE_SPECIAL_CHARACTER: "Должен быть хотя бы 1 символ",
    },
    CHART_PAYMENTS: {
      TITLE: "Денежные выплаты",
      ELECTRON: "Электрон",
      MUNIS: "МУНИС",
      PAYMEN_1034: "1031",
      CASH: "Наличные",
      MOBILE: "Мобил",
      PAID_RESIDENTS: "Количество транзакций",
      RECEITTS: "Динамика доходов",
    },
    FILE_INPUT: {
      BROWSE: "Выбирать...",
      NO_FILE_SELECTED: "Файл не выбран.",
      DOWNLOAD_ERROR_MESSAGE: "Произошла ошибка при загрузке файла",
    },
    POLYGON: {
      TABLE_HEADERS: {
        NAME: "Название организации",
        DISTRICT: "Район",
        BANK: "Банк",
        BANK_OKED: "Банк ОКЭД",
        BANK_ACCOUNT: "Банковский счет",
        ADDRESS: "Адрес",

        START_DATE: "Дата начала",
        END_DATE: "Дата завершения",
        CONTRACT_NUMBER: "Номер контракта",
      },
      EDIT_TITLE: "Редактировать полигон",
      POLYGONS_INFO: {
        ADD_POLYGON: {
          ADD_MODAL_TITLE: "Добавьте полигон",
        },
        DELETE_POLYGON: {
          DELETE_MODAL_TITLE: "Удаление полигона",
          DELETE_TEXT: "Вы действительно хотите удалить многоугольник?",
        },
        LOCATION: "Расположение",
        BANK_INFO: "Реквизиты банка",
        BANK_NAME: "Название банка",
        BANK_OKED: "Банк ОКЭД",
        BANK_MFO: "Банк МФО",
        DESCRIPTION: "Комментарий",
        POLYGON_NUMBER: "Номер полигона",
        START_DATE: "Дата начала",
        END_DATE: "Дата завершения",
        CONTRACT_NUMBER: "Номер контракта",
      },
      POLYGON_AREA: "Площадь полигона (м²)",
      POLYGON_NUMBER: "Номер полигона",
      TAB_NAME_1: "Полигон и банковские реквизиты",
      TAB_NAME_2: "Расположение полигона",
      ADD_MODAL_TITLE: "Добавление лицензии на свалку",
      EDIT_MODAL_TITLE:
        "Редактировать информацию о лицензированной организации",
      DELETE_MODAL_TITLE: "Прекращение действия лицензии на свалку",
      LICENSE_START: "Дата начала лицензирования",
      LICENSE_END: "Срок действия лицензии",
      LICENSE_NUMBER: "Номер лицензии",
      ALERTED_TEXT: "Не правильно дана дата начинания и заканчивания лицензии",
      DELETE_TEXT:
        "Вы действительно  хотите удалить лицензию полигон из системы?",
      BANK_ACCOUNT: "Банковский счет",
      DISTRICT_CITY: "Район / Город",
      POLYGON_SEARCH: "Название полигона",
      TABS: {
        ORGANIZATIONS: "Организации",
        COMPANY: {
          COMPANY: "Предприятии",
          COMPANY_ADD: "Прикрепить компанию",
          POLYGON_ADD: "Добавить в полигон",
          COMPANY_DELETE: "Удалить компанию",
          CONFIRM_MULTIPLE_TEXT:
            "Вы действительно хотите прикрепить выбранные компании к полигону?",
          CONFIRM_TITLE: "Прикрепление выбранных компаний к полигону",
          DELETE_TITLE: "Удаление выбранных предприятий со свалки",
          DELETE_MULTIPLE_TEXT:
            "Вы действительно хотите удалить выбранные объекты со свалки?",
          SELECTED_COMPANY: "Избранные компании",
        },
        TARIFFS: {
          WARNING_TEXT: "Зеленые линии обозначают текущую тарифную активность!",
          COMPANY: "Компания",
          POLYGON: "Полигон",
          ORGANIZATION: "Организация",
          COMPANY_TARIFF: "Тариф компании",
          COMPANY_TARIFF_M3: "Тариф компании (м³)",
          COMPANY_TARIFF_KG: "Тариф компании (кг)",
          POLYGON_TARIFF: "Тариф Полигон",
          POLYGON_TARIFF_M3: "Тариф Полигон (м³)",
          POLYGON_TARIFF_KG: "Тариф Полигон (кг)",
          ORGANIZATION_TARIFF: "Тариф организации",
          ORGANIZATION_TARIFF_M3: "Тариф организации (м³)",
          ORGANIZATION_TARIFF_KG: "Тариф организации (кг)",
          TABLE_HEADERS: {
            REGIONS: "Регионы",
            NAME: "Название",
            RATE: "Цена",
            DESCRIPTION: "Комментарий",
            START_DATE: "Начало",
            END_DATE: "Конец",
            COMMENT: "Комментарий",
          },
          ADD_TARIFF: {
            ADD_BUTTON: "Добавить тариф",
            ADD_MODAL_TITLE: "Добавить тариф",
          },
          EDIT_TARIFF: {
            EDIT_BUTTON: "Редактировать тариф",
            EDIT_MODAL_TITLE: "Редактировать тариф",
          },
          DELETE_TARIFF: {
            DELETE_BUTTON: "Удаление тарифа",
            TEXT: "Вы действительно хотите удалить этот тариф?",
          },
          TARIFF_RATE: {
            SOLID_WASTE_M3: "Твердые бытовые отходы 1 м³ (сум)",
            SOLID_WASTE_KG: "Твердые бытовые отходы 1 кг (сум)",
            LIQUID_WASTE_M3: "Жидкие бытовые отходы 1 м³ (сум)",
            LIQUID_WASTE_KG: "Жидкие бытовые отходы 1 кг (сум)",
            CONSTRUCTION_WASTE_M3: "Строительные и другие отходы 1 м³ (сум)",
            CONSTRUCTION_WASTE_KG: "Строительные и другие отходы 1 кг (сум)",
          },
          GARBAGE_TYPE: {
            SOLID_WASTE: "Твердые бытовые отходы",
            LIQUID_WASTE: "Жидкие бытовые отходы ",
            CONSTRUCTION_WASTE: "Строительные и другие отходы",
          },
        },
        VISITS: {
          REGISTRATION: "Регистрация",
          TABLE_HEADERS_VISITS: {
            COMPANY_NAME: "Название",
            AUTOMOBILE_NUMBER: "Номер автомобиля",
            AUTOMOBILE_MODEL: "Модель автомобиля",
            VISIT_DATE: "Дата визита",
            M_KUB: "Объем отходов (м³)",
            VISIT_SUM: "Сумма визита (сум)",
          },
          TABLE_POLYGON_AVTO: {
            ORGANIZATION_NAME: "Название организации",
            AUTOMOBILE_NUMBER: "Номер автомобиля",
            AUTOMOBILE_MODEL: "Модель автомобиля",
            VISIT_DATE: "Дата визита",
            M_KUB: "Объем отходов (м³)",
            VISIT_SUM: "Сумма визита (сум)",
          },
          REGISTER_VISIT: "Регистрация на посещение",
          VISITS: "Визит",
          COMPANY_NAME: "Название компании",
          ORGANIZATION_NAME: "Название организации",
          POLYGON_NAME: "Название полигон",
          AUTOMOBILE_NUMBER_AND_MODEL: "Номер и модель автомобиля",
          VISIT_DATE: "Дата визита",
          M_KUB: "Объем отходов (м³)",
          AUTOMOBILE_NUMBER_SELECT: "Выберите номер автомобиля",
          WASTE_CATEGORY: "Категория отходов",
          AUTOMOBILE_NUMBER: "Номер автомобиля",
          TARIFF: "Тариф (сум)",
          RATE: "Тариф (сум)",
          VISIT_SUM: "Сумма визита (сум)",
          WASTE_SELECTED: "Выберите тип отходов",
          WARNING:
            "Сумма данного визита рассчитывается исходя из полной вместимости автомобиля!",
        },
        CARS: {
          AUTOMOBILES: "Техники",
          ADD_TECHNIQUE: "Добавить технику",
          UPDATE_TECHNIQUE: "Редактирование техники",
          DELETE_TECHNIQUE: "Удаление техники",
          AUTOMOBILE_NUMBER: "Номер автомобиля",
          AUTOMOBILE_MODEL: "Модель автомобиля",
          DESCRIPTION: "Комментарий",
          M_KUB: "Объем отходов (м³)",
          DELETE_TEXT:
            "Вы действительно хотите удалить выбранную технику из системы?",
        },
      },
      COMPANY: {
        DIRECTOR_FIO: "Ф.И.О директора",
        BANK_NAME: "Название банка",
        COMPANY_ACCOUNT_NUMBER: "Номер счета компании",
        BANK_MFO: "Банк МФО",
        BANK_OKED: "Банк ОКЭД",
        INN: "ИНН",
        PHONE_NUMBER: "Телефон",
        POLYGON_ATTACHMENT: "Прикрепление / отсоединение",
        POLYGON_ATTACHMENT_TITLE: "Прикрепление и отсоединение полигонов.",
        ATTACHMENT: "Прикреплять",
        POLYGON: "Полигон",
        CARS: "Техники",
        ADDRESS: "Адрес",
      },
      STATISTICS: {
        BY_REGIONS: {
          TITLE:
            "Количество посещений полигонов зависит от количества провинций",
          TITLE_SUM: "Сумма посещений полигонов в разрезе провинций",
          TITLE_COUNT: "Количество посещений полигонов в разрезе провинций",
          VISIT_COUNT: "Количество посещений",
          VISIT_SUM: "Сумма посещений",
        },
        BY_DISTRICTS: {
          TITLE: "Количество и сумма посещений палигонов в разрезе районов",
        },
        STAT: {
          AUTOMOBILE_COUNT: "Количество автомобилей",
          POLYGON_COUNT: "Количество полигонов",
          LICENSED_ORGANIZATION_COUNT: "Количество лицензированных организаций",
          CURRENT_PERIOD_VISIT_COUNT: "Количество посещений в текущем периоде",
          CURRENT_PERIOD_VISIT_SUM: "Сумма посещений в текущем периоде",
          NUMBER_POLYGON_CARS: "Количество машин на свалке",
          NUMBER_COMPANY: "Количество предприятий",
        },
        POLYGONS_MONTHLY: {
          TITLE: "Количество и сумма посещений полигонов",
          TITLE_SUM: "Сумма посещений полигонов",
          TITLE_COUNT: "Количество посещений полигонов",
        },
      },
      REPORTS: {
        REPORT_TITLE: "Отчет о визитах",
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Название",
          N_SALDO: "Начальное сальдо",
          K_SALDO: "Кон.сальдо",
          ACCRUAL: "Начисление",
          PAYMENT: "Платежи",
        },
        VISITS: "Визит",
        ORGANIZATIONS: "Организации",
        COMPANIES: "Компаний",
        POLYGONS: "Полигоны",
      },
      EMPLOYEES: {
        POLYGON_NAME: "Название полигон",
        POLYGON_NAMES: "Название полигона",
        POSITIONS: "Должность",
        PNFL: "ПИНФЛ",
        PASSPORT_NUMBER: "Номер паспорта",
        PHOTO: "Загрузка фотографии сотрудника",
        LAST_NAME: "Фамилия",
        FIRST_NAME: "Имя",
        EMAIL: "Электронная почта",
        PHONE_NUMBER: "Телефон",
        LABEL_LOGIN: "Логин",
        LABEL_PASSWORD: "Пароль",
        CONFIRM_PASSWORD: "Подтвердите пароль",
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          POLYGON_NAME: "Название полигон",
          FIO: "Ф.И.О",
          JOB_TITLE: "Должность",
          EMAIL: "Э-почта",
          PHONE: "Телефон",
          LOGIN: "Логин",
          ATTACHED_FILE: "Прикрепленный файл",
          STATUS: "Статус",
          ADDRESS: "Адрес",
          ROLE_DESCRIPTION: "Описание роли",
          COMMENT: "Комментарий",
        },
      },

      GARBAGE_TYPE: {
        SOLID_WASTE: "Твердые бытовые отходы",
        LIQUID_WASTE: "Жидкие бытовые отходы ",
        CONSTRUCTION_WASTE: "Строительные и другие отходы",
      },
    },
    POLYGON_AUTO: {
      TABLE_HEADERS: {
        AUTOMOBILE_NUMBER: "Номер автомобиля",
      },
      DESCRIPTION: "Комментарий",
      ADD_MODAL_TITLE: "Добавление лицензии на автомобиль",
      EDIT_MODAL_TITLE: "Редактировать лицензию  на автомобиль",
      DELETE_MODAL_TITLE: "Прекращение действия лицензии на автомобиль",
      DELETE_TEXT:
        "Вы действительно  хотите удалить лицензию автомобиль из системы?",
      CONFIRM_TITLE: "Добавить выбранные компании на свалку",
    },
    POLYGON_LICENSE_ORGANIZATION: {
      START_DATE: "Дата начала контракта",
      END_DATE: "Дата окончания контракта",
      POLYGON_LICENSE_ORGANIZATION: "Лицензионные организации",
      ADD_BUTTON: "Объединение лицензированных организаций",
      DELETE_BUTTON: "Удаление лицензированного лица",
      CONFIRM_TITLE:
        "Добавление выбранных лицензированных организаций в полигон",
      CONFIRM_TEXT:
        "Вы действительно хотите добавить выбранные лицензированные объекты в полигон?",
      POLYGON_LICENSE_ORGANIZATION_INFO: {
        ADDRESS: "Адрес",
      },
      CONFIRMATION_SAVING_POLYGON: {
        POLYGONS: "Полигоны",
        POLYGON_ATTACHMENT: "Прикрепить полигон",
        CONFIRM: "Прикреплять",
        SELECTED_POLYGON: "Выбранные полигоны",
        CONFIRM_TITLE: "Прикрепить выбранные полигоны",
        CONFIRM_TEXT: "Вы действительно хотите прикрепить выбранные полигоны?",
      },
      POLYGONS: "Полигоны",
      TECHNIQUES: "Техники",
      ADD_TECHNIQUE: "Добавить технику",
      TITLE_UPDATE: "Редактирование техники",
      TITLE_DELETE: "Удаление техники",
      M_KUB: "Объем отходов (м³)",
      DELETE_MODAL_SUBTITLE:
        "Вы действительно хотите удалить выбранную технику из системы?",
      CONTRACTS: {
        CONTRACTS: "Контракты",
        ADD_CONTRACT: "Добавить контракт",
        CONTRACT_NO: "Номер контракта",
        CONTRACT_START_DATE: "Дата начала контракта",
        CONTRACT_END_DATE: "Дата окончания контракта",
        CONTRACT_FILE: "Файл контракта",
        CONTRACT_TEM: "Срок действия контракта",
        MODAL: {
          DELETE_MODAL: "Удалить контракт",
          DELETE_MODAL_SUBTITLE: "Вы действительно хотите удалить эту сделку?",
        },
      },
    },
    primeng: {
      firstDayOfWeek: 1,
      dayNames: [
        "Воскресенье",
        "Понедельник",
        "Вторник",
        "Среда",
        "Четверг",
        "Пятница",
        "Суббота",
      ],
      dayNamesShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      monthNames: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
      monthNamesShort: [
        "Янв",
        "Фев",
        "Мар",
        "Апр",
        "Май",
        "Июн",
        "Июл",
        "Авг",
        "Сен",
        "Окт",
        "Ноя",
        "Дек",
      ],
      today: "Сегодня",
      clear: "Очистить",
    },
    DAY_NAMES: {
      "1": "Понедельник",
      "2": "Вторник",
      "3": "Среда",
      "4": "Четверг",
      "5": "Пятница",
      "6": "Суббота",
      "7": "Воскресенье",
    },
    DAY_NAMES_KEY: {
      MONDAY: "Понедельник",
      TUESDAY: "Вторник",
      WEDNESDAY: "Среда",
      THURSDAY: "Четверг",
      FRIDAY: "Пятница",
      SATURDAY: "Суббота",
      SUNDAY: "Воскресенье",
    },
  },
};
